webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/2l4S9H/%3F1737196287630&title=Deuteronomy&summary=This%20milestone%20commentary%20by%20Jack%20Lundbom%20is%20intended%20for%20any%20and%20all%20readers%20who%20want%20to%20better%20know%20and%20understand%20the%20key%20Pentateuchal%20book%20of%20Deuteronomy%2C%20which%20has%20had%20a%20huge%20influence%20on%20both%20Judaism%20and%20Christianity%20over%20the%20centuries.%20For%20Jews%20Deu&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/2l4S9H/%3F1737196287630",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=This%20milestone%20commentary%20by%20Jack%20Lundbom%20is%20intended%20for%20any%20and%20all%20readers%20who%20want%20to%20better%20know%20and%20understand%20the%20key%20Pentateuchal%20book%20o%0Dhttps://textcafe.co/books/2l4S9H/%3F1737196287630&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/2l4S9H/%3F1737196287630&posttype=link&caption=This%20milestone%20commentary%20by%20Jack%20Lundbom%20is%20intended%20for%20any%20and%20all%20readers%20who%20want%20to%20better%20know%20and%20understand%20the%20key%20Pentateuchal%20book%20of%20Deuteronomy%2C%20which%20has%20had%20a%20huge%20influence%20on%20both%20Judaism%20and%20Christianity%20over%20the%20centuries.%20For%20Jews%20Deu",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/2l4S9H/%3F1737196287630&description=This%20milestone%20commentary%20by%20Jack%20Lundbom%20is%20intended%20for%20any%20and%20all%20readers%20who%20want%20to%20better%20know%20and%20understand%20the%20key%20Pentateuchal%20book%20of%20Deuteronomy%2C%20which%20has%20had%20a%20huge%20influence%20on%20both%20Judaism%20and%20Christianity%20over%20the%20centuries.%20For%20Jews%20Deu&media=https://textcafe.co/books/2l4S9H/tc-custom/9781467439084.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781467439084&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=hTuiEAAAQBAJ&amp;rdid=book-hTuiEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467439084').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/2l4S9H/tc-custom/9781467439084.jpg?1737196287630',
        alt: 'Deuteronomy'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Preface", "007_Abbreviations", "008_Introduction", "008_Introduction1", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/2l4S9H/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_TitlePage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_TitlePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_TitlePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_008_Introduction1__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_008_Introduction1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_008_Introduction1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_009_Bibliography__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_009_Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_009_Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_009_Bibliography1__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_009_Bibliography1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_009_Bibliography1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_011_Chapter01__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_011_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_011_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02a__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Chapter03__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_013_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_015_Chapter05__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_015_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_015_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_015_Chapter05a__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_015_Chapter05a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_015_Chapter05a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_016_Chapter06a__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_016_Chapter06a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_016_Chapter06a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_016_Chapter06b__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_016_Chapter06b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_016_Chapter06b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_016_Chapter06c__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_016_Chapter06c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_016_Chapter06c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_016_Chapter06d__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_016_Chapter06d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_016_Chapter06d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_016_Chapter06e__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_016_Chapter06e___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_016_Chapter06e__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_017_Chapter07__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_017_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_017_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_018_Chapter08__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_018_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_018_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_019_Chapter09__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_019_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_019_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_020_Chapter10__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_020_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_020_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_020_Chapter10a__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_020_Chapter10a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_020_Chapter10a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_021_Appendix__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_021_Appendix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_021_Appendix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_last__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_last__);
/*jshint esversion: 6 */





































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Preface",
    "name": "006_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default.a
  }, {
    "path": "/007_Abbreviations",
    "name": "007_Abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations___default.a
  }, {
    "path": "/008_Introduction",
    "name": "008_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction___default.a
  }, {
    "path": "/008_Introduction1",
    "name": "008_Introduction1",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_008_Introduction1___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_34__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2l4S9H/tc-custom/9781467439084.jpg?1737196287630",
      "alt": "This image is the cover for the book Deuteronomy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deuteronomy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This milestone commentary by Jack Lundbom is intended for any and all readers who want to better know and understand the key Pentateuchal book of Deuteronomy, which has had a huge influence on both Judaism and Christianity over the centuries. For Jews Deuteronomy contains the Decalogue and the "), _c('i', [_vm._v("Shema")]), _vm._v(" -- “Hear, O Israel, the Lord our God is one” (6:4) -- supplemented by a code of primal legislation."), _c('br'), _c('br'), _vm._v("Deuteronomy is much cited in the New Testament and has come to occupy an important place in the life and doctrine of the Christian church. It lifts up important wisdom themes such as humane treatment and benevolence to the poor and needy and is rich in theology, calling repeatedly on Israel to reject other gods and worship the Lord alone as holy."), _c('br'), _c('br'), _vm._v("Besides drawing on language, archaeology, and comparative Near Eastern material, Lundbom’s commentary employs rhetorical criticism in explicating the biblical text. Lundbom also cites later Jewish interpretation of the book of Deuteronomy and makes numerous New Testament connections. An appendix contains all citations of Deuteronomy in the New Testament.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack R. Lundbom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jack R. Lundbom is a life member at Clare Hall, CambridgeUniversity. Among his prior publications are JeremiahCloser Up and The Hebrew Prophets: AnIntroduction.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#pt-1"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-1"
    }
  }, [_c('strong', [_vm._v("Name and Canonicity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-2"
    }
  }, [_c('strong', [_vm._v("Text and Versions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-3"
    }
  }, [_c('strong', [_vm._v("Qumran Scrolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-4"
    }
  }, [_c('strong', [_vm._v("Paragraph Divisions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-5"
    }
  }, [_c('strong', [_vm._v("Deuteronomy Papyri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-6"
    }
  }, [_c('strong', [_vm._v("Date, Composition, and Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-1"
    }
  }, [_c('em', [_vm._v("The Josianic Reform")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-2"
    }
  }, [_c('em', [_vm._v("The Quest for")]), _vm._v(" Urdeuteronomium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-3"
    }
  }, [_c('em', [_vm._v("Northern Provenance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-4"
    }
  }, [_c('em', [_vm._v("Hezekiah’s Reform")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-5"
    }
  }, [_c('em', [_vm._v("A New Quest for")]), _vm._v(" Urdeuteronomium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-6"
    }
  }, [_c('em', [_vm._v("The Question of Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-7"
    }
  }, [_c('strong', [_vm._v("Ancient Near Eastern Treaties")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-8"
    }
  }, [_c('strong', [_vm._v("Ancient Hebrew Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-7"
    }
  }, [_c('em', [_vm._v("Rhetorical Prose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-8"
    }
  }, [_c('em', [_vm._v("Preached Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-9"
    }
  }, [_c('em', [_vm._v("Rhetoric and Composition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-9"
    }
  }, [_c('strong', [_vm._v("The Deuteronomic Law Code")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-10"
    }
  }, [_c('em', [_vm._v("Earlier Biblical Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-11"
    }
  }, [_c('em', [_vm._v("Later Biblical Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-12"
    }
  }, [_c('em', [_vm._v("Ancient Near Eastern Law Codes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-10"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and the Prophets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-13"
    }
  }, [_c('em', [_vm._v("Amos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-14"
    }
  }, [_c('em', [_vm._v("Hosea")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-15"
    }
  }, [_c('em', [_vm._v("Micah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-16"
    }
  }, [_c('em', [_vm._v("Isaiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-17"
    }
  }, [_c('em', [_vm._v("Jeremiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-11"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-18"
    }
  }, [_c('em', [_vm._v("Humane Treatment and Benevolence to the Poor and Needy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-19"
    }
  }, [_c('em', [_vm._v("Teaching of Children")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-20"
    }
  }, [_c('em', [_vm._v("Blessing: Life, Goodness, and Longevity in the Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-21"
    }
  }, [_c('em', [_vm._v("Avoidance of Shame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-22"
    }
  }, [_c('em', [_vm._v("Discerning False from True Prophets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-12"
    }
  }, [_c('strong', [_vm._v("Theological Ideas in Deuteronomy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-23"
    }
  }, [_c('em', [_vm._v("The Name of Yahweh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-24"
    }
  }, [_c('em', [_vm._v("Yahweh the One and Only God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-25"
    }
  }, [_c('em', [_vm._v("Yahweh a Holy God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-26"
    }
  }, [_c('em', [_vm._v("Yahweh Is Heard but Not Seen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-27"
    }
  }, [_c('em', [_vm._v("Yahweh a God of Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-28"
    }
  }, [_c('em', [_vm._v("Yahweh a God Faithful to His Promises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-29"
    }
  }, [_c('em', [_vm._v("Yahweh a Righteous God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-30"
    }
  }, [_c('em', [_vm._v("Yahweh an Impartial Judge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-31"
    }
  }, [_c('em', [_vm._v("Israel a Holy People")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-32"
    }
  }, [_c('em', [_vm._v("The Election of Israel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-33"
    }
  }, [_c('em', [_vm._v("The Covenant at Horeb (Sinai)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-34"
    }
  }, [_c('em', [_vm._v("The Land as a Gift and Tenure in the Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-35"
    }
  }, [_c('em', [_vm._v("Holy War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-36"
    }
  }, [_c('em', [_vm._v("Divine Blessing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-37"
    }
  }, [_c('em', [_vm._v("Covenant Obligations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-1"
    }
  }, [_vm._v("Doing the Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-2"
    }
  }, [_vm._v("Love to Yahweh and to Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-3"
    }
  }, [_vm._v("Fear of Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-4"
    }
  }, [_vm._v("Walking in Yahweh’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-5"
    }
  }, [_vm._v("Serving Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-6"
    }
  }, [_vm._v("Gratitude to Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-13"
    }
  }, [_c('strong', [_vm._v("The Book of Deuteronomy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-38"
    }
  }, [_c('em', [_vm._v("The First Edition (1–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-7"
    }
  }, [_vm._v("Prologue (1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-8"
    }
  }, [_vm._v("The Covenant at Horeb (5–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-9"
    }
  }, [_vm._v("The Deuteronomic Code (12–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-10"
    }
  }, [_vm._v("Blessings and Curses (27–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-39"
    }
  }, [_c('em', [_vm._v("First Supplement (29–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-40"
    }
  }, [_c('em', [_vm._v("Second Supplement (31–34)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-14"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and the New Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-41"
    }
  }, [_c('em', [_vm._v("The Synoptic Gospels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-42"
    }
  }, [_c('em', [_vm._v("The Gospel of John and the Johannine Epistles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-43"
    }
  }, [_c('em', [_vm._v("Acts of the Apostles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-44"
    }
  }, [_c('em', [_vm._v("Pauline and Deutero-Pauline Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-45"
    }
  }, [_c('em', [_vm._v("The Epistle of James")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-46"
    }
  }, [_c('em', [_vm._v("The Epistle to the Hebrews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-47"
    }
  }, [_c('em', [_vm._v("Revelation of Saint John")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Text and Reference Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Commentaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Books, Monographs, and Articles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/011_Chapter01#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TRANSLATION, NOTES, AND COMMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Superscription to the Prologue and First Edition")])]), _vm._v(" ("), _c('strong', [_vm._v("1:1–5")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("II."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Prologue to the Deuteronomic Law")])]), _vm._v(" ("), _c('strong', [_vm._v("1:6–4:40")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Land Is Set Before You (1:6–46)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pass Peaceably through Seir (2:1–8a)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pass Peaceably by Moab (2:8b–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Do Not Go near Ammon (2:16–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Have Given Sihon into Your Hand (2:24–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Have Also Given Og into Your Hand (3:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Apportionment of Transjordan Land (3:12–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Focus Now Is Beyond the Jordan (3:18–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses Asks to Cross the Jordan (3:23–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Listen to the Statutes and Ordinances and Do Them (4:1–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not the Horeb Revelation (4:1–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Will Happen If You Do Forget (4:25–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("III."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Refuge Cities in the Transjordan")])]), _vm._v(" ("), _c('strong', [_vm._v("4:41–43")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Subscription to the Prologue")])]), _vm._v(" ("), _c('strong', [_vm._v("4:44–49")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Covenant at Horeb")])]), _vm._v(" ("), _c('strong', [_vm._v("5–11")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Law and Covenant (5:1–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("This Covenant Was with You! (5:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Ten Words (5:6–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses: Mediator for Subsequent Laws (5:22–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Fear Yahweh and Keep the Commandment (6:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Liturgical Injunction (6:4–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not, Test Not (6:10–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not Yahweh (6:10–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Test Not Yahweh (6:16–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Mean These Commandments? (6:20–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Are a Holy People (7:1–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Clear Away Large and Mighty Nations (7:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Chose You Because He Loved You (7:7–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Keep Covenant and Love You (7:12–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Defeat the Larger Nations (7:17–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Yahweh and His Testing (8:1–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Are a Rebellious People (9:1–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Clear Away Larger and Mightier Nations (9:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conquest Due to Canaan’s Wickedness and Oath to the Fathers (9:4–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Your Wilderness Rebellion (9:7–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember the Calf at Horeb and Moses’ Intercession (9:7–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Taberah, Massah, and Kibroth-hattaavah (9:22–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ First Intercession on the Mountain (9:25–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("With the Covenant Renewed the Journey Can Continue (10:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses Makes New Tablets (10:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Journey to Moserah Where Aaron Died (10:6–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Levites to Carry the Ark (10:8–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Intercession Successful; Rise Up and Resume Your Journey (10:10–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Fear, Walk Straight, Love, and Serve Yahweh (10:12–11:17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Circumcise Yourself to Yahweh (10:12–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Consider Yahweh’s Discipline (11:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Promised Land Will Have Rain from Heaven (11:10–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("But Rain Hinges on Keeping the Commandments (11:13–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Liturgical Injunction (11:18–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Consequences of Obedience and Disobedience (11:22–32)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Very Careful with All This Commandment (11:22–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Blessing and the Curse (11:26–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Careful to Do the Statutes and Ordinances (11:29–32)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Deuteronomic Code")])]), _vm._v(" ("), _c('strong', [_vm._v("12–26")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Central Sanctuary (12:1–13:1[12:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Destroy All Places of Their Gods (12:1–4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Tithes and Offerings (12:5–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings at the Central Sanctuary (12:5–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Once Again: Offerings at the Central Sanctuary (12:10–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On the Clean and Unclean (12:15–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Nonsacrificial Meat in the Towns (12:15–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings at the Central Sanctuary (12:17–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Nonsacrificial Meat in the Towns (12:20–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holy Offerings at the Central Sanctuary (12:26–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Seek Not Their Gods (12:29–13:1[12:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 1: C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRALIZED")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSHIP IN THE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORMS OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EZEKIAH AND")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSIAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Testing for Faithfulness (13:2–19[1–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Prophets and Dreamers (13:2–6[1–5])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Family and Friends (13:7–12[6–11])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Worthless Men (13:13–19[12–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Israel a Holy People to Yahweh (14:1–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holiness in Lamenting (14:1–2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Animals (14:3–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Waterfowl (14:9–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Winged Creatures (14:11–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holiness in Eating and Food Preparation (14:21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithes, Remissions, and Offerings (14:22–15:23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithing Year by Year (14:22–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithing Every Three Years (14:28–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remissions Every Seven Years (15:1–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Debt Remission (15:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remission of Hebrew Slaves (15:12–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Firstborn Gifts Year by Year (15:19–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Keeping the Feasts (16:1–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Passover (16:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Weeks (16:9–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Booths (16:13–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Office Holders in Israel (16:18–18:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Judge and Matters of Judgment (16:18–17:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Appointing Judges and Officials (16:18–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Regarding Abominations (16:21–17:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Judgment for Covenant Transgressors (17:2–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Extraordinary Cases to the Priests and the Judge (17:8–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Sort of King for Israel? (17:14–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rights of the Levitical Priests (18:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Levites’ Inheritance Is Yahweh (18:1–2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings Due the Levites (18:3–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Altar Privileges for All Levites (18:6–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("How May We Know the Word of Yahweh? (18:9–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Practitioners of the Secret Arts (18:9–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Testing for the False Yahweh Prophet (18:15–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Judicial Procedure (19:1–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Cities of Refuge (19:1–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Moving of Boundary Markers (19:14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Regarding Witnesses (19:15–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When You Go to War (20:1–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Choosing Warriors (20:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conduct of Holy War (20:10–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Respect Fruit Trees in a Siege! (20:19–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Expiation for an Unsolved Murder (21:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Marriage to a Woman War Captive (21:10–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rights of the Firstborn (21:15–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Death for Rebellious Sons (21:18–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Hanged Criminals (21:22–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Miscellaneous Laws (22:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Restoring Lost Property (22:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Lifting Up Fallen Animals (22:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Wearing the Apparel of the Opposite Sex (22:5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sparing Mother Birds (22:6–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Parapets on Roofs (22:8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("More Miscellaneous Laws (22:9–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Mixing of Seeds, Yoked Animals, and Cloths (22:9–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Tassel Exception (22:12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Chastity and Marriage (22:13–23:1[22:30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Unchaste Brides (22:13–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with Another Married Woman (22:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Betrothed Girl in the City (22:23–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Betrothed Girl in the Country (22:25–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with an Unbetrothed Girl (22:28–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Father’s Wife (23:1[22:30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Purity and Cleanliness (23:2–19[1–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Purity within Yahweh’s Assembly (23:2–9[1–8])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blemished Men Excluded (23:2–3[1–2])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ammonites and Moabites Excluded (23:4–7[3–6])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Edomites and Egyptians Not Abominations (23:8–9[7–8])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Purity and Cleanliness in the Camp (23:10–15[9–14])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Hospitality to Runaway Slaves (23:16–17[15–16])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Holy Prostitutes! (23:18–19[17–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Laws on Loans, Vows, and Theft (23:20–26[19–25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Loans to Brothers Interest-Free (23:20–21[19–20])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pay Your Vows Promptly! (23:22–24[21–23])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Crop Stealing! (23:25–26[24–25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Humane Laws (24:1–25:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Marriage, Divorce, and Remarriage (24:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Divorcee May Not Return to First Husband (24:1–4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Newlywed War Deferment (24:5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4a"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 2: D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVORCE WITHIN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM AND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIANITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pledges and Scale Disease (24:6–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Millstones as Pledges (24:6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Stealing of Persons (24:7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Warning about Scale Disease (24:8–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Kindness in Exacting Pledges (24:10–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Sleeping in a Poor Man’s Pledge (24:12–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Justice and Benevolence to the Needy (24:14–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Paying Hired Laborers (24:14–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Each in His Own Sin Shall Die (24:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Perversion of Judgment to the Needy (24:17–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Needy to Get Gleaning Rights (24:19–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Limit on Flogging (25:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Muzzle on a Threshing Ox (25:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Miscellaneous Laws (25:5–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Levirate Marriage (25:5–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Wives Interfering in a Fight (25:11–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Just Weights and Measures (25:13–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Wipe Out the Remembrance of Amalek! (25:17–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rituals at the Central Sanctuary (26:1–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ritual of the Firstfruits (26:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ritual of the Third-year Tithe (26:12–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Careful and Do These Commands (26:16–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blessings and Curses")])]), _vm._v(" ("), _c('strong', [_vm._v("27–28")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Covenant Renewal at Shechem (27:1–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh’s Law on Large Stones (27:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Today You Have Become Yahweh’s People (27:9–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Let the Tribes Ascend the Mountains (27:11–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Let the People Say “Amen” (27:14–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blessings and Curses of the Deuteronomic Covenant (28:1–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("If You Obey the Covenant (28:1–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Six Blessings (28:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Victory in Battle, Prosperity, World Respect (28:7–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("If You Do Not Obey the Covenant (28:15–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Six Curses (28:15–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Disease, Famine, Defeat in Battle (28:20–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Incurable Disease, Madness, Displacement (28:27–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Crop Failure, Impoverishment, Dependent Status (28:38–46)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Curses of the Siege (28:47–57)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Egypt Revisited! (28:58–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap4"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VIII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Subscription to the First Edition")])]), _vm._v(" ("), _c('strong', [_vm._v("28:69")]), _vm._v("["), _c('strong', [_vm._v("29:1")]), _vm._v("])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IX."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("First Supplement")])]), _vm._v(" ("), _c('strong', [_vm._v("29–30")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Covenant Is Something You Do (29:1–8[2–9])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Enter into the Sworn Covenant! (29:9–28[10–29])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When the Blessings and Curses Come upon You (30:1–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Word Is Very Near You (30:11–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Two Ways: Life and Death (30:15–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("X."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Second Supplement")])]), _vm._v(" ("), _c('strong', [_vm._v("31–34")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Death Draws Near (31:1–32:52)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Cannot Cross Over This Jordan (31:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua to Head the Army, the Law Entrusted to the Levites and Elders (31:7–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua Receives Charge from Moses (31:7–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Public Reading of the Law Every Seven Years! (31:9–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Addresses Moses and Joshua (31:14–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua to Receive His Charge (31:14–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses to Write a Song (31:16–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Charge to Joshua (31:23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Parting Words about the Song (31:24–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Song of Moses (32:1–43)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 3: H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESEARCH INTO THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG OF")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Take These Words to Heart (32:44–47)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ascend this Mountain (32:48–52)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Departure (33:1–34:12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Blessing of Moses (33:1–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Death and Burial (34:1–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APPENDIX")]), _vm._v(": Citations of Deuteronomy in the New Testament")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("In James Michener’s novel "), _c('em', [_vm._v("The Source")]), _vm._v(" (Michener 1965), an American archaeologist in charge of excavating Tell Makor, Harvard-educated Dr. Cullinane of Chicago, is told by his Israeli colleague, Dr. Ilan Eliav, that if he really wants to understand the Jewish people, he should read Deuteronomy five times. The American Irish Catholic questions whether the book is worth five readings. Dr. Eliav answers:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Deuteronomy is so real to me that I feel as if my immediate ancestors—say, my great-grandfather with desert dust still on his clothes—came down that valley with goats and donkeys and stumbled onto this spot.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("So the American began reading—first in the Authorized King James Version, and last in the Hebrew Bible—and found that not only did he understand the Jews and Judaism better, but also the Christian faith in which he had been reared. Michener writes:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("… as his eyes ran down the columns they caught phrases and sentences which he had once vaguely supposed to be from the New Testament: “Man doth not live by bread only” … and “Thou shalt love the Lord thy God with all thine heart, and with all thy soul, and with all thy might.” He discovered concepts that lay at the core of his New Testament Catholicism: “But the word is very nigh unto thee, in thy mouth, and in thy heart, that thou mayest do it.” (Michener 1965, 158–59)")])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("It is no fiction that Deuteronomy has exercised enormous influence on both Judaism and Christianity over the centuries. No fewer than two hundred of the traditional six hundred thirteen commandments of Pharasaic Judaism ")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("are said to have been based on Deuteronomy, and commentator Jeffrey Tigay (xxvii), who points this out, goes on to say that Deuteronomy’s contribution to Jewish worship in the daily liturgy and on special occasions has been extensive and profound. The Shema in Deut 6:4 has been at the heart of Jewish theology and worship for centuries, and its importance for Judaism continues up to the present day. The debt owed to Deuteronomy by the Christian Church is also considerable. The Decalogue has, in fact, been an important document in the minds of many great thinkers, e.g., Philo, Luther, Calvin, Immanuel Kant, Thomas Jefferson, Friedrich Nietzsche, and others (Kuntz 2004).")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy’s celebrated rhetorical prose, although flowing and not particularly difficult Hebrew, is nevertheless a challenge to the translator, for which reason I am not always satisfied with my renderings into English. As in my Jeremiah commentary (Lundbom 1999; 2004a; 2004b), so also here, I have stayed as close as possible to the Hebrew. This will not always lend itself to readings in public worship, but since I am writing a commentary, I want the reader to get a feel for the language, grammar, and style of the original, much of which is lost when translation is done according to the “dynamic equivalent” principle, or with an aim to render Biblical Hebrew into good English prose. I want the reader to hear the repetitions, the building of phrases, the parallelisms, the many dependent clauses, the concrete idioms, the added pronouns, and the inverted word order, the latter of which make for emphasis, which pervades the original. Much of this has been entirely lost in all modern English translations since the King James Version of 1611.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I am also in sympathy with modern Jewish scholars such as Richard Friedman, William Propp, and others, who quite intentionally want to render in English, with less change than is customary, an ancient language decidedly not English, having as it often does a strangeness to the modern ear. Translation of the Hebrew in Friedman’s "), _c('em', [_vm._v("Commentary on the Torah")]), _vm._v(" (2001) has much to recommend it, and I have used it with profit in my own translation of Deuteronomy. For a recent translation of Exodus that goes even further in preserving characteristics of the original, see Propp’s Anchor Bible commentary on "), _c('em', [_vm._v("Exodus")]), _vm._v(" (Propp 1999, 40–41). In a commentary, characteristic features of ancient Hebrew can perhaps be allowed, and may even be preferred, in translation. My hope, then, is that the reader will be charitable in assessing the translation of the present work. I have no desire to be doggedly literal or otherwise to render ancient Hebrew into inelegant English.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("I have chosen to cite in notes of the commentary a full listing of Deuteronomy’s stereotyped words and phrases the first time they occur, and then refer back to the note in question when they turn up again. One may consult the exhaustive lists of characteristic words and phrases in Driver (lxxvii–lxxxiv) and Weinfeld (1972, 320–65), but I think it useful to see the distinctive language of ")]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("Deuteronomy in contexts where it occurs. Of even greater importance will be to see how language contributes to important theological concepts contained in the book. Deuteronomy is a rich book of theology, and this theology is embodied first and foremost in language and rhetoric, not in concepts derived from great philosophical thinkers ancient and modern.")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("Deuteronomy’s influence on writers of the New Testament can hardly be overemphasized. Phrases and entire passages from the book are cited, abridged, paraphrased, or slightly altered on pages throughout the New Testament, by my count some 113 times (see ")]), _c('span', {
    attrs: {
      "href": "#/021_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")]), _vm._v("). Deuteronomy’s strident monotheism was also pressed into service by the church fathers, who used it as a weapon against anyone worshipping gods other than the God revealed in Holy Writ, which included Roman authorities, and Christian heretics such as the Gnostics, Marcionites, and Arians (Hilhorst 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Decalogue of Deuteronomy and key phrases from Deuteronomy turn up in Luther’s Larger and Smaller Catechisms. In the Smaller Catechism, Luther begins his explanation of each commandment with the words, “We should fear and love God,” embodying two important teachings of Deuteronomy. Many prominent New Testament themes—e.g., the love, righteousness, and faithfulness of God; the divine election of a holy people (Israel initially, then an expanded Israel to which Gentiles belong); the importance of love, fear, gratitude, obedience, and service on the part of covenant people towards God; a mandate for benevolent and humane treatment of sojourners, orphans, widows, poor, and the needy in general; divine judgment and exclusion from the Kingdom for human disobedience and foolishness—all these come straight out of Deuteronomy. So while the New Testament is known to draw heavily upon Isaiah and the Psalms, it is permeated as well with a host of important teachings from Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One realizes in the preparation of a commentary how indebted one is to others who labored earlier in the field. In the study of Deuteronomy, the commentary of S. R. Driver in the ICC series is where everyone has to begin, filled as it is with enormous learning and sanely appropriating a century and more of German scholarship on the Pentateuch, to which is added an encyclopedic knowledge of the Hebrew language and Deuteronomy’s distinctive vocabulary and style. All commentators and students of Deuteronomy have profited from Driver in the years since his work was published in 1895. Driver’s mastery of Deuteronomy was recognized by Rudolph Kittel, who assigned to him the textual work of Deuteronomy for his first edition of "), _c('em', [_vm._v("Biblica Hebraica")]), _vm._v(" ("), _c('em', [_vm._v("BH")]), _c('sup', [_vm._v("1")]), _vm._v(") in 1905, and by Cyrus Adler, who edited the "), _c('em', [_vm._v("Jewish Encyclopedia (JE)")]), _vm._v(" published in the years 1901–1906. Driver was one of the greats—perhaps the greatest—of nineteenth-century British Old Testament scholars (Emerton 2001; 2002; John Rogerson, "), _c('em', [_vm._v("TRE")]), _vm._v(" 9:190–92). His mastery of Biblical Hebrew is seen in collaborating "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("with Francis Brown and Charles Briggs to produce the "), _c('em', [_vm._v("Hebrew and English Lexicon of the Old Testament")]), _vm._v(" (BDB), a revision of the important lexical work of Wilhelm Gesenius (Smend 2007, 63–64). Driver also possessed a broad knowledge of ancient Hebrew religion and culture, and was not, like many scholars proficient in the ancient languages today, ignorant of Old Testament theology. Driver’s "), _c('em', [_vm._v("Deuteronomy")]), _vm._v(" is thus the commentary with which one has to begin, and a careful reading of its contents—including discussions in small print and in footnotes—will more than repay the effort. Although dated, it is nevertheless a veritable mine of information.")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("I am also much indebted to work in Deuteronomy carried out by two recent Jewish scholars, Moshe Weinfeld and Jeffrey Tigay. Weinfeld’s "), _c('em', [_vm._v("Deuteronomy 1–11")]), _vm._v(" in the Anchor Bible series (Weinfeld 1991), regrettably left unfinished, and a large number of publications on Deuteronomy and subjects relating to Deuteronomy combine to make Weinfeld the premier modern interpreter of this biblical book. The "), _c('em', [_vm._v("Deuteronomy")]), _vm._v(" commentary by Tigay in the JPS Torah Commentary (Tigay 1996) is also a very important work, and from him, too, I have learned much. Although written largely for a Jewish audience, it is of great value to non-Jewish readers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("German scholars of the nineteenth and twentieth centuries have made significant contributions to the study of Deuteronomy, even though no German language commentary ranks with those of Driver, Weinfeld, and Tigay. Modern critical study of Deuteronomy owes much to W. M. L. de Wette’s dissertation of 1805, which anchored the book in the seventh century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(", and to essays written in the 1930s and 1940s by Gerhard von Rad. On these two important Old Testament scholars, see Smend 2007, 43–56, 170–97. Von Rad’s commentary on Deuteronomy, published in English in the OTL series, fell way short of expectation, and was replaced in the series by a new commentary written by Richard Nelson. It, too, is brief, but contains much helpful information on the text, particularly readings of Dead Sea Scroll fragments. Another major German contributor to the study of Deuteronomy has been Norbert Lohfink, whose work on rhetorical structures has been of particular value.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Other Deuteronomy commentaries can also be consulted with profit. There is considerable learning in William Moran’s “Deuteronomy” in "), _c('em', [_vm._v("A New Catholic Commentary on Holy Scripture")]), _vm._v(" (1969), even though his treatment is brief and the work is not a full commentary like those of Driver, Weinfeld, and Tigay. Other Deuteronomy commentaries have been written over the years, and from these too insights may be gleaned in studying this important biblical book. One realizes in the preparation of a commentary, like any scholarly enterprise, how much one stands on the shoulders of those who labored earlier, to whom an enormous debt of gratitude is owed.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("Ancient place names and distances between ancient sites contained in the ")]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('em', [_vm._v("Onomasticon")]), _vm._v(" of Eusebius of Caesarea "), _c('em', [_vm._v("(Onom.)")]), _vm._v(" and the "), _c('em', [_vm._v("Liber Locorum")]), _vm._v(" of Jerome "), _c('em', [_vm._v("(Sit.)")]), _vm._v(" are taken from the new English translation of these works by G. Freeman-Grenville (Eusebius 2003), where the entries are listed in alphabetical order and Eusebius’s distances appear in Excursus II of the volume.")])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The section on “Deuteronomy and Wisdom” in the Introduction is an abridged version of an essay published earlier in a "), _c('em', [_vm._v("Festschrift")]), _vm._v(" for Richard Nelson (Lundbom 2010c).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I wish to express thanks to the National Endowment for the Humanities for a grant in 2004–2005 enabling me to begin work on this commentary at the Albright Institute of Archaeological Research in Jerusalem. It was David Noel Freedman who invited me to write the Deuteronomy volume for a projected Eerdmans Critical Commentary Series, of which he was the general editor. He lived to edit only the completed work on chapters 12–26. As always, his many pages of single-spaced, typewritten critique were filled with learned comment and helpful suggestions. I remain greatly indebted to this extraordinary biblical scholar and teacher over a period of forty years, from the beginning of graduate study at the San Francisco Theological Seminary and Graduate Theological Union in the fall of 1967 to the summer prior to his death in April 2008. My thanks to Eerdmans for accepting the work as a self-standing volume after the commentary series was closed down, and specifically to the able and congenial Allen Myers, who guided the work through to publication.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSbl"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACK")]), _vm._v(" R. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UNDBOM")])]), _vm._v(" "), _c('p', {
    staticClass: "Rightl"
  }, [_c('em', [_vm._v("Garrett-Evangelical Theological Seminary")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('table', {
    staticClass: "abbr"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Annual of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AAWG")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Abhandlungen der Akademie der Wissenschaften in Göttingen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Anchor Bible, ed. William F. Albright and David Noel Freedman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ABD")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Anchor Bible Dictionary")]), _vm._v(", ed. David Noel Freedman. 6 vols. New York, 1992")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ABRL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Anchor Bible Reference Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AbrN")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Abr-Nahrain")]), _vm._v(" (continued by "), _c('em', [_vm._v("Ancient Near Eastern Studies")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AcOr")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Acta orientalia")]), _vm._v(" (Copenhagen)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AcSu")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Acta sumerologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AfO")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Archiv für Orientforschung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AfOB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Archiv für Orientforschung: Beiheft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AGSJU")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Arbeiten zur Geschichte des Spätjudentums und Urchristentums")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AHw")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Wolfram von Soden, "), _c('em', [_vm._v("Akkadisches Handwörterbuch")]), _vm._v(". 3 vols. Wiesbaden, 1959–81.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AJBI")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Annual of the Japanese Biblical Institute")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AJP")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("American Journal of Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AJSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("American Journal of Semitic Languages and Literatures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AJSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Association for Jewish Studies Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("American Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Akk")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Akkadian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Al.T")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Donald J. Wiseman, "), _c('em', [_vm._v("The Alalakh Tablets")]), _vm._v(". London, 1953")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AmT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("The Bible: An American Translation, trans. J. M. Powis Smith and Edgar J. Goodspeed. Chicago, 1935")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AnBib")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Analecta biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ANE")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Ancient Near East(ern)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ANEP")]), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("The Ancient Near East in Pictures")]), _vm._v(", ed. James B. Pritchard. 2nd ed. with Supplement. Princeton, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", ed. James B. Pritchard. 3rd ed. with Supplement. Princeton, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AnOr")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Analecta Orientalia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AOAT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Alter Orient und Altes Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AOS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("American Oriental Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("APOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("The Apocrypha and Pseudepigrapha of the Old Testament")]), _vm._v(", ed. R. H. Charles. 2 vols. Oxford, 1913")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ApOTC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Apollos Old Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Aq")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Aquila")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Ar")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Arabic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ArBib")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("The Aramaic Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ARM")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Archives royales de Mari")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ArOr")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Archiv Orientální")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Assyriological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ASOR")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("American Schools of Oriental Research")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ATANT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Abhandlungen zur Theologie des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ATR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Anglican Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AuOr")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Aula orientalis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("AUSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Andrews University Seminary Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("AV")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Authorized King James Version, 1611")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("b")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblical Archaeologist")]), _vm._v(" (continued as "), _c('em', [_vm._v("NEA")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BASORSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Bulletin of the American Schools of Oriental Research: Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BBVO")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Berliner Beiträge zum Vorderen Orient")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(", ed. Francis Brown, S. R. Driver, and Charles A. Briggs. Oxford, 1907")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Bibliotheca ephemeridum theologicarum lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BH")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblia Hebraica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BH")]), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblia Hebraica")]), _vm._v(". 1st ed., ed. Rudolf Kittel. Stuttgart, 1905–6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BH")]), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblia Hebraica")]), _vm._v(". 3rd ed., ed. Rudolf Kittel. Stuttgart, 1937")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BHM")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Bulletin of the History of Medicine")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BHQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblia Hebraica Quinta")]), _vm._v(". 5th ed., ed. Adrian Schenker et al. Stuttgart, 1998–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(", ed. Kurt Elliger and Wilhelm Rudolph. Stuttgart, 1983. "), _c('em', [_vm._v("Liber Jeremiae")]), _vm._v(" prepared by Wilhelm Rudolph. Stuttgart, 1970")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BHT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Beiträge zur historischen Theologie")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BibOr")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Biblica et orientalia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BIW")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("The Bible in Its World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_c('em', [_vm._v("BJRL")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Bulletin of the John Rylands Library")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BJS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Brown Judaic Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BRev")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Bible Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BRS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Biblical Resource Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("The Biblical World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BWANT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Beiträge zur Wissenschaft vom Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CAD")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("The Assyrian Dictionary of the Oriental Institute of the University of Chicago")]), _vm._v(", ed. Ignace J. Gelb et al. Chicago, 1956–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Century Bible, ed. Walter F. Adeney")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CBC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cambridge Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CBSC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cambridge Bible for Schools and Colleges. OT ed. Alexander Francis Kirkpatrick")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cairo Genizah copy of the "), _c('em', [_vm._v("Damascus Document")]), _vm._v(" (= “Zadokite” Document)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CH")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Code of Hammurabi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CIS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Corpus inscriptionum semiticarum")]), _vm._v(" (Paris)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ConBOT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Coniectanea biblica: Old Testament Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("COS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("The Context of Scripture")]), _vm._v(", ed. William W. Hallo. 3 vols. Leiden, 1997–2003")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CovH")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Covenant Hymnal")]), _vm._v(". Chicago, 1950")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CovQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Covenant Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CP")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CPSSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cambridge Philological Society: Supplementary Volumes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Classical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CRFB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Christian Rural Fellowship Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("CUF")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Collection des Universités de France")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("CurTM")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Currents in Theology and Mission")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("D")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Deuteronomic source of the Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("DDD")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Dictionary of Deities and Demons in the Bible")]), _vm._v(", ed. Karel van der Toorn, Bob Becking, and Pieter W. van der Horst. Leiden and Grand Rapids, 1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("DH")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Deuteronomic Historian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Dict Talm")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature")]), _vm._v(", ed. Marcus Jastrow. 2 vols. London, 1903; Peabody, 2005")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Did")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Didache")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("DJD")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Discoveries in the Judaean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("DMB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Danish Medical Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("DMOA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Documenta et monumenta Orientis antiqui")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_c('em', [_vm._v("DSD")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Dead Sea Discoveries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("E")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Elohist source of the Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("EA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("El-Amarna tablets. According to the edition of J. A. Knudtzon, "), _c('em', [_vm._v("Die el-Amarna-Tafeln")]), _vm._v(". Leipzig, 1908–15. Repr. Aalen, 1964. Continued in A. F. Rainey, "), _c('em', [_vm._v("El-Amarna Tablets, 359–79")]), _vm._v(". 2nd rev. ed. Kevelaer, 1978.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("EBib")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Etudes bibliques")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ECB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(", ed. James D. G. Dunn and John W. Rogerson. Grand Rapids, 2003")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("EDSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Encyclopedia of the Dead Sea Scrolls")]), _vm._v(", ed. Lawrence H. Schiffman and James C. VanderKam. 2 vols. Oxford, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("EncB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Encyclopaedia Britannica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("EncIs")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Encyclopaedia of Islam")]), _vm._v(". New (2nd) ed., ed. C. E. Bosworth et al. Leiden, 1960–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("EncJud")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Encyclopaedia Judaica")]), _vm._v(", ed. Cecil Roth and Geoffrey Wigoder. 18 vols. Jerusalem, 1982–92")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ErIsr")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Eretz-Israel")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("EstBib")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Estudios bíblicos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ETL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Ephemerides theologicae lovanienses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("EVV")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Modern English Versions of the Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ExpTim")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("FRCS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Folklore Research Center Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("FS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Festschrift")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("G"), _c('sup', [_vm._v("B")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Codex Vaticanus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Gk")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Greek")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("GKC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(", ed. E. Kautzsch; trans. A. E. Cowley. 2nd ed. Oxford, 1963. Orig. 1910")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Good News Bible (New York, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("GRBS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Greek, Roman and Byzantine Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("GTA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Göttinger theologische Arbeiten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("H")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Holiness Code in Leviticus 17–26")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("HAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Hebrew Annual Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("HDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("A Dictionary of the Bible")]), _vm._v(", ed. James Hastings. New York, 1902")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Heb")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Hebrew")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Hen")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Henoch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Hist. eccl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Eusebius, "), _c('em', [_vm._v("Ecclesiastical")]), _vm._v(" History")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("HL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Hittite Laws")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("HS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Hebrew Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("HSM")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("HSS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Harvard Semitic Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('em', [_vm._v("HUB")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Hebrew University Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Interpreter’s Bible")]), _vm._v(", ed. George A. Buttrick. 12 vols. New York, 1951–57")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("International Critical Commentary, ed. S. R. Driver, Alfred Plummer, and Charles A. Briggs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Interpreter’s Dictionary of the Bible")]), _vm._v(", ed. George A. Buttrick. 4 vols. New York, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IDBSup")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Interpreter’s Dictionary of the Bible, Supplementary Volume")]), _vm._v(", ed. Keith Crimm. Nashville, 1976")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Israel Oriental Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("IR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Iliff Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("J")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Yahwist source of the Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JANES")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of the Ancient Near Eastern Society of Columbia University")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JBW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jahrbücher der biblischen Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JCS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Cuneiform Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JE")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jewish Encyclopedia")]), _vm._v(", ed. Cyrus Adler et al. 12 vols. New York, 1901–6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("JE")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Combined Yahwistic and Elohistic sources of the Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JEA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Egyptian Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JEOL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jaarbericht van het Vooraziatisch-Egyptisch Genootschap “Ex oriente lux”")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JHI")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of the History of Ideas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JJS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Jewish Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JLA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jewish Law Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JNES")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Near Eastern Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JNSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Northwest Semitic Languages")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JP")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JPOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of the Palestine Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("JPS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Jewish Publication Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JRev")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Juridical Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Journal for the Study of the Old Testament: Supplement Series (Continued as LHB/OTS)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Semitic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Jub.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Jubilees")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("K")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Kethib (“what is written”)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_vm._v("KAI")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Kanaanäische und aramäische Inschriften")]), _vm._v(". 2nd ed., ed. Herbert Donner and Wolfgang Röllig. 3 vols. Wiesbaden, 1962–71")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("KBL"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Ludwig Köhler and Walter Baumgartner, "), _c('em', [_vm._v("Hebräisches und Aramäisches Lexikon zum Alten Testament")]), _vm._v(". 3rd ed. Leiden, 1967–90")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("KEH")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Kurzgefasstes exegetisches Handbuch zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("KRT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("La Légende de Keret")]), _vm._v(", C. Virolleaud. Paris, 1936; H. L. Ginsberg, "), _c('em', [_vm._v("BASORSup")]), _vm._v(" 2–3, 1946")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("KTU")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Die keilalphabetischen Texte aus Ugarit")]), _vm._v(", ed. Manfred Dietrich, Oswald Loretz, and Joaquin Sanmartín. AOAT 24. Neukirchen, 1976")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Lane")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("E. W. Lane, "), _c('em', [_vm._v("An Arabic-English Lexicon")]), _vm._v(". London 1863–93")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Lat")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Latin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LE")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Laws of Eshnunna")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LHB/OTS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Library of Hebrew Bible/Old Testament Studies (continuing JSOTSup)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LI")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Laws of Lipit-Ištar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Liv. Pro.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Lives of the Prophets")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Loeb")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LOS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("London Oriental Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LUN")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Laws of Ur-Nammu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Septuagint, according to "), _c('em', [_vm._v("Septuaginta II")]), _vm._v(". 8th ed., ed. Alfred Rahlfs. Stuttgart, 1965")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("M"), _c('sup', [_vm._v("A")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Masoretic Text according to the Aleppo Codex (Codex A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("M"), _c('sup', [_vm._v("L")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Masoretic Text according to the Leningrad Codex B19"), _c('sup', [_vm._v("A")]), _vm._v(" (Codex L)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("MAL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Middle Assyrian Laws")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Mandelkern")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Solomon Mandelkern, "), _c('em', [_vm._v("Veteris Testamenti Concordantiae")]), _vm._v(". Tel Aviv, 1964")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Mart. Isa.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Martyrdom of Isaiah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("MS(S)")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Manuscript(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("MSU")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Mitteilungen des Septuaginta-Unternehmens")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Masoretic Text, according to "), _c('em', [_vm._v("BH")]), _c('sup', [_vm._v("3")]), _vm._v(" or "), _c('em', [_vm._v("BHS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NAB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New American Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NCBC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New Century Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("NEA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Near Eastern Archaeology")]), _vm._v(" (continuing "), _c('em', [_vm._v("BA")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("NEAEHL")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("New Encyclopedia of Archaeological Excavations in the Holy Land")]), _vm._v(", ed. Ephraim Stern. 4 vols. Jerusalem, 1993")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NEcB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Die Neue Echter Bibel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NJB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_vm._v("NJV")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Tanakh: A New Translation of the Holy Scriptures According to the Traditional Hebrew Text. Philadelphia, 1985")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("NKZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Neue kirchliche Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("NT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Orbis biblicus et orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("OEANE")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Oxford Encyclopedia of Archaeology in the Near East")]), _vm._v(", ed. Eric M. Meyers. 5 vols. Oxford, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("OED")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Oxford English Dictionary")]), _vm._v(". 2nd ed. Oxford, 1989")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OIP")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Oriental Institute Publications. University of Chicago")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("OJA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Oxford Journal of Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Onom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Onomasticon")]), _vm._v(" of Eusebius")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Or")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Orientalia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("OrAnt")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Oriens antiquus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("OTP")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Old Testament Pseudepigrapha")]), _vm._v(", ed. James H. Charlesworth. 2 vols. Garden City, 1983–85")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OTS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Oudtestamentische Studiën")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("OTWSA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Die Oudtestamentiese Werkgemeenskap in Suid-Afrika")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("P")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("“Priestly” source of the Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("PEFQS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Palestine Exploration Fund. Quarterly Statement (continued as Palestine Exploration Quarterly")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Palestine Exploration Quarterly (continuing Palestine Exploration Fund. Quarterly Statement")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("PIBA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Proceedings of the Irish Biblical Association")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("POS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Pretoria Oriental Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("PRU")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Le Palais Royal d’Ugarit, ed. Claude F.-A. Schaeffer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("PSBA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Proceedings of the Society of Biblical Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Q")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Qere (“what is read”)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("QT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Qumran "), _c('em', [_vm._v("Temple Scroll")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue d’Assyriologie et d’Archéologie Orientale")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("REB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Revised English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RES")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue des études sémitiques")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RevQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue de Qumrân")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("RGG"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Die Religion in Geschichte und Gegenwart, 1st ed. Tübingen, 1909–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RHA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue hittite et asianique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RIDA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Revue internationale des droits de l’antiquité")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("RLA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Reallexikon der Assyriologie")]), _vm._v(", ed. Erich Ebeling und Bruno Meissner. Berlin, 1932–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_vm._v("RV")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Revised Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("S")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Syriac")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SAA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("State Archives of Assyria")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Sam")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Samaritan Pentateuch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SAOC")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studies in Ancient Oriental Civilization")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBAB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Stuttgarter biblische Aufsatzbände")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBL")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLABS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Archaeology and Biblical Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLMS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLSCSS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Septuagint and Cognate Studies Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLSymS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Symposium Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLTT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Texts and Translations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBLWAW")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Society of Biblical Literature Writings from the Ancient World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Stuttgarter Bibelstudien")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("ScrHier")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Scripta hierosolymitana")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Sem")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Semitica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SHANE")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studies in the History of the Ancient Near East")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Sib. Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Sibylline Oracles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("Sit.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Jerome, "), _c('em', [_vm._v("De situ et nominibus locorum Hebraicorum (Liber locorum)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("SJLA")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studies in Judaism in Late Antiquity")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("SJOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Scandinavian Journal of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("SLR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Stanford Law Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("SRR")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Seminary Ridge Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("StPB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Studia post-biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Symm")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Symmachus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("T")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Targum(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("T"), _c('sup', [_vm._v("MS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Targum Manuscript")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("T"), _c('sup', [_vm._v("Nf")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Targum Neofiti")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("T"), _c('sup', [_vm._v("Onq")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Targum Onqelos")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("T"), _c('sup', [_vm._v("PsJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Targum Pseudo-Jonathan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("T. Levi")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Testament of Levi")]), _vm._v(" (in "), _c('em', [_vm._v("The Testament of the Twelve Patriarchs")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("T. Reu.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Testament of Reuben")]), _vm._v(" (in "), _c('em', [_vm._v("The Testament of the Twelve Patriarchs")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("T. Sim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Testament of Simeon")]), _vm._v(" (in "), _c('em', [_vm._v("The Testament of the Twelve Patriarchs")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("TA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Tel Aviv")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("TAPS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Transactions of the American Philosophical Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("TB")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Theologische Bücherei")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(", ed. G. Johannes Botterweck, Helmer Ringgren, and Heinz-Josef Fabry. 17 vols. Grand Rapids, 1974–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }, [_c('em', [_vm._v("Text")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Textus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Theod")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Theodotion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("TLZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("TRE")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Theologische Realenzyklopädie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("UF")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Ugarit-Forschungen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Ug")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Ugaritic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("UgT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Ugaritic text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("UM")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cyrus H. Gordon, "), _c('em', [_vm._v("Ugaritic Manual")]), _vm._v(". AnOr 35. Rome, 1955")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("UT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Cyrus H. Gordon, "), _c('em', [_vm._v("Ugaritic Textbook")]), _vm._v(". AnOr 38. Rome, 1965")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("VAT")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Vorderasiatische Abteilung Tontafel. Vorderasiatisches Museum, Berlin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("Vg")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Vulgate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("VTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("D. J. Wiseman, "), _c('em', [_vm._v("Vassal Treaties of Esarhaddon. Iraq")]), _vm._v(" 20 (1958) 1–99; also London, 1958")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("War Scroll")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Scroll of the War of the Sons of Light against the Sons of Darkness")]), _vm._v(" (1QM)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("WHJP")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("World History of the Jewish People")]), _vm._v(". 1st ser.: "), _c('em', [_vm._v("Ancient Times")]), _vm._v(", ed. E. A. Speiser et al. Jerusalem, 1964–79")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Western Watch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_vm._v("YJS")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_vm._v("Yale Judaica Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ZA")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Zeitschrift für Assyriologie und verwandte Gebiete")]), _vm._v(" (continued as "), _c('em', [_vm._v("Zeitschrift für Assyriologie und vorderasiatische Archäologie")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ZDMG")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Zeitschrift der deutschen morgenländischen Gesellschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "Abbr"
  }, [_c('em', [_vm._v("ZDPV")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "Abbr-h"
  }, [_c('em', [_vm._v("Zeitschrift des deutschen Palästina-Vereins")])])])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-title",
    attrs: {
      "id": "pt-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("NAME AND CANONICITY")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy is the fifth book of the canonical Hebrew Scriptures/Old Testament (OT). In Jewish tradition the first five books are “The Torah” (Sirach, "), _c('em', [_vm._v("Prologue")]), _vm._v("), going otherwise by their Latin name, "), _c('em', [_vm._v("Pentateuch")]), _vm._v(". Greek πεντάτευχος (= “five rolls”) is an adaptation of the Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֲמִשָּׁה חֻמְשֵׁי הַתּוֹרָה")]), _vm._v(", meaning “five-fifths of the Law” ("), _c('em', [_vm._v("JE")]), _vm._v(" 9:589). A Dead Sea Scroll fragment (1Q30:1 line 4) has turned up the expression ‏"), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("[ס]פרים חומשים")]), _vm._v(", which may denote either the five books of the Torah or the five books of the Psalter (Barthélemy and Milik 1955, 132–33).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not known when the division into five books occurred, although it is generally thought to have been long before the Second Temple/New Testament (NT) period ("), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:232). In the Talmud ("), _c('em', [_vm._v("b. B. Bat")]), _vm._v(". 14b–15a), the author of this work, except perhaps for the last eight verses of Deuteronomy, is said to have been Moses. These concluding verses report Moses’ death, for which reason certain rabbis said they must have been written by Joshua. Already in 1 Kgs 2:3 and 2 Kgs 14:6 are references to a written “law of Moses” (cf. Josh 8:31; 23:6; Ezra 3:2). Mosaic authorship of Deuteronomy is affirmed by Josephus, although with the qualification that Moses left things in a scattered condition ("), _c('em', [_vm._v("Ant")]), _vm._v(". 4.196–97).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The name "), _c('em', [_vm._v("Deuteronomion")]), _vm._v(" in the Greek Septuagint (LXX) derives from τὸ δευτερονόμιον το"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ῦ")]), _vm._v("το in LXX 17:18, which is its rendering of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־מִשְׁנֵה הַתּוֹרָה הַזֹּאת")]), _vm._v(". The LXX translator(s) took the expression to mean “this second law,” whereas T"), _c('sup', [_vm._v("Onq")]), _vm._v(" translates “a copy of this law” (cf. Josh 8:32), now the generally accepted interpretation. Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁנֶה")]), _vm._v(" can mean “double, second, copy.” Mishnah "), _c('em', [_vm._v("Sanh")]), _vm._v(". 2:4 says the king was to write for himself “a scroll of the law,” which it takes to mean “an additional scroll” (Blackman 1977, 4:244). The Qumran "), _c('em', [_vm._v("Temple ")])]), _c('em', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Scroll")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v(" (11QT 56:21) simply has “this law,” instead of “a copy of this law,” removing the ambiguity (Yadin 1983, 1:345; 2:254). In Rabbinical Hebrew Deuteronomy is called "), _c('em', [_vm._v("Mishneh Torah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תּוֹרָה מִשְׁנֵה")]), _vm._v("), which means “repeated law” (Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:232). This name and the LXX name are therefore not inappropriate, since Deuteronomy repeats earlier law from Exodus, and in 28:69(29:1) the Deuteronomic covenant is distinguished from the covenant made at Horeb (Sinai). Luther took "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁנֵה תּוֹרָה")]), _vm._v(" to mean “second Law,” but said there was no difference between this law and the law given at Horeb. Latin "), _c('em', [_vm._v("Deuteronomium")]), _vm._v(" of the Vulgate (Vg) comes into English as “Deuteronomy.” The Hebrew name for Deuteronomy is "), _c('em', [_vm._v("Debarim")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("דְּבָרִים")]), _vm._v("), “(the) Words,” taken—as elsewhere in the Pentateuch—from the opening words of the book: “These are the words” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵלֶּה הַדְּבָרִים")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("TEXT AND VERSIONS")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The text of Deuteronomy is relatively good, only occasionally requiring correction from the ancient Versions (Driver 1895, xcv). It has none of the problems found in Samuel, Hosea, Jeremiah, and certain other OT books. Difficult or problematic readings occur mainly in the poetry of chapters 32 and 33, and even then, these are not many.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Hebrew Masoretic Text (MT) survives in modern times in the Leningrad Codex (M"), _c('sup', [_vm._v("L")]), _vm._v("), dated ca. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 1010, and is the text on which "), _c('em', [_vm._v("BH")]), _c('sup', [_vm._v("3")]), _vm._v(" and "), _c('em', [_vm._v("BHS")]), _vm._v(" are based (Sanders and Beck 1997). It is also the text on which "), _c('em', [_vm._v("Biblia Hebraica Quinta (BHQ)")]), _vm._v(" and the "), _c('em', [_vm._v("Oxford Hebrew Bible")]), _vm._v(", both currently in preparation, will be based. Deuteronomy in "), _c('em', [_vm._v("BHQ")]), _vm._v(" has been prepared by Carmel McCarthy; for a summary of her work on the text, see McCarthy 2007. M"), _c('sup', [_vm._v("L")]), _vm._v(" is the oldest complete manuscript of the Hebrew Bible in existence, housed in the Russian National Library in St. Petersburg. A fascimile was published recently by David Noel Freedman et al. (1998). The other important medieval manuscript of the Hebrew Bible is the Aleppo Codex (M"), _c('sup', [_vm._v("A")]), _vm._v("), dated to the tenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" This codex has been published in a facsimile edition by Moshe Goshen-Gottstein (1976) and is the text being used in the "), _c('em', [_vm._v("Hebrew University Bible (HUB)")]), _vm._v(". The Aleppo Codex is only 70 percent complete, however, a number of folios having been lost as a result of the Aleppo riots of 1948. Most of the Pentateuch is missing. The codex presently begins with the last word of Deut 28:17, “and your baking bowl” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וּמִשְׁאַרְתֶּךָ")]), _vm._v("), after which the remainder of Deuteronomy is preserved.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The LXX of the Pentateuch, translated probably in the early or middle third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" by Jews in Alexandria, is a relatively good translation of the Hebrew text (Eissfeldt 1965, 604–5, 702–4; Fohrer 1968, 508). Variants in Deuteronomy are largely the sudden and frequent changes between second singular ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and second plural (both “you”) in the speeches of Moses (the so-called "), _c('em', [_vm._v("Numeruswechsel")]), _vm._v(") and minor differences bearing little or not at all on the sense. There are cases where the LXX translator seems not to have correctly understood the Hebrew, e.g., in 28:5 he mistranslates "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁאַרְתֶּךָ")]), _vm._v(" (“your kneading bowl”) with τὰ ἐγκαταλείμματά σου (“your reserve”), and in 28:20 he translates "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־הַמְּאֵרָה אֶת־הַמְּהוּמָה וְאֶת־הַמִּגְעֶרֶת")]), _vm._v(" (“curse, panic, and rebuke”) with τὴν ἔνδειαν καὶ τὴν ἐκλιμίαν καὶ τὴν ἀνάλωσιν (“poverty and famine and destruction”), which are not quite right.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The LXX appears not to manifest any anti-anthropomorphic bias in its translation, as might be expected (Wittstruck 1976). Fritsch (1943) claimed for the Greek Pentateuch numerous anti-anthropomorphisms, but this thesis has been refuted by Orlinsky (1944) and Wittstruck (1976). It finds little support in Deuteronomy, and of the examples cited by Fritsch many occur not in the law code, but in the poetry of chapters 32 and 33, where unusual coinages might be expected. The LXX text of Deuteronomy gets full and detailed discussion in Wevers 1978 and 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A couple of LXX readings in Deut 32:8 and 43 (the Song of Moses) have taken on new importance in light of Dead Sea Scroll readings, which vindicate them partially or wholly against readings in MT (see below).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Samaritan Pentateuch (Sam), dating in all likelihood from a time soon after the Pentateuch was canonized in ca. 400 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(", contains a reported six thousand divergencies from the MT, most of which are orthographic (Eissfeldt 1965, 695; Fohrer 1968, 505; Waltke, "), _c('em', [_vm._v("ABD")]), _vm._v(", 5:932). Roughly one-third agree with the LXX against MT. While some do correct or improve readings of MT, the vast majority are insignificant differences in spelling and grammar that do not affect the sense. Waltke ("), _c('em', [_vm._v("ABD")]), _vm._v(", 5:938) says the Sam is therefore of little value in determining original readings. Occasionally variants are of substance. One is the substitution of “Gerizim” in Deut 27:4 for “Ebal” in MT. This could be a deliberate change giving prominence to the mountain on which the Samaritan temple was located, although Eissfeldt (1965, 216 n. 9, 695) and others think the reading is more likely an anti-Samaritan polemic in light of the schism between Samaritans and Jews in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" (cf. Josephus "), _c('em', [_vm._v("Ant")]), _vm._v(". 13.74–79), thus a change not in Sam, but in MT. For discussion on the Samaritan Pentateuch, see J. MacDonald in "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:264–68; B. Waltke in "), _c('em', [_vm._v("ABD")]), _vm._v(", 5:932–40; Crawford 2005b:131–32.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The Targums, which are Aramaic paraphrases of OT books written in Palestine in the early centuries of the Christian Era, fulfill a need similar to what the LXX filled in Egypt, viz., to enable non-Hebrew-speaking Jews to understand the Hebrew Bible. They are literal renditions of the biblical text adding "), _c('em', [_vm._v("halakhic")]), _vm._v(" interpretation and "), _c('em', [_vm._v("aggadic")]), _vm._v(" embellishment. The authoritative Targum on the Torah is "), _c('em', [_vm._v("Targum Onqelos")]), _vm._v(" (T"), _c('sup', [_vm._v("Onq")]), _vm._v("), dated in the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(", but in ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Deuteronomy one can also consult readings in "), _c('em', [_vm._v("Targum Neofiti")]), _vm._v(" (T"), _c('sup', [_vm._v("Nf")]), _vm._v(") and "), _c('em', [_vm._v("Targum Pseudo-Jonathan")]), _vm._v(" (T"), _c('sup', [_vm._v("PsJ")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("QUMRAN SCROLLS")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Numerous texts of Deuteronomy have been found at Khirbet Qumran: biblical fragments, excerpted texts, selected verses on "), _c('em', [_vm._v("mezuzot")]), _vm._v(" and phylacteries, and passages incorporated into sectarian and other nonbiblical documents. According to García Martínez (1994, 66), there are thirty-two extant fragments of Deuteronomy from the Judean Desert, all prior to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 70. Crawford (2005a, 316) says the total is thirty-four or thirty-five, which includes one Greek Deuteronomy fragment and one Hebrew fragment each from Wadi Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever/Wadi Seiyal, and Masada. Deuteronomy is second only to the book of Psalms in numbers of copies turning up at Qumran (Crawford 2005b, 127). There is no complete manuscript to be compared with the celebrated Isaiah Scroll found in Cave 1 (1QIsa"), _c('sup', [_vm._v("a")]), _vm._v("). The majority of Deuteronomy fragments turned up in Cave 4, a few coming from Caves 1, 2, and elsewhere. Deuteronomy is represented in nine "), _c('em', [_vm._v("mezuzot")])]), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#f-1",
      "id": "f1"
    }
  }, [_vm._v("*")]), _vm._v(" and thirty-three phylacteries,"), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#f-2",
      "id": "f2"
    }
  }, [_vm._v("†")]), _vm._v(" which contain verses from the Decalogue and the "), _c('em', [_vm._v("Shema")]), _vm._v(" in 5:1–6:9, portions of 10:12–11:21, and in one case verses from the Song of Moses (Deuteronomy 32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A couple of Qumran readings in the Song of Moses are of particular importance. In 4QDeut"), _c('sup', [_vm._v("j")]), _vm._v(" the reading "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בני אלוהים")]), _vm._v(" (“sons of God”) occurs in 32:8 (Ulrich, Cross et al. 1995, 90), where MT and the Versions all have "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בְּנֵי יִשְׂרָאֵל")]), _vm._v(" (“sons of Israel”). The LXX supports the Qumran text with ἀγγέλων θεο"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ῦ")]), _vm._v(") (“angels of God”). Also, a 4QDeut"), _c('sup', [_vm._v("q")]), _vm._v(" reading of 32:43 expands the two poetic lines of MT into three (Ulrich, Cross et al. 1995, 141). The LXX expands the verse to four poetic lines (see Note for 32:43). For a discussion of the Deuteronomy texts found in the Qumran caves and in the Judean Desert, see J. Duncan, “Deuteronomy, Book of” in "), _c('em', [_vm._v("EDSS")]), _vm._v(" 198–202.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Qumran "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" (11QT) expounds large sections of Deuteronomy (Yadin 1977; 1983, vols. 1–2; Crawford 2005b, 137–40), although it harmonizes the Deuteronomic texts with texts from Exodus, Leviticus, and Numbers to create a unified whole. The Deuteronomic texts are largely those from chapters 12–26, 28, which can be found in 11QT 43, 48, 51–57, and 59–66. In 11QT two texts from chapter 7 are inserted into the covenant renewal passage of Exod 34:10–16. Occasionally the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" makes a substantive change, e.g., in "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Deut 21:22, where the biblical text reads: “and he is put to death and you hang him upon a tree,” it changes the word order to read: “you shall hang him on a tree, and he shall die” (11QT 64:8; Yadin 1983, 1:81; 2:289–90). Here the author makes the cause of death the hanging, which is not what the biblical passage intends. The "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" also changes grammar so that God, not Moses, is speaking (Yadin 1983, 1:71–73), which brings the Deuteronomic discourse into line with the discourse of Exodus. This has the law given directly by God, not handed down through Moses. Other Qumran documents indicating the importance of Deuteronomy in the Dead Sea Community include 4Q473 on “The Two Ways” (Brooke et al. 1996, 292–94); 4QMMT (Qimron and Strugnell 1994, 58–61; Fraade 2003, 150–51); and 1Q22 on the “Words of Moses” (Barthélemy and Milik 1955, 91–96).")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("PARAGRAPH DIVISIONS")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The MT, Samaritan Pentateuch, Qumran biblical fragments, and Qumran "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" all contain paragraph divisions. There are two types: the closed section, marked by a "), _c('em', [_vm._v("setumah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ס")]), _vm._v("), and the open section, marked by a "), _c('em', [_vm._v("petu"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("ah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פ")]), _vm._v("). The texts simply have blank spaces at the beginning, middle, and end of lines, or between lines; the sigla "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ס")]), _vm._v(" and "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פ")]), _vm._v(" are put in later, their first known appearance being in an edition of Isaiah and Jeremiah published at Lisbon in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 1492 (Ginsburg 1885, 3:xvi). Before the Dead Sea Scrolls were found, these section markings were thought to be later. The Mishnah (ca. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 200) mentions paragraphs in the Pentateuch and the Prophets, but the distinction between open and closed sections is first made in the Talmud (cf. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 500). Jerome’s Hebrew text shows the subdivisions plainly (Pfeiffer 1948, 81). Now that sections have turned up in Qumran texts, we realize that they are even more ancient, and that they can be very useful in delimiting discourse units.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("DEUTERONOMY PAPYRI")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Some important early papyri contain portions of Deuteronomy. The Nash Papyrus (S. A. Cooke 1903), a liturgical text written in Hebrew, comes from Egypt, perhaps Fayum, and is dated by Albright (1937, 149) to the second half of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" It contains the entire Decalogue (Exod 20:2–17; Deut 5:6–21) and the Shema (Deut 6:4–5). The text of the Decalogue appears to combine Exodus and Deuteronomy. The Roberts Papyrus (P. Ryl. Gk. 458; Roberts 1936), a Greek text also from Egypt and dated to the end of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(", a mere one hundred years after the Torah was translated into Greek in Alexandria ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("(LXX), contains four fragmented columns of a Deuteronomy scroll (23:25–24:3; 25:1–3; 26:12, 17–19; 28:31–33). These were used along with a fragment of the "), _c('em', [_vm._v("Iliad")]), _vm._v(" to wrap a mummy.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("From the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" comes the Chester Beatty Biblical Papyri (Kenyon 1935), another important collection of twelve Greek manuscripts of the Bible emanating from Egypt, probably having been discovered in the ruins of an early Christian church or monastery in the neighborhood of Fayum. Papyrus VI is a codex of what originally were the complete books of Numbers and Deuteronomy (216 pages, or 108 leaves). A large portion of Deuteronomy has survived (1:20–33, 35–46; 2:1–3:21; 3:23–4:49; 5:1–7:10; 7:12–13, 15–20; 9:26, 29; 10:1–2, 5–7, 11–12, 19–21; 11:12–13, 17–18, 31–32; 12:2–4, 15–17; 18:22; 19:1, 4–6, 10–11, 13–14, 16; 27:6–8, 13–15; 28:1–4, 7–10, 12–13, 16–20, 22–25, 27–30, 32–35, 38–41, 43–68; 29:1–18, 20–21, 23–27; 30:1, 4–6, 10–11, 12–13, 16–17, 19–20; 31:3–4, 8–16, 18, 21–23, 26–29; 32:3–5, 10–13, 17–19, 24–25, 27–29; 33:24–26; 34:11–12). This manuscript presents few textual problems and contains no notable new readings (Roberts 1936, 41).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-6"
    }
  }, [_vm._v("DATE, COMPOSITION, AND AUTHORSHIP")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-20",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSIANIC")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORM")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Modern research in Deuteronomy—indeed in the entire Pentateuch—builds on the thesis of W. M. L. de Wette (1830; 1843, 2:150–54), published originally in 1805, that Deuteronomy was the lawbook found in the temple during the reign of King Josiah (2 Kgs 22:8). Some early church fathers, viz., Athanasius, Chrysostom, Jerome, and Theodoret, also made the identification (Nestle 1902), but de Wette went farther in arguing that Deuteronomy had been written shortly before it was found. This appropriated earlier critical views rejecting Mosaic authorship and put Deuteronomy’s composition in the seventh century. De Wette also compared Deuteronomy with Joshua to 2 Kings and found here a peculiar style and content, now called “Deuteronomic.” His thesis was widely accepted, becoming the linchpin in modern critical theory of the Pentateuch (Rowley 1963b, 161; Eissfeldt 1965, 173).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("By the time of Wellhausen, in 1878, Deuteronomy (Source D) had become one of the four pillars of pentateuchal theory, and it was agreed that D preceded Priestly legislation (Source P) in Numbers, Leviticus, and portions of Exodus, rather than vice versa (Wellhausen 1957). Since D was found exclusively in Deuteronomy, or nearly so, it did not have to be disentangled from other source documents. Wellhausen’s views were presented convincingly to Anglo-American scholars by S. R. Driver who, in the "), _c('em', [_vm._v("Introduction")]), _vm._v(" to his ICC "), _c('em', [_vm._v("Deuteronomy")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("(lxxvii–xciv), compiled extensive lists of vocabulary and phraseology characterizing the D source and, in the words of one scholar, “brought down to earth what had hitherto dwelt in the clouds.”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A seventh-century date for Deuteronomy is now widely accepted, although some would push back the composition to the reigns of Manasseh or Hezekiah, arguing that portions of the book betray a northern provenance and may date from before or just after the fall of the northern kingdom (722). A postexilic date for P and its dependence upon D have more recently been challenged by Yehezkel Kaufmann (Greenberg 1950; Weinfeld 1972, 179–80; 2004, 3–74; "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:240), and there is a growing consensus—particularly among Jewish scholars—that P is older, preexilic in any case, and perhaps contemporary with D (Freedman; Weinfeld 2004, xii). Weinfeld sees the two documents as representing two theological schools: P characterized by a theocentric approach; D characterized by an anthropocentric approach (Weinfeld 1972, 179–89; 2004, 77–94).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Josianic reform, as reported in 2 Kings 22–23, appears to owe much to Deuteronomy. The purge carried out by the young king in Jerusalem, Judah, and sites to the north (2 Kgs 23:4–20) is said to have taken place immediately following the finding of the scroll in the temple, and specific acts of the purge—the temple cleansing and destruction of vessels and other cult objects dedicated to foreign deities; the destruction of high places with their altars, pillars, and Asherim; the deposition of idolatrous priests in Jerusalem and slaying of idolatrous priests in the northern cities; the tearing down of chambers in the temple belonging to cult prostitutes; and the elimination of various other elements of foreign worship—all seem to correlate with the prohibitions in Deut 5–26, 28—not only in content, but in vocabulary and phraseology (Driver 1895, xlv; Paton 1928, 325–26; Weiser 1961, 127–28; Nicholson 1967, 3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to 2 Kings 23, a covenant renewal ceremony preceded the purge, and a grand celebration of Passover took place afterwards, in Jerusalem, now the one and only legitimate sanctuary for Yahweh worship. Covenant renewal and centralization of worship are at the heart of Deuteronomy, which mandates that worship occur only at “the place that Yahweh your God will choose (out of/in all your tribes) to put his name there,” or descriptions of the like (12:5, 11, 14, 18, 21, 26). Finally, since Huldah’s oracle (2 Kgs 22:16–17) declares certain judgment upon Judah for covenant violation, some scholars (G. A. Smith 1918, 194; G. E. Wright 1953, 320; H. L. Ginsberg 1982, 39) have argued that the curses of Deuteronomy 28 must be included on the temple scroll.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEST FOR")]), _vm._v(" "), _c('em', [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RDEUTERONOMIUM")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("In the years following the placement of Deuteronomy in the context of the Josianic reform, a quest for "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" (“proto-Deuteronomy”) began, since it was thought that the scroll of 622 could not possibly contain all the material now found in our present book of Deuteronomy. The quest began with Wellhausen (1889, 191–95), who believed that the newly found scroll contained only the core legislation in chapters 12–26. This core, in his view, appeared in two editions, each of which contained its own introduction: chapters 1–4 and chapters 5–11 (Wellhausen 1957, 369). DeWette had argued earlier (1843, 2:131) that 4:44 began a new collection of Mosaic law containing a sermonic admonition similar to the first admonition in 1:1–4:40. This view of two editions was adopted by J. Estlin Carpenter (1883, 254–55) and numerous other scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("S. R. Driver (1895, lxvi–lxxii, 135), however, pointed out soon after that so far as language and style were concerned, there was nothing in chapters 5–11 to suggest a different author from chapters 12–26, and he concluded that chapters 5–26 were the work of a single author, a view that gained broad acceptance (G. E. Wright 1953, 318; von Rad 1962a, 832). Driver also saw no reason to assign chapters 1–3(4) to a different hand than chapters 5–26 (Driver 1895, lxxii; 1913, 94; cf. Albright 1957b, 319), though he did concede the view of earlier scholars that, for some reason, the book contained two superscriptions: 1:1–5 and 4:44–49. He said (p. 79) that the summary in 4:44–49 appeared to be superfluous after 1:1–5, introducing as it does not simply chapters 1–4, but the Deuteronomic discourses generally (v. 5: “to make plain this law”). Despite this difficulty, numerous scholars have followed Driver in viewing 1:1–5 and 4:44–49 as double superscriptions surviving in the present book (G. E. Wright 1953, 314; Nicholson 1967, 18; Fohrer 1968, 171; Lohfink 1968, 7; Weinfeld, 233–34; 1972, 69), a point to which we will return shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A solution to this puzzlement of two apparent introductions was offered by Martin Noth in his study of the Deuteronomic History, published in 1943 (Noth 1981). Noth believed Deuteronomy was intended as an introduction to the entire Deuteronomic History (Deuteronomy to 2 Kings) and was the work of a single author. In his view, the Deuteronomic History could not begin with Creation, since he found no signs of Deuteronomic editing in Genesis to Numbers. But he did see a linkage of Deut 31:1–13 and 14 with Joshua 1. The Introduction to this great work must therefore have been Deuteronomy 1–3(4) (Noth 1981, 12–14). Viewed in this manner, the chapters did not introduce the Deuteronomic law, as Wellhausen and Driver imagined, but rather the larger history beginning with the conquest of Canaan and ending with the collapse of the Israelite nation.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Noth believed the Deuteronomic Historian took over the Deuteronomic ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("law consisting of Deut 4:44–30:20, which meant he was still taking 4:44–49 to be an introduction (p. 16). Since the last event recorded in 2 Kings is to be dated ca. 562, the writing of the Deuteronomic History was put shortly after. This thesis of Noth had wide appeal, although many scholars continued to believe that much of the Deuteronomic History was written before the fall of Jerusalem, some arguing that the work went through two editions (G. E. Wright 1953, 317; Freedman 1962, 716; Cross 1968; R. D. Nelson 1981). Freedman said the First Edition could be seen reaching a climax in 2 Kings 22–23, which reports the Josianic reform, and that “what follows is a melancholy epilogue.” Lohfink (1976, 231), too, thinks 2 Kings 22–23 contains material probably composed in Josiah’s lifetime. If this be the case, then Deuteronomy 1–4 as an introduction to the First Edition of the Deuteronomic History could be preexilic (Albright 1957b, 315). Fohrer (1968, 177) believes chapters 1–3 cannot be removed from the rest of the book and made the beginning of a Deuteronomic historical work, and agrees with Driver that these chapters are better taken as introducing the Deuteronomic law code.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Noth’s theory underwent further revision in the work of David Noel Freedman (1962, 716–18), who saw continuity between the end of Numbers and the beginning of Deuteronomy (he calls Deuteronomy 1–4 a “bridge” to what has gone before). Freedman believed therefore that the document completed ca. 560 was not the Deuteronomistic History, but rather a work he calls the “Primary History,” viz., Genesis to 2 Kings. Albright (1957b, 345) had earlier expressed the view that the Pentateuch existed in substantially its present form before 522. Only later was the Pentateuch separated out from the Primary History, according to Freedman, occasioned by an interest of the exilic community in the person of Moses and Israel’s experience in the wilderness. A linking between Numbers and Deuteronomy was seen also by Eissfeldt (1965, 157), who said that Deuteronomy 31–34 must be a direct continuation of Numbers 27, in that here Joshua’s appointment as Moses’ successor is brought to conclusion; also, in chapter 34 of Deuteronomy the last words and the death of Moses are reported.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Other source-critical studies were part of the quest for an "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(". Staerk (1894, 76–93) and Steuernagel (1894), for example, attempted to show that the sudden and frequent changes between second singular and second plural forms of the verb in the speeches of Moses (the so-called "), _c('em', [_vm._v("Numeruswechsel")]), _vm._v(") were an indication of sources. But these theses failed to gain acceptance (von Rad 1962a, 832; Lohfink 1963a, 240; Fohrer 1968, 171; Hillers 1964a, 32–33), even along lines later proposed by Minette de Tillesse (1962). Lohfink considers the change to be a stylistic device, which it probably is (Begg 1994). G. Ernest Wright (p. 362) says: “Hebrew writers have the disconcerting habit of completely disregarding consistency in the use of pronouns (cf. e.g., 6:4 with 6:5; 6:13 with 6:14; 6:16–17 with 6:18–19),” and he discounts attempts to find different ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("sources in the singular and plural use of pronouns. I take the shift to be simply another facet of the celebrated Deuteronomic rhetoric: the singular “you” perhaps addressing the people as a whole, and the plural “you” addressing each person individually and emphatically (= “each and every one of you”). Shalom Paul (1991, 150) sees the shift from plural to singular in Amos 4:12 to be just the reverse, saying that with the singular in 4:12 “the impending chastisement is now addressed individually to each member of the nation.” Tigay (1996, 62) says the same with regard to Deueronomy: the singular emphasizes the responsibility of each individual, and the plural is used to emphasize Israel’s collective responsibility. Milgrom took this same position in responding to a paper of mine read at the Albright Institute in Jerusalem on 3 February 2005. Either way, we have support for the idea that “individual responsibility” does indeed exist in Deuteronomy and the Deuteronomic History (Albright 1957b, 326). Even Weinfeld (1992b, 174), who thinks the exchange may indicate different layers in the text, concludes by saying: “In general the interchange reflects stylistic variations introduced by the same author.” Sonsino (1980, 198), too, having compared the Deuteronomic discourse with the ANE treaties, treaty curses, and royal inscriptions, remarks:")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("These extra-biblical examples show that the particular grammatical inconsistencies noted in the biblical texts are really part of the normal literary style of the ancient Near East and need not be explained by recourse to a theory of editorial reworking.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("No consensus has therefore emerged on what portion of the present book may confidently be assigned to "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" (Eissfeldt 1965, 173–76; Fohrer 1968, 169–72). There is simply general agreement that the 622 lawbook contained at most chapters 5–26, 28 (Freedman 1962, 715; Nicholson 1967, 22; Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1574), and it may well have contained less. Von Rad (1962a, 832) stated more than forty-five years ago: “Obviously the zeal for literary analysis has flagged for a long time.” The quest for "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" had reached a dead end, with nothing more known about the contents of "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" than was purportedly known at the turn of the century (Lundbom 1976, 294).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORTHERN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROVENANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Another search into Deuteronomy’s prehistory was carried out during the last century, viz., an inquiry into the book’s provenance. It began largely with Adam Welch, who argued that the book of Deuteronomy came originally from North Israel (Welch 1924, 184–85, 190–91). Welch said the author of 27:4")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("evidently regarded the sanctuary at Ebal as being the first which was erected in Palestine, and as owing its authority to the direct command of the great lawgiver. Again we have a significant hint as to the provenance of the Deuteronomic code, for we are carried to Northern Israel and to one of its leading sanctuaries.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Welch found Deuteronomy’s mandate for a single sanctuary only in chapter 12, although he argued that 12:1–7 was a later addition (1932, 205). His view of chapter 12 did not win the day, nor also his view that Deuteronomy was composed in the tenth century, but his idea about Deuteronomy having a northern provenance had considerable impact (Albright 1957b, 315; G. E. Wright, 326; von Rad 1962a, 836; 1966a, 94; Nicholson 1967, 58–82; Fohrer 1968, 175).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The view of Alt (1953b) that Deuteronomy was a restoration program in North Israel after the fall of Samaria in 722 has little to recommend it, and is best laid to rest (Nicholson 1967, 80–81). The two passages testing for inauthentic prophets, in chapters 13 and 18, seem to me to be a legacy of Northern Israel’s experience with prophets during the reign of Ahab (Lundbom 1996, 309–12). Nicholson (1967, 69) sees “vital contacts between Deuteronomy and the teaching of the prophetic party in northern Israel,” saying that a good case can be made for Deuteronomy owing its origin to prophetic circles in northern Israel (p. 79).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Others have argued that Deuteronomy originated largely in Judah (Lohfink; Weinfeld), perhaps even before the time of Hezekiah. The passage on judges in 16:18–20 points to the reign of Jehoshaphat (873–849), who carried out a judicial reform in Judah (2 Chr 19:4–11) and is reported by the Chronicler as having sent out princes and Levites to teach people the law (2 Chr 17:7–9). Ahab reigned in the north and Jehoshaphat in the south during the mid-ninth century, with both the Deuteronomic Historian and the Chronicler reporting good relations between the two kings (1 Kgs 22:45[44]; 2 Chr 18:1–3). Ahab is not likely to have sponsored an early Deuteronomic program, but Jehoshaphat could have (Albright 1957b, 320).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the book of Deuteronomy or portions of it did originate in North Israel, that book was most likely brought to Jerusalem after the fall of Samaria in 722. Fohrer (1968, 175) thinks it was deposited in the temple in the time of Hezekiah. To what extent it could have played a role in Hezekiah’s reform before coming to light in the time of Josiah is the question to which we now turn.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EZEKIAH")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORM")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("De Wette’s view that Deuteronomy was written shortly before its discovery in the temple has been challenged over the years, by many rejected outright, ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("largely because the time span between the young Josiah’s accession in 640 and the discovery of the lawbook in 622 is too brief. It is usually assumed that the newly found lawbook had been lost for some time (Driver 1895, liv–lv), for which reason many scholars have pushed back the date of Deuteronomy’s composition to the reigns of Manasseh (687–642) or Hezekiah (715–687). Manasseh’s reign was nearly a half-century of idolatrous worship, yet some argue that during this time a reform document could have been written for the future, if and when an opportunity came for its use (Nicholson 1967, 101–2). Still, it is a stretch to imagine a vibrant document like Deuteronomy being written during the reign of Manasseh. Pfeiffer (1948, 180) says: “During the reign of Manasseh D[euteronomy] would have been consigned to the flames, like Jeremiah’s book later on (Jer. 36:23).”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A reform document such as Deuteronomy is more likely to have emanated from a reform in progress (like documents of the Reformation, or more recently Vatican II), favoring the reign of Hezekiah over the reign of Manasseh. In the Bible, a reform by Hezekiah is reported briefly in 2 Kgs 18:4, 22[= Isa 36:7], where it says that Hezekiah removed high places, altars, and other objectionable cult symbols in a move to purify Yahweh worship and centralize it in Jerusalem. In 2 Chronicles 29–31 this reform gets extended coverage. The Chronicler states that the good king began in his first year to make repairs in the temple (2 Chr 29:3), concluding his reform and other faithful acts before Sennacherib invaded Judah and encamped against its fortified cities (2 Chr 32:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wellhausen (1957, 25) did not believe such a reform ever took place. He doubted the report in 2 Kings and dismissed out of hand the account of the Chronicler who, in his view, was not a credible historical source. More recently Na‘aman (1995) and Fried (2002) have challenged the results of archaeological studies pointing to a reform by Hezekiah, stating that the research does not support a reform. Besides being dismissive of the biblical accounts, they both misconstrue and outrun the archaeological evidence they cite and base too much on “arguments from silence.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The Deuteronomic Historian and the Chronicler agree that Hezekiah carried out reforming activities at the beginning of his reign. There are, to be sure, chronological problems associated with Hezekiah’s accession and uncertainty too about the campaign(s) of Sennacherib against Judah and Jerusalem; nevertheless, a window of opportunity for carrying out a reform is arguable between 712 and 701 (Rainey 1994, 333 says between 715 and 701). Many scholars have accepted the biblical testimony that Hezekiah did carry out a reform, one that did away with objectionable objects of worship and aimed at creating a central sanctuary in Jerusalem. This reform was short-lived (Nicholson 1967, 99: between 705 and 701), as many reforms are, but not so short-lived that Deuteronomy ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("could not have been written while it was in progress, or else soon after. Freedman (1987d, 20–26) argued that the books of the eighth-century prophets, Amos, Hosea, Isaiah, and Micah, were assembled during the reign of Hezekiah to mark the destruction of the northern kingdom by the Assyrians in 722, the reason being that Israel failed to repent of its rebellion against Yahweh and gross violation of covenant demands, also because of Judah’s deliverance from the Assyrians in 701, at which time Hezekiah repented of his rebellion and violation of covenant demands (cf. Jer 26:19). Freedman says: “Only a king of such stature and ethical sensitivity, as Hezekiah is described to be, could and would have encouraged such a work” (Freedman 1987d, 24).")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Most current scholars state their views on the composition of Deuteronomy in general terms, usually content to say that the book was written in the seventh century, or between the reigns of Hezekiah and Josiah. It is difficult to be more precise when we do not know more. For a fuller discussion of Hezekiah’s reform and issues related to the reform, see Excursus 1.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_vm._v("A N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEST FOR")]), _vm._v(" "), _c('em', [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RDEUTERONOMIUM")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Since Wellhausen, a change has taken place in appraising the work of the Chronicler. Wellhausen believed the Chronicler was late and unreliable. Welch (1939) viewed the Chronicler more positively, but his assessment has been largely ignored. The change occurred with Albright (1957b, 273; 1963, 76–77), whose views survived in the work of his students: John Bright (1981, 229), also Frank M. Cross and David Noel Freedman (1953). Cross and Freedman pointed out that so far as the Josianic reform was concerned, the Chronicler’s scheme of events correlated better with the extrabiblical records documenting Assyria’s decline. Nicholson (1967, 11–12) in his overview therefore concludes that the Chronicler’s report of the Josianic reform is basically reliable, which is what Albright concluded about the Chronicler’s report of the reform of Hezekiah.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In an earlier work (Lundbom 1976), I proposed that the Chronicler’s account of the Josianic reform be given precedence over the account of the Deuteronomic Historian (DH), which would mean putting the main purge of pagan worship in 628, rather than 622, and seeing the legal portions of Deuteronomy as being the moving force behind the reform activity in that year. Deuteronomy 5–26, 28—or better, Deuteronomy 1–28—was not the lost lawbook. The lawbook newly found in 622 was the much briefer Song of Moses in Deuteronomy 32.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Two lines of evidence point to one and the same conclusion. The first is this: Two stanzas of the Song of Moses (Deut 32:15–22) compare closely in content to a portion of Huldah’s oracle in 2 Kgs 22:16–20. Huldah was the prophetess ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("to whom Hilkiah went with the lawbook in order to obtain a divine oracle. She heard the scroll read, or else read it herself, and responded with a two-part oracle, the first part directed to the nation (vv. 16–17) and the second part to the king (vv. 18–20). It is the first part that draws upon the Song of Moses. The relevant texts are the following:")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("Deut 32:15–22")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיִּשְׁמַן יְשֻׁרוּן וַיִּבְעָט שָׁמַנְתָּ עָבִיתָ כָּשִׂיתָ")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("יַקְנִאֻהוּ בְּזָרִים בְּתוֹעֵבֹת יַכְעִיסֻהוּ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיִּטֹּשׁ אֱלוֹהַ עָשָׂהוּ וַיְנַבֵּל צוּר יְשֻׁעָתוֹ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("יִזְבְּחוּ לַשֵּׁדִים לֹא אֱלֹהַ אֱלֹהִים לֹא יְדָעוּם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֲדָשִׁים מִקָּרֹב בָּאוּ לֹא שְׂעָרוּם אֲבֹתֵיכֶם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("צוּר יְלָדְךָ תֶּשִׁי וַתִּשְׁכַּח אֵל מְחֹלְלֶךָ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיַּרְא יְהוָה וַיִּנְאָץ מִכַּעַס בָּנָיו וּבְנֹתָיו")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיֹּאמֶר אַסְתִּירָה פָנַי מֵהֶם אֶרְאֶה מָה אַחֲרִיתָם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי דוֹר תַּהְפֻּכֹת הֵמָּה בָּנִים לֹא־אֵמֻן בָּם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("הֵם קִנְאוּנִי בְלֹא־אֵל כִּעֲסוּנִי בְּהַבְלֵיהֶם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַאֲנִי אַקְנִיאֵם בְּלֹא־עָם בְּגוֹי נָבָל אַכְעִיסֵם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי־אֵשׁ קָדְחָה בְאַפִּי וַתִּיקַד עַד־שְׁאוֹל תַּחְתִּית")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַתֹּאכַל אֶרֶץ וִיבֻלָהּ וַתְּלַהֵט מוֹסְדֵי הָרִים")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("22")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kgs 22:16–17")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כֹּה אָמַר יְהוָה")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("הִנְנִי מֵבִיא רָעָה אֶל־הַמָּקוֹם הַזֶּה וְעַל־יֹשְׁבָיו")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵת כָּל־דִּבְרֵי הַסֵּפֶר אֲשֶׁר קָרָא מֶלֶךְ יְהוּדָה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תַּחַת אֲשֶׁר עֲזָבוּנִי וַיְקַטְּרוּ לֵאלֹהִים אֲחֵרִים")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לְמַעַן הַכְעִיסֵנִי בְּכֹל מַעֲשֵׂה יְדֵיהֶם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וְנִצְּתָה חֲמָתִי בַּמָּקוֹם הַזֶּה וְלֹא תִכְבֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("Deut 32:15–22")])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerseSb"
  }, [_vm._v("Yes, Jeshurun got fat and kicked;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("you got fat, you grew thick, you became gorged.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_c('em', [_vm._v("Then he abandoned the God")]), _vm._v(" who made him,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("and took to be foolish the Rock of his salvation.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They made him jealous with strangers,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("with abominations "), _c('em', [_vm._v("they provoked him")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They "), _c('em', [_vm._v("sacrificed")]), _vm._v(" to demons, "), _c('em', [_vm._v("no gods")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("gods they had not known.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("New ones recently come in,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("your fathers were not awed by them.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_c('em', [_vm._v("The Rock")]), _vm._v(" that begot you, "), _c('em', [_vm._v("you neglected")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("and you forgot the God")]), _vm._v(" who bore you in travail.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerseSb"
  }, [_vm._v("So Yahweh saw and spurned")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("because of "), _c('em', [_vm._v("the provocation")]), _vm._v(" of his sons and daughters.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("And he said, I will hide my face from them,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("I will see what their end will be.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("For a generation of perversities they are,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("children in whom is no faithfulness.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They, they have made me jealous with a no-god,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("they provoked me with their nothings")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("So I, I will make them jealous with a no-people,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("with a foolish nation I will provoke them.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("For "), _c('em', [_vm._v("a fire is kindled in my anger")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("and it will burn to the depths of Sheol")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("Yes, it will consume the earth and its yield")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("and set ablaze the mountains’ foundations.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kgs 22:16–17")])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("Thus says Yahweh:")]), _vm._v(" "), _c('p', {
    staticClass: "TVerse1"
  }, [_vm._v("Behold I will bring evil upon this place and upon its inhabitants—all the things of the book which the king of Judah has read.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("Because "), _c('em', [_vm._v("they have forsaken me and have burned incense to othergods")]), _vm._v(", that "), _c('em', [_vm._v("they might provoke me with all the work of their hands. Therefore my wrath will be kindled against this place and it will not be quenched")]), _vm._v(".")])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("One can immediately see that while the vocabularies of the two passages are somewhat different, the substance is the same. In both we note: (1) that Israel is indicted because she has "), _c('em', [_vm._v("forgotten")]), _vm._v(" Yahweh and "), _c('em', [_vm._v("provoked him by sacrificing to other gods;")]), _vm._v(" and (2) that Yahweh’s "), _c('em', [_vm._v("wrath")]), _vm._v(" is promised to "), _c('em', [_vm._v("burn")]), _vm._v(" in judgment like an "), _c('em', [_vm._v("unquenchable fire")]), _vm._v(". Huldah has restated the message of the Song in the current idiom, or else the DH has stylized her speech using the current idiom (so Driver 1895, xlv). The result, in either case, is the oracle as we now have it. Since this exact combination of ideas is not to be found elsewhere in the OT in the way it appears in these two passages, we may conclude that Huldah drew the substance of her indictment against Israel from the Song of Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second bit of evidence comes from a rhetorical structure in the prose frame to the Song. In Deut 31:24–30 and 32:44–46 a keyword chiasmus makes Moses’ “song” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שִּׁירָה")]), _vm._v(") into a “law” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תּוֹרָה")]), _vm._v("), with “words” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("דְּבָרִים")]), _vm._v("), a good Deuteronomic term, mediating in between:")]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַתּוֹרָה־הַזּאֹת")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("31:24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵת הַדְּבָרִים הָאֵלֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he2"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַשִּׁירָה הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he2-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי הַשִּׁירָה־הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("32:44")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־הַדְּבָרִים הָאֵלֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי הַתּוֹרָה הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("46")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("31:24")])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("28")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse1"
  }, [_c('em', [_vm._v("these words")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse2"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this song")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("32:44")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse2-t"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("this song")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("45")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse1"
  }, [_vm._v("all "), _c('em', [_vm._v("these words")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("46")])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("this law")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("One final piece of evidence serves to connect the Song of Moses to the lawbook of 622. The expression, "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("סֵפֶר הַתּוֹרָה")]), _vm._v(" (“book of the law”), which in Deut 31:26 refers to the scroll on which the Song of Moses—not the entire Deuteronomic code—was written, occurs also in 2 Kgs 22:8, where it refers to the temple lawbook. The identification is thus complete: "), _c('em', [_vm._v("Deuteronomy 32 is the lawbook Hilkiah found in the temple in 622")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some scholars (Kaufmann 1960, 175; Holladay 1966, 26; 2004, 73–74) have suggested that the Song of Moses be included in "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(", but if added to a document containing 5–26, 28, or 1–28, we have a scroll rather large to have been read three times in one day. It is possible, but not likely. It is better, therefore, to take only the Song of Moses as the lawbook of 622. In my view, the Song is the core of the second supplement (chs. 31–34) to the First Edition, this supplement having been added after the Song’s discovery in the temple. This final expansion in our present book of Deuteronomy could have been completed in the latter years of Josiah, at the same time the First Edition of the Deuteronomic History was written.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("What then are we to make of the narrative in 2 Kings 22–23, which leads us to believe that all the reform activity came about because of the lawbook’s discovery in 622? The passage out of chronological order in the scheme of the DH appears to be 2 Kgs 23:4–20. The purge reported there took place six years earlier (2 Chr 34:3–7). My solution would be to take 2 Kgs 23:4–20, which describes the purge, as a separate account that the DH has incorporated into his narration of the Josianic reform. It speaks of the “book of the covenant” (2 Kgs 23:2–3, 21), which as Carpenter (1883, 277) noted years ago, was a title well-suited for the Deuteronomic Code, beginning as it does with the “covenant” of ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Horeb and ending with the “covenant” of Moab (5:2; 28:69 [29:1]). We can then proceed to discover another rhetorical structure for 2 Kgs 22:8–23:25, even if we remain unable to judge the DH’s knowledge or lack of knowledge about how the reform activity actually played out. It is reasonable to assume that he did know the actual sequence of events, simply choosing for whatever reason to schematize his reporting of them.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The DH intends to make the purge the center and climax of his narrative. We know it is the climax because of the space he gives it: seventeen verses compared to five by the Chronicler. But it is also the center, as we can see by observing a keyword chiasmus in the prose frame to the account. This is a structure similar to the one framing the Song of Moses in Deut 31:24–30 and 32:44–46:")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kings 22:8–23:25")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("סֵפֶר הַתּוֹרָה מָצָאתִי בְּבֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("22:8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי סֵפֶר הַתּוֹרָה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי סֵפֶר הַבְּרִית הַנִּמְצָא בְּבֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("23:2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַבְּרִית הַזּאֹת הַכְּתֻכִים עַל־הַסֵּפֶר הַזֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "he2-t"
  }, [_vm._v("Account of the Purge")])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("4–20")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כַּכָּתוּב עַל סֵפֶר הַבְּרִית הַזֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַתּוֹרָה הַכְּתֻבִים עַל־הַסֵּפֶר אֲשֶׁר מָצָא … בֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כְּכֹל תּוֹרַת מֹשֶׁה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("22:8")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("I have found "), _c('em', [_vm._v("the book of the law")]), _vm._v(" in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("the words of "), _c('em', [_vm._v("the book of the law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("23:2")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2Sb"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("the book of the covenant")]), _vm._v(" that")]), _vm._v(" "), _c('p', {
    staticClass: "Verse3"
  }, [_vm._v("had been found in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this covenant")]), _vm._v(" that were written in "), _c('em', [_vm._v("this book")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("4–20")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse3Sb"
  }, [_vm._v("Account of the Purge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("21")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2Sb"
  }, [_vm._v("as it is written in "), _c('em', [_vm._v("this book of the covenant")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("24")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "VerseSb"
  }, [_vm._v("the words of "), _c('em', [_vm._v("the law")]), _vm._v(" that were written in "), _c('em', [_vm._v("the book")]), _vm._v(" that")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1Sb"
  }, [_vm._v("[Hilkiah] … found in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("25")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("according to all "), _c('em', [_vm._v("the law of Moses")])])])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The account in 2 Kgs 22:8–23:25 is a conflation at two points: (1) it combines the purge of 628 with whatever reform measures took place in 622, making ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("it appear that Josiah undertook a single purge of pagan worship centers after the lawbook was found; and (2) it combines a “(book of the) law” from Moses (22:3–20; 23:24–25) with a “book of the covenant” (23:1–3, 21–23), making it appear that a single temple scroll inspired Huldah’s oracle, formed the basis for Josiah’s covenant renewal ceremony, led to the purge of pagan worship centers, and guided the king to host the grandest Passover in Jerusalem since the days of the Judges. The “(book of the) law” was the Song of Moses (32); the “book of the covenant” was the First Edition of Deuteronomy (1–28). A conflation of the same sort occurred in Deuteronomy 31–34, where the Song of Moses was integrated into the First Edition of Deuteronomy and made a part of Moses’ ever-expanding collection of “torah” (Lundbom 1990).")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Some earlier scholars believed that 2 Kings 22–23 altered or schematized events in Josiah’s reign in order to create the impression that Deuteronomy was Josiah’s lawbook, but they did so to argue for an exilic or postexilic date of Deuteronomy (Nicholson 1967, 4–7). I agree that the events in 2 Kings 22–23 have been schematized to create the impression desired by the DH, but I do not think an exilic or postexilic date for the book is at all likely. As noted earlier, 2 Kings 22–23 is the climax to a First Edition of the Deuteronomic History, in my view a preexilic work.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UESTION OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHORSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("With critical theory concluding that Moses was not the author of Deuteronomy, nor of the Pentateuch as a whole, the question was then: “Who wrote Deuteronomy?” Carpenter (1883), Driver (1895, xxv–xxix), and others emphasized the prophetic character of Deuteronomy, Driver believing that the work, although legal in nature, nevertheless built on foundations laid by the prophets, mainly Hosea and Isaiah. He called Deuteronomy a “prophetic lawbook.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Along with Wellhausen and others of his time, Driver saw the prophets as moral giants in ancient Israel, individuals who “held up before the people high conceptions of life and duty.” Deuteronomy was the spiritual heir of Hosea, joining him in repudiating nature worship and acknowledging Yahweh as the true giver of earth’s bounty. Driver says Deuteronomy agreed with Hosea in giving prominence to the emotional side of religion—love, affection, and sympathy are all present, particularly love. This love is a moral love, limited when necessary by the demands of righteousness; thus idolatry and immorality cannot be tolerated or condoned by it.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Driver pointed to the monotheistic creed of Deuteronomy (4:35, 39; 6:4; 7:9; 10:17) as another development of prophetic teaching. Deuteronomy preaches and teaches monotheism more formally and explicitly than earlier ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("biblical books. The single sanctuary, in his view, was the corollary to the monotheistic idea. That worship at one Jerusalem altar developed later into a false religion of security (Jer 7:1–15) did not render invalid Deuteronomy’s view at an earlier stage.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("At the same time, Driver (1895, xxx) says that with priestly institutions the author of Deuteronomy has greater sympathy than with prophets generally. He evinces a warm regard for the priestly tribe; he guards its privileges (18:1–8), demands obedience for its decisions (24:8; cf. 17:10–12), and commends its members to Israelite benevolence (12:18–19; 14:27, 29, etc.). This author has no desire to see ceremonial observances current at the time abolished; sacrifice, though not emphasized, is taken for granted. Offerings on which Deuteronomy lays the greatest stress are those expressive of gratitude to God as Giver of all good things in the land (14:22–27; 15:19–23; 16:10, 15, 17; 26:10). Religious feasts are to be occasions of gladness before Yahweh and a display of generous hospitality towards the destitute (12:7, 12, 18; 14:26–27; 16:11, 14; 26:11). In Deuteronomy the tribe of Levi is confirmed in its possession of priestly rights, and it alone is to supply ministers for the sanctuary (Driver 1895, xxv).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The term “Levites” in Deuteronomy refers to all priests. The expression, "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כֹּהֲנִים הַלְוִיִּם")]), _vm._v(", “the priests, the Levites” (= the Levitical priests), appears in 17:9, 18; 18:1; 24:8; 27:9 and other literature earlier than Nehemiah, e.g., Josh 3:3; 8:33; Jer 33:18; Ezek 43:19; 44:15. It need not be taken, then, as an archaism by someone writing in the postexilic period. According to Levine (1993, 104–5, 449, 450), stratification of the tribe into two groups, priests and Levites, first occurs explicitly in Numbers (chs. 3–4, 8, 16–17). There is no reference to the subordination of Levites in Exodus. On the priests and Levites, see further G. E. Wright (1954) and Emerton (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The question of authorship, therefore, took a different turn with von Rad (1953; 1962a, 835–37), who believed that although Deuteronomy reflected an ancient Shechemite cultic festival (11:26–32), the preachers behind its sermons were post-701 Levitical priests from the Judean countryside. Von Rad cites Neh 8:1–8, where the Levites instruct as Ezra reads people the law. The Chronicler, too, makes numerous references to the Levites as teaching priests (2 Chr 15:3; 17:7–9; 35:3). One notes that Deut 31:9 says the Deuteronomic code, after being written down by Moses, was put into the hands of the Levitical priests. In Deut 20:2–4, too, the (Levitical) priests have a prominent role in addressing people before Israel is to go to war. Von Rad’s views were accepted by G. E. Wright, Muilenburg (1959, 348–350), and others, with Wolff (1956) arguing that Deuteronomy owed its origin to Levites in northern Israel who had been excluded from sanctuaries at Bethel and Dan by Jeroboam I (1 Kgs 12:31–32). Hosea, in Wolff’s view, was linked to this circle of Levites.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Priestly authorship of Deuteronomy came under scrutiny with Weinfeld ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("(1967; 1972, 158–71; "), _c('em', [_vm._v("EncJud")]), _vm._v(" 5:1578–79), who argued that the authors of Deuteronomy were scribes. Weinfeld agreed that Deuteronomy contained material of northern provenance, but was not surviving oral torah from preaching Levites. What we have in Deuteronomy is rather a written document compiled by scribes of the Jerusalem court. Such a conclusion, he argues, is supported by wisdom elements in the book, e.g., the education of children and various humanistic laws, which have no counterpart in any other pentateuchal book (Weinfeld 1960a). Numerous parallels exist also between Proverbs and Deuteronomy, e.g., Deut 19:14 with Prov 22:28; Deut 23:17 [16] with Prov 30:10; and Deut 25:13–16 with Prov 20:10, 23. Citing ANE treaty parallels to Deuteronomy, Weinfeld argues that scribes must have authored Deuteronomy, since only they would have been familiar with the treaty structures.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Weinfeld makes his case for scribal authorship of Deuteronomy, but his case against priestly authorship falls short of being decisive. Besides the evidence that von Rad presents for priestly authorship are biblical texts putting the torah in the hands of priests (Jer 18:18; Ezek 7:26). Also, 2 Chr 34:13 tells us that “some of the Levites were scribes,” which indicates that Weinfeld may have overdrawn his separation of the two vocations. This reference in Chronicles is important, since it occurs in the context of the Josianic reform. In Nehemiah 8, Ezra is called both “Ezra the priest” and “Ezra the scribe” (Neh 8:1, 9). If these overlaps in terminology correspond to reality in preexilic times, which is not hard to imagine (Mowinckel 1955, 206; Muilenburg 1970a, 230–31), Weinfeld’s argument that Deuteronomy is authored by scribes, not Levites, loses much of its force. The authors of Deuteronomy could have been both Levites and scribes. Finally, a presence of wisdom elements in Deuteronomy is not a sure pointer to scribal authorship. Amos and Jeremiah are brim full of wisdom teaching, and both are prophets, not scribes. Priests, scribes, and prophets from the eighth to sixth century, all shared a common intellectual and rhetorical tradition, fully capable of producing the discourse and teaching of Deuteronomy.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("ANCIENT NEAR EASTERN TREATIES")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("By the mid-1950s the focus of Deuteronomy studies had shifted to the Hittite vassal treaties (1450–1200) unearthed at Boghazköy, published two decades earlier. George Mendenhall, in an important study (1955), pointed out the formal similarities between these treaties concluded between suzerains and their vassals, and the biblical covenants. Dennis McCarthy (1963, 109–40) went on to make it even more clear that the covenant form in Deuteronomy was the real beneficiary of the new comparison. Hittite treaties typically contained six elements: (1) a preamble, introducing the speaker (cf. Deut 1:1–5); (2) a historical ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("prologue (cf. chs. 1–4); (3) the stipulations (cf. chs. 5; 12–26); (4) provisions for depositing the document in the temple and a periodic reading (31:9–13, 26); (5) a list of the gods as witnesses (no parallel in Deuteronomy); and (6) blessings and curses (cf. chs. 27–28).")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1958 D. J. Wiseman published the Vassal Treaties of Esarhaddon, which were shown to have striking parallels to the maledictions in Deuteronomy 28. Subsequent studies have therefore focused on these treaties rather than those of the Hittites (D. J. McCarthy 1963, 68–79; Weinfeld 1991, 6–9; 1972, 59–157; 1976a; 1992b, 169–171), one reason being that they date from the same time as Deuteronomy, the seventh century. After examining these treaties, Weinfeld judged Deuteronomy to be a “loyalty oath” imposed by a suzerain (Yahweh) on his vassal (Israel) prior to a leadership change (Moses to Joshua). Similarities between the two were seen to extend even into the language, e.g., the terms for loyalty in both were “to go after” (= to follow), “to fear,” and “to hearken to the voice of”; and in both the vassal was commanded “to love” the suzerain “with all the heart and all the soul” (cf. Deut 6:5). On the use of the term “love” in the ANE treaties, see Moran 1963b. It is now generally accepted that these international treaties—both Hittite and Assyrian—influenced the form of the biblical covenants, particularly Deuteronomy (Weinfeld 1991, 9). Phillips (1983, 2) argues that the treaty form entered Israelite theology only after the fall of the northern kingdom, which would bring it into the time when Deuteronomy was written.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("ANCIENT HEBREW RHETORIC")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-20",
    attrs: {
      "id": "sec2-7"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HETORICAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROSE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Since the beginning of pentateuchal criticism it has been recognized that Deuteronomy has a distinctive rhetorical style, characterized by stereotyped vocabulary and phraseology (Driver 1895, lxxvii–xci; 1913, 99–102; Weinfeld 1972, 320–65). Its prose teems with "), _c('em', [_vm._v("accumulatio")]), _vm._v(", i.e., nouns heaped up in twos, threes, and fours, and longer phrases balanced rhythmically in parallelism, also "), _c('em', [_vm._v("asyndeton")]), _vm._v(". This prose occurs also in the Deuteronomic History, particularly Kings, and in the book of Jeremiah (Lundbom 1999, 126–27). Deuteronomy, according to Driver, is fond of the emphatic form of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וּן")]), _vm._v(" in the second and third person plurals of the Imperfect, of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֵבָב")]), _vm._v(" (47x) over "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֵב")]), _vm._v(", and of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אָנֹכִי")]), _vm._v(" (56x) over "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֲנִי")]), _vm._v(". He believes these preferences are probably due to the writer’s sense of what harmonized best with the oratorical rhythm of his discourse. In Deuteronomy also are the frequent changes between second singular and second plural forms, about which we spoke earlier, and these must be reckoned as another rhetorical feature of Deuteronomic discourse.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REACHED")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Gerhard von Rad, following the lead of August Klostermann (1893), said of Deuteronomy in comparison to the Book of the Covenant:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Deuteronomy is not divine law in codified form, but preaching about the commandments—at least, the commandments appear in a form where they are very much interspersed with parenesis. (von Rad 1953, 15; cf. 1966b, 30)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The point was made also by Breit (1933) and by Driver in his "), _c('em', [_vm._v("Deuteronomy")]), _vm._v(" commentary. Driver saw Deuteronomy’s rhetorical discourse as aiming to inculcate religious and moral principles, being therefore of greater importance than the historical and legislative discourse in the book (Driver 1895, xix, lxxvii–lxxxviii). So far as Deuteronomy being a lawbook was concerned, Driver took it as a manual addressed to the people intended for popular use (Driver 1895, xxvi). H. Wheeler Robinson (1980, 3) said the exhortations in Deuteronomy could be compared with a sermon:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("It is a sermon so reported as to preserve the spiritual warmth of a Bernard preaching the Crusade, the flaming zeal of a Savonarola kindling the Florentine fire of vanities; whilst with this more passionate feeling against idolatry there is a noble humanitarianism, a consideration for the stranger and the helpless, an appeal to deep human sympathies, not unworthy of a Francis of Assisi.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Von Rad’s desire was to advance the study of Deuteronomy from a rhetorical and homiletical standpoint. His method was form criticism, worked out with consummate skill in “The Form-Critical Problem of the Hexateuch” (1966b) and "), _c('em', [_vm._v("Studies in Deuteronomy")]), _vm._v(" (1953). Von Rad also initiated a search for Deuteronomy’s "), _c('em', [_vm._v("Sitz im Leben")]), _vm._v(" (“situation in life”), paying particular attention to Deuteronomy 27 and Joshua 24. He concluded that Deuteronomy reflected a covenant renewal ceremony at Shechem, appropriating the view of Adam Welch (1924) that the book’s provenance was northern Israel. But, as we have said, von Rad viewed the preachers behind Deuteronomy’s sermons as post-701 Levitical priests from the Judean countryside (2 Chr 17:7–9). In any case, Deuteronomy contained all the marks of a scroll having been read aloud to a gathered assembly.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HETORIC AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMPOSITION")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Despite the consuming interest in treaty forms among Deuteronomy scholars of the past half-century, James Muilenburg felt in the 1950s that more work in this homiletical treasure needed to be done along rhetorical lines. He said:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("the large and varied terminology associated with covenantal formulations requires closer attention, the composition and rhetoric and structural forms need to be studied more carefully. (Muilenburg 1959, 348)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("To some extent it was already being done. In the 1960s, Roman Catholic scholars at the Pontifical Biblical Institute in Rome were applying to the Old Testament a method of rhetorical research practiced earlier in the century by Scripture scholars such as A. Condamin (1905; 1920; 1933), A. Bea, and H. Galbiati (Lohfink 1960, 123 n. 2). Two scholars were engaged in Deuteronomic research: William L. Moran (1969), and Norbert Lohfink (1963a; 1968). On the Protestant side, foundational work on “chiasmus” had been done by University of Chicago—trained Nils W. Lund (1930; 1933; 1942), dean of North Park Theological Seminary in Chicago. The methods these scholars employed were not unlike Muilenburg’s own (1953; 1956; 1969), seeking to locate in the text keyword, motif, and speaker distributions forming inclusios and chiasms (concentric inclusions).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Lohfink (1963b; 1976, 229), in discovering these structures, did not concur with von Rad that Deuteronomy betrayed a “preaching style,” noting that the book’s language had many ties with language of the court and wisdom language, also that the international treaties possessed a rhetorical cast and were meant to be read aloud in solemn public ceremonies. With respect to Deuteronomy’s final composition, Lohfink followed Kleinert (1872, 167) in arguing that the book was an “archive,” its main divisions marked by the headings in 1:1; 4:44; 28:69(29:1); and 33:1 (Lohfink 1962, 32–34; 1968, 7–9; 1976, 229; 1992). Although not giving up entirely the view that Deuteronomy preserved traditions from northern Israel, the accent for Lohfink (1963b) was now upon a written document of Jerusalem origin, not an oral document of northern provenance.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Rhetorical work in Deuteronomy continued apace in the following decades with tangible results, e.g., the work of G. Seitz (1971). The present writer, besides the work noted earlier in connection with the Song of Moses, has shown in other studies that inclusio and framing devices are the controlling structures within Deuteronomy 1–28 (Lundbom 1996) and that a framing mode of composition has been used in Deuteronomy 29–34 (Lundbom 1990). The inclusio and chiasmus, along with other framing devices, are well attested in the poetry and prose of Jeremiah (Lundbom 1975; 1999; 2004a; 2004b), which derive ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("from the same general period. On the method of rhetorical criticism as practiced in the OT generally, and in Jeremiah in particular, see Muilenburg (1969) and Lundbom (1997).")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Rhetorical criticism has advanced our understanding of Deuteronomy’s composition at two important junctures. The summary statements of 4:44–49 and 28:69(29:1) are shown not to be superscriptions, as commonly supposed, but subscriptions, the function of which is to effect closure within the Deuteronomic discourse (Lundbom 1996). There has been ongoing debate whether 28:69 is a superscription or subscription (Nicholson 1967, 21 n. 6), perhaps in part because of the section markings before and after verse 69, and also because some MSS of the LXX, the Vg, and certain English Versions take verse 69 as 29:1. But it never seems to have occurred to earlier critical scholars that 4:44–49 could be a subscription. These verses continued to be viewed as a “second introduction” to the legal material in the book (Nicholson 1967, 19–20). But once it is recognized that the controlling structure in all of Deuteronomy 1–28 is the inclusio, it makes considerably more sense to take both 4:44–49 and 28:69 as forming inclusios with the superscription in 1:1–5 (Lundbom 1996, 302–4, 312–13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Keywords showing that the summary in 4:44–49 is intended to repeat and create an inclusio with the summary in 1:1–5 are the following:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Deut 1:1–5")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Deut 4:44–49")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("And this is the law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses spoke … all Israel")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses spoke … children of Israel")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arabah")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses … struck down")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sihon king of the Amorites")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sihon king of the Amorites")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("who dwelt in Heshbon")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("who dwelt in Heshbon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses … struck down")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Og king of the Bashan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Og king of the Bashan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arabah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("this law")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Chapters 1–4 are then the proper introduction to the Decalogue and Deuteronomic law, which is what Driver and others have taken them to be ("), _c('em', [_vm._v("pace")]), _vm._v(" Noth), but we must include all of chapter 4, not bracket out 4:44–49 as a “second introduction.” Noth may still be correct in viewing chapters 1–3(4) as an Introduction to the Deuteronomic History, but if so, the chapters take on a dual function: initially introducing the Decalogue and Deuteronomic law, then ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("later introducing the Deuteronomic History once Deuteronomy has been integrated into the Deuteronomic History. This integration will have occurred in the early exile. There is no longer any reason to follow Noth in taking Deuteronomy 1–4 as an exilic work.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In similar fashion, the summary statement in 28:69(29:1) makes another inclusio with the book’s superscription in 1:1–5 (Lundbom 1996, 312–13):")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('em', [_vm._v("These are the words")]), _vm._v(" that "), _c('em', [_vm._v("Moses")]), _vm._v(" spoke to "), _c('em', [_vm._v("all Israel")]), _vm._v(" beyond the Jordan … beyond the Jordan, "), _c('em', [_vm._v("in the land of Moab")]), _vm._v(", Moses sought to make plain "), _c('em', [_vm._v("this law:")]), _vm._v(" (Deut 1:1–5)")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('em', [_vm._v("These are the words of the covenant")]), _vm._v(" that Yahweh commanded "), _c('em', [_vm._v("Moses")]), _vm._v(" to cut with "), _c('em', [_vm._v("the children of Israel in the land of Moab")]), _vm._v(", besides the covenant that he cut with them in Horeb. (Deut 28:69[29:1])")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("The controlling structures in Deuteronomy are rhetorical, dictated by canons of Hebrew rhetoric, known and practiced in the late eighth and early seventh century. With 28:69 taken as a subscription, functioning to bring an initial work on Deuteronomic law and covenant to a conclusion, chapters 1–28 become the first identifiable book of Deuteronomy, herein called the First Edition. A written (Deuteronomic) law is referred to already in 28:58 and 61.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The process from Deuteronomy to Pentateuch can be provisionally sketched as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Deuteronomy 1–28 issued in a First Edition, perhaps in Hezekiah’s reign")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 29–30 added as a supplement to the First Edition sometime between the reigns of Hezekiah and Josiah, or in Josiah’s reign")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 31–34 added as a second supplement to the First Edition and Supplement I in Josiah’s reign, after the temple lawbook (the Song of Moses) was found in 622. The Song now becomes Mosaic “law” along with the rest of Deuteronomy (31:26; 32:46)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 1–34 made the introduction to the larger Deuteronomic History (Deuteronomy to 2 Kings), completed in the early exile")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Primary History (Genesis to 2 Kings) completed ca. 560")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Pentateuch separated from the Primary History in the postexilic period, and canonized ca. 400")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("On the completion of the Primary History and the separation of the Pentateuch, see Freedman 1962.")])]), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("THE DEUTERONOMIC LAW CODE")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The book of Deuteronomy contains the Decalogue in 5:6–21, following with its own law code in chapters 12–26, 28. In all of 5–26, 28 preaching is mixed in, with even the laws in 13–18 cast largely in homiletical form. The core of the Deuteronomic Code is casuistic law in chapters 19–25. According to 5:22, only the Decalogue was given to the people at Horeb; the Deuteronomic law was given separately to Moses (5:31), who was now presenting it to Israel in the plains of Moab (1:1–5; 4:44–49). This latter law contained the terms of the covenant made in Moab, to be distinguished from the covenant made at Horeb (28:69[29:1]; cf. 5:2–3). The Deuteronomic Code builds on earlier law in Exodus (JE), but not on Priestly law (P) contained in Exodus, Numbers, and Leviticus. It may indeed know of Priestly law, but does not build on it as systematically presented (Driver 1895, xiv). Deuteronomy also contains parallels with other ancient Near Eastern law, although the major law codes uncovered in excavations thus far are considerably older than Deuteronomy (2200 to 1300), which means one must simply be content with comparisons and contrasts, stopping short of any arguments for dependence of Deuteronomy upon older Near Eastern law.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLIER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Critical theory has reached a broad consensus that the laws of Deuteronomy build on JE legislation in the book of Exodus. Exodus 20–23 is taken to be a legal collection from the early monarchy, to which the name “Covenant Code” is given. It begins with the Decalogue in Exod 20:1–17. Other important law from this earlier period is contained in Exod 13:3–16 and 34:10–26. The main parallels between the Covenant Code and the Deuteronomic Code are these:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 21:1–11")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dut 15:12–18")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 22:15–16(22:16–17)")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 22:28–29")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 22:24–26(22:25–27)")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 24:10–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:4–5")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 22:1–4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:8")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 16:19")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:14–19")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 16:1–17")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:19b")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 14:21b")])])])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Other overlaps exist. The Covenant Code has more laws dealing with personal injury (Exod 21:18–27) and liabilities relating to animals, personal goods, and property (Exod 21:28–22:14[22:15]) than Deuteronomy. Deuteronomy does not deal with damages or civil suits, which occupy a large part of the Covenant Code. It is concerned rather with protecting human individuals, particularly ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("individuals who have little or no means of protecting themselves (Weinfeld 1961, 243; 1967, 261). The Deuteronomic Code contains only two laws on property: the law prohibiting removal of a landmark (19:14) and the law concerning just weights and measures (25:13–16). Both have parallels in Proverbs (Prov 11:1; 20:10, 23; 22:28; 23:10) and other wisdom literature of the ANE. For a fuller comparison between Deuteronomic law and the laws of Exodus, see Driver 1895, iii–xix; “Deuteronomy” in "), _c('em', [_vm._v("JE")]), _vm._v(", 4:539; Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1579–81.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-11"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Priestly laws so-called are found in Exodus, Numbers, and Leviticus. They are concerned largely with cultic practice, which includes sacrifice, purity, and ceremonies of various description. Critical theory recognizes a separate law code in Leviticus 17–26, which has come to be called the “Holiness Code” (H). It is generally agreed that Deuteronomy is not dependent upon the Holiness Code (Driver 1895, xi–xiv; Weinfeld in "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1579; Milgrom 1991, 13–35), but whether it antedates all the Priestly legislation in Exodus, Numbers, and Leviticus is a debated question. Scholars following Wellhausen believed that Priestly law, dated to the postexilic period, was later than Deuteronomic law and dependent upon it. But Weinfeld (1972, 179–89) thinks that P and D are concurrent documents emanating from two preexilic literary schools: D from the royal court and P from the temple. Priestly law has a theocentric approach; Deuteronomy is anthropocentric, having its roots in wisdom teaching. For comparisons between Priestly law and Deuteronomy, see Driver 1895, iii–xix; “Deuteronomy” in "), _c('em', [_vm._v("JE")]), _vm._v(", 4:540; Weinfeld 1972, 179–89; Milgrom 1973.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-12"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCIENT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EAR")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTERN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODES")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Archaeological excavations of the past century and a half have brought to light numerous law codes of the ANE, the major ones being:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Code of Ur-Nammu (LUN), of Third Dynasty of Ur (ca. 2050; Good 1967, 2200; cf. "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 523–25; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 408–10)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Code of Lipit-Ishtar (LI) of Isin (ca. 2017–1985; cf. "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 159–61; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 410–14)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Laws of Eshnunna (LE), author unknown, reference to King Dadusha in the superscription (ca. 1800; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 161–63; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 332–35)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Code of Hammurabi (CH), king of Babylon (ca. 1700; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 163–80; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 335–53)")])]), _c('p', {
    staticClass: "Hang"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Middle Assyrian Laws (MAL) (ca. 1400; tablets from 1100; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 180–88; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 353–60)")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Hang"
  }, [_vm._v("Hittite Laws (HL) (ca. 1300; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 188–97; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 106–19)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("To these major codes may be added fragmentary collections of Sumerian laws, e.g., “The Edict of Ammisaduqu” (1646–1626; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 526–28; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 362–64), and a fragmentary collection of “Neo-Babylonian Laws” (635–539; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 197–98; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 360–61). Older English works exist on (1) Laws of Eshnunna: Yaron (1969); (2) Old Babylonian and Neo-Babylonian laws: Johns (1904; 1914) and G. R. Driver and Miles (1952; 1955); (3) Assyrian laws: G. R. Driver and Miles (1935); and (4) Hittite laws: Neufeld (1951).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Study of these ancient nonbiblical law codes has brought to light two basic types of law in the OT: apodictic law and casuistic law. The important work here was done by Albrecht Alt. Alt noted that most of the Ten Commandments contain the second singular “you” together with an emphatic and unconditional “not” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֹא")]), _vm._v("), which makes them apodictic in form (Alt 1966c, 117–23). Commandments on keeping the Sabbath and honoring one’s parents are positive, and also stated differently. The same obtains in the Decalogue of the Covenant Code. Other laws in Deuteronomy and the Covenant Code, also in law codes of the ANE, are stated in casuistic form: “If someone does such and such, then such and such will be the punishment” (Alt 1966c, 88–103). “The ordinances” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִּשְׁפָּטִים")]), _vm._v(") of the Covenant Code (Exod 21:1) are casuistic law, beginning most often with the conjunction "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי")]), _vm._v(" (“when”). Casuistic laws in Deuteronomy 24–25 occur in the midst of apodictic laws (24:14–16; 25:4, 13–14). Casuistic laws are suited for use in a court of law. Apodictic law, more absolute than law containing provisions for punishment, has no parallel in Mesopotamian law. Alt believed that apodictic law was distinctly Israelite and that casuistic law was taken over from the Canaanites after Israel’s settlement in the land.")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-10"
    }
  }, [_vm._v("DEUTERONOMY AND THE PROPHETS")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Earlier critical scholars, as we mentioned, called Deuteronomy a “prophetic law code.” In the view of Wellhausen and his school it was the prophets who gave ancient Israel its high ethical and spiritual teaching. Deuteronomy was therefore thought to have originated among heirs to the great eighth-century prophets (H. W. Robinson 1907, 33–43; Pfeiffer 1948, 179–80; Nicholson 1967, xi). Pfeiffer believed that the teaching of the prophets, beginning with Amos, was too revolutionary to make an impact on the masses, so a Jerusalem priest, upon whom the prophetic teaching did make an impact, wrote a book of Moses that became the kernel of Deuteronomy. Whereas Amos talked about righteousness "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("as a principle (Amos 5:24), Deuteronomy went on to define righteousness as “doing the commandments” (Deut 6:25). For Deuteronomy, as for Hosea, love for God is the essence of true religion (Deut 6:5), but Deuteronomy says love must be shown in keeping the commandments (7:9; 10:12–13; 11:1, 13, 22; 19:9).")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("So while the writer of Deuteronomy may be credited for bringing the revolutionary teaching of the eighth-century prophets to the masses, it doubtless happened that Amos and Hosea gradually achieved stature among the common people, especially after the northern kingdom fell to the Assyrians in 722. The book of Deuteronomy was therefore written with another purpose in mind, viz., to establish Moses as a “prophet” in Israel, one who predicted, among other things, that another like himself would arise in the latter days to speak words that Yahweh put into his mouth (Deut 18:15–18). When the book of Deuteronomy was brought to final completion, Moses had become prophet nonpareil, one greater than all who preceded him (34:10–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Scholars of this earlier period were more or less agreed that eighth-century prophetic preaching did not betray any indebtedness to Deuteronomy (Driver). Influence seemed to be in the reverse, although this doubtless owes something to the view that Deuteronomy in its written form could not be earlier than the reign of Hezekiah. Deuteronomy knows the election of Israel, about which Amos speaks, and it learned from Hosea about the love of God and Israel’s obligation to reciprocate that love. The book, then, may very well owe a debt to the preaching of Amos and Hosea, confirming the view that its provenance is the northern kingdom of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy also contains parallels to Micah and Isaiah, prophets active in Judah in the late eighth century. But in each case influence one way or another is unclear. We must be content simply to draw parallels. With Jeremiah, influence of both the Song of Moses and core Deuteronomy is clear in the poetry and prose of this prophet, and the influence is considerable. Other seventh-and sixth-century prophets seem also to have been influenced by Deuteronomy, but parallels in diction and ideas are not what they are between Amos, Hosea, Jeremiah, and Deuteronomy. One can say, at the very least, that all the major prophets understood the conditional nature of the Horeb covenant and to this extent appropriated Deuteronomy’s message that a nation in violation of the Horeb covenant would be punished by Yahweh.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-13"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MOS")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Amos was a shepherd and dresser of vines from Tekoa, a Judahite town just south of Jerusalem (Amos 1:1). In the middle of the eighth century he was found up at the northern sanctuary of Bethel (Amos 7), preaching judgment against ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("nations of the region, especially northern Israel. Whether he preached in Israel over a longer period is not known. Judah, too, comes under indictment for rejecting Yahweh’s law and not keeping his statutes (Amos 2:4), which could lie behind Deuteronomy’s message that the covenant people must be sure to “keep the commandments, the statutes, and the ordinances” once they become settled in the land (Deut 4:1; 8:11, etc.).")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In his preaching against northern Israel, Amos has earned the reputation of being Israel’s greatest preacher of justice and righteousness, finding in this northern kingdom an appalling lack of both (Lundbom 2010a, 42–47). Among the other nations of the world, with whom Yahweh has no covenant, Amos finds inhumane and moral outrages, making them candidates, too, for punishment from Yahweh (Amos 1:3–2:3). This conception of Yahweh’s “moral government of the world” may be reflected in Deut 9:4–5, where Israel is told that Yahweh will drive out the former inhabitants of Canaan because of their wickedness (H. W. Robinson 1907, 40).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The overlap of ideas between Amos and Deuteronomy is considerable. Not all parallels have the same value as evidence, but there is reason enough to support the view that Deuteronomy was written in response to the preaching of this prophet from Tekoa. Amos, in one of his most celebrated statements, says that Israel has been elected as Yahweh’s own people, which is why Yahweh will punish her for all her iniquities (Amos 3:2). Israel’s election as Yahweh’s holy people becomes a major teaching in Deuteronomy (Deut 4:20, 34, 37; 7:6–8; 9:26, 29; 10:15; cf. 32:8–9), which states also that the nation will be punished for disobeying the commandments (7:10; 11:28; 28:15–68).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Amos knows, as we might expect, that Yahweh brought Israel out of Egypt, cared for it in the wilderness, and gave it the land of the Amorites (Amos 2:10). Deuteronomy emphasizes the same: Yahweh’s deliverance of Israel from Egypt (Deut 4:20, 37; 5:6, and passim); Yahweh’s care of the nation in the wilderness (8:2, 15; 29:4[29:5]; cf. 32:11–12); and Yahweh’s gift of land to Israel, fulfilling a promise made to the fathers (1:8, 21, 25, and passim). Amos says that Yahweh destroyed the Amorites to give Israel its land (Amos 2:9–10). Successful battles against the Amorite kings, Sihon and Og, are reported in Deuteronomy, which also reports the giving of Amorite land to Reuben, Gad, and the half-tribe of Manasseh (Deut 2:24–3:17).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Amos censures Israel for boasting about success in war being due to its own might (Amos 6:13). Deuteronomy, perhaps in response to this, says the conquest of Canaan will not be due to its own righteousness, but rather because of the wickedness of the Canaanites, and because of the promise Yahweh made to the fathers that their descendants would be given the land (Deut 9:4–6). The conquest of Canaan will succeed because Yahweh will go before Israel as the head of the army (Deut 1:30–33). Yahweh is the one who made the Exodus deliverance ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("possible, and the one who cared for Israel in the wilderness. The deliverance from Egypt was due not to Israel’s strength, says Deuteronomy, but came about because of the great strength of Yahweh (4:37–38; 9:29). So when Israel comes to inhabit the land, it must not boast that by its own strength it gained wealth in the land; the strength will come from Yahweh (8:17–18).")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Amos censures in strong terms the worship taking place at Israel’s multiple sanctuaries: Bethel, Samaria, Dan, Gilgal, and Beersheba. It is displeasing to Yahweh (Amos 3:14; 4:4–5; 5:5; 8:14). In fact, Yahweh hates the feasts and solemn assemblies (Amos 5:21–23). Deuteronomy seeks to remedy this problem by saying that Yahweh has decided now upon a single sanctuary for worship (Deut 12:5–14, and passim). At festivals carried on at this central sanctuary Yahweh wants joyful celebration (Deut 12:7, 12, 18; 14:23; 16:11, 14; 26:11; 27:7). This, too, may answer Amos’s censure of the music at the multiple sanctuaries, which to Yahweh is a disgusting noise (Amos 5:21–24). Amos says that Yahweh will turn the feasts into mourning, their songs into lamentations (8:10). The high places too, says Amos, will be made desolate (7:9). Deuteronomy forbids high place worship (Deut 12:2). What is happening at the multiple sanctuaries of Samaria, Dan, and Beersheba is that people are swearing by other gods (Amos 8:14), which Deuteronomy forbids. Israel must swear only by the name of Yahweh (Deut 6:13; 10:20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Sexual adventurism also comes under attack in Amos. Fathers and sons are having sex with the same maiden (Amos 2:7). In Deuteronomy, sexual activity is regulated by law (Deut 22:22–23:1[22:30]). In the marketplace injustice is rife, with merchants using false weights and measures (Amos 8:5–6). Deuteronomy says there must be no false weights and measures in the marketplace (Deut 25:13–16). Amos says the urban rich are oppressing the poor and needy (Amos 2:6–7; 4:1; 5:11–12; 8:4–6). In response, Deuteronomy says there must be no oppression of the poor and needy; people are to show them benevolence and generosity (Deut 1:16; 15:1–11; 24:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the heart of Amos’s message is the charge that Israel has rejected justice and righteousness (Amos 5:7; 6:12). People are oppressing the righteous (Amos 2:6; 5:12), and justice is not being carried out in the city gate (5:10, 15). So Amos says: “Let justice roll down like waters, and righteousness like an ever-flowing stream” (5:24). Deuteronomy could not agree more. It tells the people: “Righteousness, righteousness you shall pursue” (Deut 16:20; cf. 6:25; 24:13). There must be no perversion of justice to orphans, widows, or sojourners (Deut 24:17; 27:19). Yahweh, Deuteronomy points out, executes justice to orphans and widows (10:18). Amos says that judges are taking bribes (Amos 2:6; 5:12). Deuteronomy responds by saying that judges are to judge with righteous judgment, and not take bribes (Deut 16:18–19; 27:25). And it points out, once again, that Yahweh is not one to take bribes (10:17).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Israelite society is rife with corruption. People are sleeping on garments taken in pledge (Amos 2:8). The Deuteronomic Code says that the pledge of the poor cannot be slept on and must be returned to its owner at sundown (Deut 24:12–13). As for widow’s garments, they must not be taken as pledges under any circumstances (24:17). Honest testimony is not being heard in the city gate, says Amos (Amos 5:10). The Deuteronomic Code repeats the commandment about not bearing false witness (Deut 5:20) and says that malicious witnesses will be punished according to the "), _c('em', [_vm._v("lex talionis")]), _vm._v(" (19:16–21).")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Amos tells people to “seek Yahweh” and “seek the good” and they will live (Amos 5:4, 14). Deuteronomy echoes this in passing along the wisdom teaching that by obeying Yahweh and his commandments people will walk the path that leads to life (Deut 4:1; 8:1; 16:20; 30:16, 19; 32:47). Amos says that Israel should praise the name of Yahweh (Amos 4:13; 5:8; 9:6). Deuteronomy goes a step further in developing a full-blown “name” theology (Deut 12:5, 11, 21; 14:23, and passim).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Amos knows that Yahweh is the creator of heaven and earth (Amos 4:13; 5:8–9; 9:5–6). So does Deuteronomy, which says that to Yahweh belong heaven and earth and everything in it (Deut 10:14). In both Amos and Deuteronomy, Yahweh resides in the heavens (Amos 9:6; Deut 4:36; 26:15—although see Deut 23:15[23:14]). Amos says that in the past Yahweh has withheld rain (Amos 4:7). In Deuteronomy Yahweh promises abundant rain in the good land of Canaan (Deut 11:10–12; 28:12), but this hinges on Israel doing the commandments (11:13–17). Deuteronomy knows that if Israel breaks the covenant, one of the curses will be that the heavens overhead will become hard as bronze and the rain in the land will be dust and dirt (28:23–24). Amos says that Yahweh has brought blight, mildew, and pestilence upon Israel (Amos 4:9–10). Deuteronomy includes all three among its covenant curses (Deut 28:21–22; cf. 32:24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yahweh raised up prophets in Israel, says Amos, but people told them not to prophesy (Amos 2:11–12). Deuteronomy knows, too, that Yahweh raised up prophets within Israel and says it will continue in the future (Deut 18:15–22), but when society as a whole becomes hopelessly corrupt and people no longer listen to prophets who seek to reform it, Amos says Yahweh will raise up against Israel a nation to punish it for unrighteousness, injustice, and hubris (Amos 6:14). Deuteronomy agrees, saying that Yahweh will raise up against Israel a nation to punish it for not joyfully serving Yahweh (Deut 28:49–57). Amos says Israel will surely go into exile for not allowing prophets to preach (Amos 7:17). Deuternomy does not use the term “exile” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("גלה")]), _vm._v(") but does say that Israel will be scattered among the nations for covenant disobedience (Deut 4:27; 28:64–68; 29:27[29:28]).")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSEA")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Hosea was Israel’s great prophet of divine compassion (Lundbom 2010a, 48–57). Among the major Hebrew prophets, he is northern Israel’s only homegrown herald of the divine word. A contemporary of Amos, Hosea preached in the mid-eighth century, during the years just prior to the fall of Samaria and the demise of northern Israel. He may have survived the fall of Samaria, and if so would have been a contemporary of Isaiah in Judah. We don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It has long been maintained that Deuteronomy owes its greatest debt to Hosea (Driver 1895, xxvii; H. W. Robinson 1907, 40; H. L. Ginsberg 1982, 19–24; Weinfeld 1972, 366–70). Ginsberg shows how Deuteronomy echoes the diction of Hosea, ideas from Hosea, and adopts its legislation in response to the preaching of Hosea. Although northern Israel had Samuel, Elijah, Elisha, and the fearless Micaiah, no other prophet from the north has left us a written legacy of his preaching, only Hosea. H. W. Robinson said it was from Hosea, whose conception of Yahweh was the richest, that Deuteronomy derived its highest ideals. Jeremiah, later on, was also greatly influenced by Hosea in his early preaching, particularly in chapters 2–3 and 30–31 of his book (Lundbom 2004a, 371–75).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The recurring theme in Hosea’s preaching is Israel’s whoring and adultery. It exists in society at large, and the prophet uses it metaphorically to describe Israel’s abandonment of Yahweh. Israel’s daughters are guilty of whoring and adultery, but then so are the men, who are sacrificing with cult prostitutes (Hos 4:13–14; cf. Deut 22:21; 23:18–19[23:17–18]). Priests and lay people are both guilty (Hos 4:10, 12). Because the nation behaves like a whore and an adulteress (Hos 1:2; 2:4, 7[2:2, 5]; 4:15, 18; 5:3–4; 6:10; 7:4; 9:1; cf. Deut 31:16), Hosea marries a woman of this description to act out his message symbolically (Hos 1:2; 3:1). Language about “forgetting Yahweh” and “going after other gods” (Hos 2:7, 15[2:5, 13]; 3:1; 8:14; 13:6) is precisely what turns up in Deuteronomy (Deut 6:12; 8:11, 14, 19), having prominence also in the Song of Moses, which says this was Israel’s way of showing gratitude for all of Yahweh’s goodness (Deut 32:10–18). Hosea sees in Israel an unawareness that Yahweh is the one who supplied it with the grain, wine, and oil, not Baal (Hos 2:7, 10, 14[2:5, 8, 12]. Deuteronomy therefore makes it plain that Yahweh is the one who gave Israel food and drink in the wilderness and promises to bring Israel into a land that will yield abundantly. If Israel obeys the commandments, it will reap ongoing material blessing from Yahweh (Deut 6:10–15; 7:13–14; 8:3–20; 11:10–17; 28:4–5, 11–12).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("The problem in eighth-century Israel is Baal worship, to a lesser extent Asherah worship (Hos 4:12; cf. Deut 7:5; 12:3; 16:21), also idols and images associated with that worship (Hos 4:17; 8:4–5; 10:5–6; 13:2; 14:9[8]; cf. Deut 4:16–18, 25–31; 5:8–10; 7:25; 12:3; 16:21–22). Deuteronomy says the people saw no form of Yahweh at Horeb, only a voice (Deut 4:12, 15, 35–36). Hosea speaks against Israel’s ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("multiple sanctuaries: Gilgal and Bethaven (= Bethel) (4:15; 9:15; 12:12[11]; cf. Deut 12:2–4 and passim); the high places (Hos 4:13; 10:8); the feasts occurring there (2:13, 15[2:11, 13]; 9:5); the sacrifices connected with the feasts (4:13, 19[MT]; 6:6; 9:4; 11:2), and the gashing taking place at the feasts (7:14; cf. Deut 14:1–2). Yahweh has no delight in any of this, and will put an end to the feasts (Hos 2:13, 15[2:11, 13]; 8:13). Hosea judges Israel’s many altars (Hos 4:19[LXX]; 8:11; 10:1–2, 8; 12:11); the pillars by the altars (10:1–2); and the priests officiating at the altars (4:6; 5:1; 6:9), who he says will be punished (10:5) along with prophets preaching empty oracles (9:7–8; cf. Deut 13:2–6[13:1–5]; 18:20–22). Deuteronomy’s response to this is one sanctuary for the worship of Yahweh (Deut 12:5–14 and passim; H. L. Ginsberg 1982, 21).")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Hosea says that Ephraim has been “mixing with the peoples,” i.e., foreigners (Hos 7:8), and as a result has become like them. Deuteronomy therefore mandates that Israel separate itself from other peoples, particularly in worship (Deut 23:4–7[23:3–6]), so they will not adopt their abominable religious practices (Deut 4:15–20; 7:1–5; 12:29–31; 17:2–7; 18:9–14). If they do, harsh punishment will follow. Hosea says Israel will now have to return to “Egypt” (Hos 9:3, 6). At the conclusion of Deuteronomy’s curses, Yahweh says this is precisely what he will do, although it was a journey he promised would never happen (Deut 28:68; H. L. Ginsberg 1982, 20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Hosea’s view, Israel is in gross violation of Yahweh’s law and covenant (Hos 4:6; 8:1), particularly the Ten Commandments (4:2; 6:9). Injustice is not a major theme in this book, as it is in Amos, but it is there. Princes are like those who remove the landmark (Hos 5:10), a prohibition included in the Deuteronomic Code (Deut 19:14). The nation is said to behave like a trader with false balances (Hos 12:7), which may issue forth in another Deuteronomic law (Deut 25:13–15). Hosea, in hopes of reforming a sinful people, tells them to “sow righteousness” and “hold fast to steadfast love and justice” (Hos 10:12; 12:7[12:6]), qualities to be found in Yahweh (2:21[2:19]; cf. Deut 10:18). Deuteronomy has a good deal to say about the practice of justice and righteousness (Deut 6:25; 16:20; 24:13, 17; 27:19).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Hosea preaches that there is no God but Yahweh, which becomes defining theology in Deuteronomy (Hos 13:4; cf. Deut 4:35, 39; 6:4). Dominant themes in Hosea are the “love” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אַהֲבָה")]), _vm._v(" and "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֶסֶד")]), _vm._v(") Yahweh has bestowed upon Israel, particularly when it was a child (Hos 3:1; 11:1–4; Deut 4:37; 7:8; 23:6[23:5]), and the love Yahweh expects in return (Hos 12:7[12:6]; cf. Deut 6:5; 10:12; 11:1, 13; 30:16). The problem, says Hosea, is that Israel’s love is “like a morning cloud, like the dew that goes early away” (Hos 6:4). Israel loves the wrong things: cakes of raisins (3:1); sacrificial flesh (8:13); a whore’s hire on the threshing floor (9:1); and oppression resulting from deceitful practices (12:8[12:7]). At one point Yahweh says he will love Israel no more (9:15), and yet, after healing their faithlessness, ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("he will again love them freely (2:21[2:19]; 14:5[14:4]). For a list of Deuteronomy’s prototypical terminology in Hosea, see Weinfeld 1972, 364.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-15"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICAH")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Micah was a late-eighth-century prophet from a town in the Judean foothills southwest of Jerusalem, best remembered for having raised his voice against violence, injustice, and oppression in both Israel and Judah, also for preaching that Yahweh would make Samaria and Jerusalem heaps of ruins (1:2–9; 3:9–12; Jer 26:18; Lundbom 2010a, 57–62). He followed in the tradition of Amos, but parallels exist also between his preaching and the Deuteronomic Code.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Those engaged in evildoing, said Micah, were the leaders and wealthy citizens, who preyed on helpless and other unknowing folk (Mic 3:1–3, 9–11; cf. Deut 1:16; 15:1–11; 24:17). Blood was being spilled, which meant people were being murdered (Mic 3:10; 7:2; cf. Deut 5:17; 19:11–13); fields were being coveted and seized (Mic 2:2; cf. Deut 5:21), and women—probably widows—were being forced out of their houses (Mic 2:9; cf. Deut 10:18; 24:17; 27:19). Princes and judges were taking bribes (Mic 3:11; 7:3; cf. Deut 16:19; 27:25), and merchants were carrying on business in the marketplace using false scales and bogus weights (Mic 6:11; cf. Deut 25:13–16). In a memorable prophetic word, Micah says that doing justice ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁפָּט")]), _vm._v("), loving faithfulness ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֶסֶד")]), _vm._v("), and walking humbly with your God ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וְהַצְנֵעַ לֶכֶת עִם־אֱלֹהֶיךָ")]), _vm._v(") are all more important to Yahweh than burnt offerings, year-old calves, thousands of rams, and even the offering of one’s firstborn son (Mic 6:6–8; cf. Deut 5:33; 10:12–19; 16:18–20; 24:17; 25:6; 27:19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Idolatry and images were a problem for this prophet, including stone pillars and wooden posts to Lady Asherah (Mic 1:7; 5:12–13[5:13–14]; cf. Deut 5:8–10; 7:5, 25; 12:3; 16:21–22). Behind false worship lay false practitioners of religion, with Micah citing here not only diviners, sorcerers, and soothsayers (Mic 2:11; 3:7; 5:11[5:12]; cf. Deut 18:10), but (peace) prophets and priests, many of whom who were in the business mainly for money (Mic 3:5, 11; cf. Deut 18:20–22). But Micah anticipated the day when the law and Yahweh’s word would go forth from Zion (Mic 4:2[= Isa 2:3]), which could find fulfillment in the appearance of the book of Deuteronomy.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-16"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SAIAH")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Isaiah was a prophet in Jerusalem during the late eighth and early seventh century, which puts him roughly a couple decades after Amos and Hosea in the north and makes him a contemporary of Micah in the south. Isaiah is remembered ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("among other things for describing Yahweh as the “Holy One of Israel” (Isa 1:4; 5:16, 19, 24; 6:3; 8:13; 10:20; 12:6; 17:7, etc.; Lundbom 2010a, 62–78), an epithet that Deuteronomy may have known (Deut 32:51), but if so, preferred rather to express the complementary idea that Israel was Yahweh’s “holy people” (Deut 7:6; 14:2, 21; 26:19; 28:9).")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Yahweh, for Isaiah, is the one and only God, although people may not know this until his terrible “day” dawns (Isa 2:10–11, 17; cf. Deut 4:35, 39; 6:4). Along with the other prophets, Isaiah speaks out against the proliferation of idols (Isa 2:8), which are not tolerated by Deuteronomy (Deut 4:16–18; 5:8–10; 7:25; 12:3; 16:21–22). The reason given in Deuteronomy is that Israel saw no form of Yahweh in the revelation at Horeb (Deut 4:12, 15, 35–36). Isaiah says that idols and images will come under judgment in Yahweh’s future day of visitation, at which time people will literally throw them away (Isa 2:18, 20; 10:11; 30:22; 31:7).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In his indictment of the nation, Isaiah repeats the now common charges that people have forsaken Yahweh (Isa 1:4; cf. Deut 6:12; 8:11, 14, 19; 32:10–18) and rejected his law (Isa 5:24; cf. Deut 4:1; 8:11, and passim). This manifests itself in foreign religious practices, which are flourishing, and in flagrant violations of covenant law. The land is full of soothsayers, charmers, mediums, and wizards (Isa 2:6; 8:19), all of whom are outlawed in Deuteronomy (Deut 18:10–14). People are seeking out seers and prophets who speak smooth things and illusions (Isa 30:9–11; cf. Deut 13:2–6[13:1–5]; 18:20–22). A more serious covenant violation is the shedding of blood, i.e., murder (Isa 1:15, 21; 5:7; cf. Deut 5:17; 19:11–13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Along with Amos and Micah, Isaiah is uncompromising in his condemnation of injustice and oppression, particularly with regard to the poor and needy. Because of evil decrees, oppressive laws, and evasive tactics by those in power, the needy are turned aside from justice, the poor are robbed of their rights, widows become spoil and orphans become prey (Isa 3:14–15; 5:23; 10:1–2; 32:7; cf. Deut 1:16–17; 5:21; 10:18; 24:17; 27:19). No one will defend the cause of the orphan and the widow (Isa 1:23), the reason being that everyone wants a bribe (Isa 1:23; 5:23; cf. Deut 16:19; 27:25). Isaiah says the city once filled with justice has become a whore; righteousness is replaced by murder (Isa 1:21). The evil there is like that found rife in Sodom and Gomorrah (Isa 1:9–10; 3:9; cf. Deut 29:22[23]; 32:32). Yahweh, on a visit to his vineyard, looked for justice but found only bloodshed, for righteousness but heard only a cry (Isa 5:7). All this is intolerable to Yahweh, for he is exalted in justice, shows himself holy in righteousness, and cannot be bribed (Isa 5:16; cf. Deut 10:17–18).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Because Zion reminds Yahweh of Sodom, he could not care less about the multitude of sacrifices and holy feasts in his honor (Isa 1:11–14). Polluted altars and Asherim beside them will be thrown down and broken into pieces (Isa 27:9; cf. Deut 7:5; 12:3; 16:21). Support is present here for a single sanctuary in Jerusalem ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("(Deut 12:5–14 and passim). Yahweh will judge the ruthless people who are obstructing justice in the city gate (Isa 29:21; cf. Deut 27:19).")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Isaiah, despite all his indictments and judgments, hopes nevertheless for reform. We hear him admonishing people to seek justice, defend orphans and widows (Isa 1:17), and let Yahweh be their fear (Isa 8:13). In Deuteronomy, fearing Yahweh consists of doing the commandments (Deut 4:10; 5:29; 6:2, 24; 10:12–13, and passim), and special care for orphans and widows gets repeated mention (Deut 14:29; 16:11, 14; 24:17; 27:19). Yahweh exercises special care for them (Deut 10:18). Isaiah preaches early on the very essence of Deuteronomic theology, i.e., that if people are obedient, they will eat the good of the land, but if they refuse, the sword will devour them (Isa 1:19–20; cf. Deut 11:13–17, 26–28; 28:1–19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Isaiah looks for a better day to come, in which evil will be replaced by the goodness Yahweh requires. The people of Zion will cast away their idols and images (Isa 30:22; 31:7), and out of Zion shall go forth the law and Yahweh’s word (Isa 2:3 = Mic 4:2). There will no longer be regard for pagan altars and standing Asherim (Isa 17:8; cf. Deut 7:5; 12:3; 16:21). Zion will become the city of the appointed feasts (Isa 33:20), which may reflect Hezekiah’s centralization program and laws in the Deuteronomic Code (Deut 12:5–14; 16:1–17). Judah will become a righteous nation (Isa 26:2), and Jerusalem will be a city known for holiness, justice, and righteousness, one in which the fear of Yahweh will be in evidence (Isa 1:26–27; 4:3; 28:16–17; 33:5–6, 14–15). When the Spirit is poured out from on high, justice will dwell in the wilderness and righteousness in the orchard (Isa 32:15–16). In this wonderful transformation, the meek and the needy will once again rejoice in the Holy One of Israel (Isa 29:19). A Davidic king and his princes will rule in justice and righteousness, delight in the fear of Yahweh (Isa 9:6[9:7]; 11:1–3), and judge with equity the poor and the meek (Isa 11:4–5; 32:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are some puzzlements, however, in a comparison of Isaiah with Deuteronomy. How could Isaiah propose that a pillar to Yahweh will mark Egypt’s future conversion (Isa 19:19) when pillars are prohibited in Deut 16:22? Driver (1895, xlix) notes, too, that although Isaiah speaks against images, he does not wage war against local sanctuaries as such (but see Isa 1:29) and hardly ever alludes to the worship of “other gods” (cf. Isa 17:10b). The term “other gods,” so common in Deuteronomy and Jeremiah, does not occur in Isaiah. May be this is because Hezekiah removed the high places and centralized worship in Jerusalem (2 Kgs 18:4, 22; 21:3).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-17"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EREMIAH")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Jeremiah was the last major prophet residing in ancient Israel, which by the late seventh century had been reduced to the rump kingdom of Judah. He lived ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("more than fifty years during this final period of Israelite nationhood, witnessing the reform of Josiah, its undoing by Kings Jehoiakim and Zedekiah, and the fall of Jerusalem to the Babylonians in 586. Another four years were spent in a community of remnants at Mizpah, until the Babylonian-appointed governor was murdered and a contingent of Mizpah residents fled to Egypt. Jeremiah, and his scribal companion Baruch, went with them to Egypt, where he was last heard from (Lundbom 1999, 102–20; 2010a, 88–100).")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah’s earliest preaching betrays indebtedness to the Song of Moses (Deuteronomy 32), both in language and in key ideas (Lundbom 1999, 110–14). Jeremiah learned from this Song that Yahweh is a just and upright Father, the one who created Israel and gave her—along with other nations—land as an inheritance (Deut 32:4–8; Jer 2:5, 7; 3:19; 5:4–5; 9:23[9:24]; 10:12–16; 27:5; 32:17). From the Song Jeremiah learned also that Yahweh’s goodness to Israel in the inhospitable wilderness (Deut 32:10–12; Jer 2:6) and his gift of land with all its bounty (Deut 32:13–14; Jer 2:7) were repaid by ingratitude: Israel became sated, forgot Yahweh, and went after gods it had not known (Deut 32:15–18; Jer 2:5–9). The idea appears in both the Song and in Jer 2:7–8 that the settlement was the time when things began to go bad.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah learned from the Song that Yahweh becomes greatly provoked when his covenant people forget him and go after other gods (Deut 32:16, 22; Jer 4:4; 7:18; 8:19; 15:14; 17:4) and in burning anger will bring against Israel another nation as his punishing agent (Deut 32:19–25; Jer 4:5–8, 13–17; 5:10–13, 15–17). But the Song also taught him, as other traditions—in Deuteronomy and elsewhere—undoubtedly did, that Yahweh’s burning anger will nevertheless stop short of completely wiping out his covenant people (Deut 32:26–33; cf. 9:6–29; Exod 32:7–14). If he were to destroy them completely, the enemy will take credit for having brought about the destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Song then turns to describe Yahweh’s holy wrath against other nations, which will have a positive result in bringing deliverance to Israel (Deut 32:34–43). This elicits from Jeremiah a number of oracles against foreign nations (Jer 25:15–38; 46–51). The brief poem in Jer 2:27c–28—the language and also the irony—derives from Deut 32:37–38, where Yahweh promises self-vindication before devotees of gods now shown to be powerless. In the Song, the grand sweep of divine history goes from salvation to salvation: Yahweh, who began a saving work among his people, will end things with another saving work: vindication of Israel and a simultaneous judgment against enemy nations. This informed Jeremiah’s hope oracles for the future (Jeremiah 30–33), the most important of which was the new/eternal covenant prophecy (Jer 31:31–34; 32:38–40). The Song of Moses was the temple lawbook of 622, which, after its finding, Jeremiah consumed (Jer 15:16).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Jeremiah was also influenced by core Deuteronomy, i.e., chapters 1–28, the ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("document that inspired young King Josiah’s purge of pagan religious practices in Jerusalem and Judah, even in sanctuaries to the north, where the king extended his reform once the Assyrians had left the territory and returned home (2 Kgs 23:4–20; 2 Chr 34:3–7). Following the Chronicler, I take the purge to have occurred in 628 (Lundbom 1976). Jeremiah was influenced by the Song of Moses and core Deuteronomy, both of which were written documents in his time. Driver (1895, xlvii) says, “Jeremiah exhibits marks of [Deuteronomy] on nearly every page.”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("From core Deuteronomy Jeremiah came to know the “prophet like Moses” passage in Deut 18:15–18, incorporating it into his prophetic call (Jer 1:4–12; Lundbom 1999, 233–35). He learned from Deuteronomy that the Horeb covenant was conditional: If Israel keeps the covenant, which means keeping the commandments and other covenant conditions, it will continue to live long in the land; if it does not, the nation will be destroyed and the land will be lost (Deut 5:32–33; 28; Jer 7:3–15). Influence here extends even into Jeremiah’s diction: Deuteronomy says if Israel keeps the statutes and the ordinances, “it will go well with you … and you will live long in the land” (Deut 4:40; 5:16, 33; 6:2–3, 18; 10:13, and passim; Jer 7:23; 22:15; 35:7; 38:20; 40:9; 42:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Other early reform preaching of the prophet echoes Deuteronomy, e.g., Jeremiah’s calling for a “circumcision of the heart” (Deut 10:16; 30:6; Jer 4:4); preaching covenant obedience and the consequences of disobedience (Deut 11:13–17, 27–28; 27:10; 28:1–19; Jer 11:1–13); and calling for observance of the fourth commandment on Sabbath rest (Deut 5:12–15; Jer 17:19–27).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But Jeremiah’s task was more difficult than that of the Deuteronomic preacher, for he was called by Yahweh to indict Israel for covenant violation and announce that Yahweh’s punishment was forthcoming. But here again, he drew heavily upon Deuteronomy. Israel had “forgotten” or “forsaken” Yahweh (Jer 1:16; 2:13, 17, 19, 32; 3:21; 5:7, 19; 18:15, and passim), which went to the heart of the covenant relationship. Deuteronomy warned people to be careful lest they forget the extraordinary events of the wilderness (Deut 4:9); the covenant and then make for themselves an idol (Deut 4:23); and most importantly Yahweh himself, who brought the nation out of Egyptian slavery (Deut 6:12; 8:14). Forgetting Yahweh meant not keeping the commandments, and Deuteronomy warned against this repeatedly (Deut 8:11). It said if Israel forgets Yahweh and goes after other gods, it will surely perish, as the other nations did (Deut 8:19). Deuteronomy lays much stress on “remembering”—remembering Yahweh, his mighty works, his deliverance in the exodus, and how Israel provoked him in the wilderness (Deut 5:15; 7:18; 8:2, 18–19; 9:7; 15:15; 16:3, 12; 24:18, 22). Remembering the deliverance from Egypt should issue forth in doing the commandments. Jeremiah pleads with Yahweh not to break his covenant with the people (Jer 14:21), which, according to Deuteronomy, was something Yahweh said he would not do (Deut 4:31).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Jeremiah reflects Deuteronomy’s idea that forsaking Yahweh occurs when Israel goes after other gods (Jer 7:6, 9; 11:10; 13:10; 16:11; Deut 6:14; 8:19; 11:28; 13:7[13:6]), a violation of the first commandment (Deut 5:7). The expression “other gods” occurs seventeen times in Jeremiah and seventeen times in Deuteronomy. Jeremiah says that prophets have been and still are prophesying by Baal (Jer 2:8; 23:13), which is strictly forbidden in Deut 13:2–6(13:1–5) and 18:20. People have also built high places to burn their sons and daughters to other gods (Jer 2:20; 3:6; 7:31; 13:27; 19:5) and have been carried away by astral worship, both of which are forbidden in Deuteronomy (Jer 8:2; Deut 4:19; 12:2, 31; 17:2–7; 18:10).")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah knows Deuteronomy’s prohibition of diviners, soothsayers, and sorcerers (Jer 27:9; 29:8; Deut 18:10, 14), finding a problem also with prophets and dreamers in Jerusalem and Babylon who are not getting the message right (Jer 5:12–13, 31; 14:14; 23:14–22, 25–32; 29:21–23; Deut 13:2–6[13:1–5]; 18:20–22). Small wonder, when false practitioners of religion proliferated under the evil Manasseh (2 Chr 33:6). Both Jeremiah and Deuteronomy are concerned about people “obeying Yahweh’s voice” (Jer 3:13; 9:12[9:13]; 11:7; 42:13; Deut 4:30; 8:20; 9:23; 13:5[4]; 15:5, and passim) and “rebelling” against Yahweh (Jer 4:17; Deut 1:26–46; 9:24). Deuteronomy—except for the wilderness recollection in 1:26–46—simply warns against disobedience and rebellion; Jeremiah in his day reports that people are guilty of both.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah in one of his celebrated “Temple Oracles” lists six of the Ten Commandments that people have broken: no other gods; idols; swearing falsely; murder; adultery; and stealing (Jer 7:9; cf. Deut 5:7–20). Elsewhere, Jeremiah censures people for (1) setting up idols and images (Jer 7:30; 8:19; 10:1–5, 8–9, 14–15; 13:27; cf. Deut 5:8–10); (2) erecting sacred pillars and Asherim (Jer 2:27; 17:12; cf. Deut 7:5; 12:3; 16:21–22); (3) swearing falsely (Jer 5:2; cf. Deut 5:11; 6:13; 10:20); (4) murder, i.e., the shedding of innocent blood (Jer 7:6; 22:3, 17; cf. Deut 5:17; 19:10, 13; 21:8–9); (5) adultery (Jer 5:7–8; 9:1[9:2]; 13:27; 23:10, 14; 29:22–23; cf. Deut 5:18); and (6) Sabbath breaking (Jer 17:21–23; cf. Deut 5:12–15). Deuteronomy prohibits all of these. Added to “adultery” is the sin of “going whoring” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("זנה")]), _vm._v("), which Jeremiah probably gets from Hosea.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah warns—more often indicts—Judah and its king for not executing justice and righteousness (Jer 7:5; 21:12; 22:3, 13–17), also for oppressing the poor, needy, sojourner, orphan, and widow (Jer 2:34; 5:26–28; 7:6; 22:3). This is a blatant violation of the Deuteronomic Code (Deut 24:14–15, 17; 27:19). Since Yahweh does justice and righteousness (Jer 5:1; 9:23[9:24]; Deut 10:18), people must do the same. Josiah practiced these cardinal virtues, but his son Jehoiakim did not (Jer 22:15–17). Jeremiah thus looked ahead to a future Davidic king who would do justice and righteousness (Jer 23:5; 33:15).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Evil in Jerusalem made it like the proverbial cities of Sodom and Gomorrah ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("(Jer 23:14; cf. Deut 29:22[29:23]), which suffered punishment from Yahweh. In preaching punishment to come, Jeremiah draws heavily on the curse language of Deuteronomy. Deuteronomy 28 states that a multitude of curses will descend upon Israel for not obeying the voice of Yahweh or for not being careful to do Yahweh’s commands (Deut 28:15). In his call for covenant obedience (Jer 11:3–7), Jeremiah uses the “cursed … amen” formula of Deut 27:15–26, with the one difference that he speaks the “amen” on the people’s behalf. The “cursed be the man who” phrase of Deut 27:15 appears three times in Jeremiah’s preaching (Jer 11:3; 17:5; 20:15). In the bulk of Jeremiah’s preaching, the Deuteronomic curses are either currently being carried out or slated to come in the near future.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremiah in some cases reproduces the actual wording of the Deuteronomic curses. The following curses from Deuteronomy 28 occur in one form or another in Jeremiah:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Deut 28:18—curse on the fruit of your body, the fruit of your ground, the increase of your cattle and young of your flock (Jer 5:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:21—curse of pestilence (Jer 14:12; 15:2; 18:21; 21:5–6, 9–10, and passim).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:23–24—curse of no rain (Jer 3:3; 23:10). Both Deuteronomy and Jeremiah recognize that Yahweh sends the rain, with Deuteronomy making it conditional on Israel’s obedience of the commandments (Deut 11:11–17; Jer 5:24; 14:22).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:25—curse of being a “fright” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("זַעֲוָה")]), _vm._v(") to other nations (Jer 15:4; 24:9; 29:18; 34:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:26—curse that dead bodies will be food for the birds of the air and the beasts of the earth (Jer 7:33; 15:3; 16:4; 19:7; 34:20).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:30—curse that one will betroth a wife and another will lie with her; one shall build a house and not live in it; one shall plant a vineyard and not eat its fruit (Jer 6:11–12; 8:10). This is reversed in Jer 29:5–6; 31:5. Deuteronomy knows what obtains in ordinary times (Deut 20:5–7).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:33—curse that a nation you have not known shall eat up the fruit of your ground and all of your labors (Jer 5:15–17; cf. 3:24). See also Deut 28:49–52.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:37—curse that Israel will become a “desolation” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שַׁמָּה")]), _vm._v("), a “proverb” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מָשָׁל")]), _vm._v("), and a “taunt” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שְׁנִינָה")]), _vm._v(") among all peoples (Jer 24:9; 25:9, 11; 18, and passim).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:48—curse that the enemy will put a “yoke of iron” on your neck (Jer 28:14).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:49–52—curse that a nation from afar, whose language you do not know, shall eat the offspring of your cattle and the fruit of your ground (Jer 5:15–17). See also Deut 28:33.")])]), _c('p', {
    staticClass: "Hang"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Deut 28:49—curse of an enemy that flies swiftly, like an eagle, coming against Israel (Jer 48:40; 49:22).")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:53—curse that people will eat the flesh of their own sons and daughters in the siege (Jer 19:9).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:54, 56—curse that the most delicately-bred men and women will do indelicate things in the siege (Jer 6:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:59, 61—curse of sicknesses ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מַכּוֹת")]), _vm._v("), severe and lasting, coming upon the people (Jer 6:7; 10:19; 14:17; 15:18; 19:8; 30:12, 14; 49:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deut 28:64—curse that Israel will be scattered among foreign nations (Jer 9:15[9:16]; 30:11). See also Deut 4:27.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Jeremiah cites Deuteronomy’s divorce and remarriage law to make the point that Israel cannot, at least for now, return to Yahweh (Jer 3:1; Deut 24:1–4). In his court trial (Jer 26:12–15), Jeremiah’s testimony, “Yahweh sent me,” betrays a knowledge of the authentication legislation in Deut 13:2–6(13:1–5); and in his encounter with Hananiah, initial acquiescence and eventual judgment on this Yahweh prophet (Jer 28:15–17) show an understanding of the authentication legislation in Deut 18:20–22. Jeremiah censures Zedekiah and the people (Jer 34:14) for not abiding by the seven-year law of release in Deut 15:12–18. The firstfruit legislation of Deut 16:9–12 and 26:1–11 is in Jeremiah’s mind when he reports his vision of the good and bad figs (Jer 24:1–10). To a Jerusalem under siege, Jeremiah parodies “the way of life and way of death” preaching in Deut 30:15–20, telling people that surrendering to the Babylonians will lead to life, resisting them will lead to death (Jer 21:8–10; cf. 38:17–18; 42:10–22). The main difference between Deuteronomy and Jeremiah is that the former warns people not to break the covenant and tells what will happen if they do. Jeremiah argues that the covenant has been broken and people must either repent or suffer the consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In judgment preaching Jeremiah speaks of Yahweh’s steadfast love ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֶסֶד")]), _vm._v(") toward Israel, only to say that it has been withdrawn (Jer 16:5). The problem is that Israel has other lovers: the strange gods (16:11; cf. 2:25, 33; 8:2; 14:10). Deuteronomy says that Yahweh’s steadfast love depends on Israel keeping the commandments (Deut 5:10; 7:9, 12). People have also ceased to fear Yahweh (Jer 2:19; 3:8; 5:22, 24; 44:10), which Deuteronomy admonished them to do (Deut 5:29; 6:2, 13, 24; 8:6; 10:12, 20, and passim). Jeremiah knew the need for this important inner disposition (Jer 10:7), with people rising to his defense at the trial of 609 and pointing out too that the good King Hezekiah feared Yahweh, with the result that Yahweh rescinded evil planned against the nation (26:19). Jeremiah looked ahead to the day when people would fear Yahweh forever (32:39). In passages of hope, Jeremiah affirmed that Yahweh’s love or steadfast love remains (31:3; 32:18; 33:11[from Pss 100:5; 106:1; 107:1; 136:1]).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Jeremiah’s diction—in both poetry and prose—draws heavily on the sermonic prose of Deuteronomy (Driver 1895, xcii–xciv; Weinfeld 1972, 320–61). There are the stereotyped clichés: “and these are the words” (Deut 1:1; 28:69[29:1]; Jer 29:1; 30:4); “as at this day” (Deut 2:30; 4:20, 38; 8:18; 10:15; Jer 11:5; 25:18; 32:20); “with outstretched hand and with strong arm” (Deut 4:34; 5:15; 7:19; 11:2; 26:8; Jer 21:5[reversed]); “sojourner, orphan, and widow” (Deut 10:18; 14:29; 16:11, 14; Jer 7:6; 22:3); “the place that (Yahweh your God will choose) to make his name reside there” (Deut 12:11; 14:23; 16:2, 6, 11; Jer 7:12), carrying with it the “name” theology of Deuteronomy; and many more. Some rhetorical questions of Jeremiah also echo Deuteronomy, e.g., “Ask around … and see if there has been anything like this: ‘Has a nation exchanged gods, even though they are no-gods?’ ” (Jer 2:10–11), which is like the string of questions in Deut 4:32–34:")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Indeed ask, would you, about the former days that were before you, from the day that God created human beings upon the earth, and from one end of the heaven to the other end of the heaven: Has a great thing like this happened or has anything like it been heard of? Has a people heard the voice of a god speaking from the midst of the fire as you, you have heard, and lived? Or has a god attempted to go and take for himself a nation from the midst of another nation by testings, by signs and by wonders, and by war, and by a strong hand and by an outstretched arm, and by great terrors, according to all that Yahweh your God did for you in Egypt before your eyes?")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("We do not hear from Jeremiah, as we do from Deuteronomy and Hosea, preaching about the love Yahweh expects in return for the love he has shown Israel. Jeremiah mentions only the love Israel showed Yahweh in the wilderness (Jer 2:2) and then does not speak about it again. Holiness is also not a major theme in Jeremiah. In Deuteronomy it is not so much Yahweh being the “Holy One of Israel” (but see Deut 32:51), as in Isaiah, but Israel being Yahweh’s holy people (Deut 7:6; 14:2, 21; 26:19; 28:9), which carries over into Jeremiah. Israel is remembered as being holy to Yahweh in the wilderness (Jer 2:3), but it presumably lost that distinctive quality due to its sinful behavior. Jeremiah does say, however, that he himself was made holy at the time Yahweh called him to be a prophet (Jer 1:5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, Jeremiah’s announcement of a new/eternal covenant (Jer 31:31–34; 32:38–40) is another indication that he understood himself to be “the prophet like Moses” (Lundbom 2010b, 37). Moses presented the Horeb covenant to Israel; Jeremiah presents Israel with a new covenant for the future.")])]), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("DEUTERONOMY AND WISDOM")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Wisdom is commonly defined as an intellectual capacity or quality of the mind enabling one to live well in the world, to succeed, and to counsel others in the way of success (Blank 1962, 852–53). Its opposite is foolishness, usually reduced to the lack of good sense or good judgment in a person. The wise are admired; fools are held up to ridicule. “Wise women” appeared in the early monarchy in ancient Israel (2 Sam 14:2; 20:16), and by Isaiah and Jeremiah’s time “wise men” were a distinct professional class in Jerusalem (Isa 29:14; Prov 25:1; Jer 8:8–9; 9:11, 22[12, 23]; 18:18; Weinfeld 1967, 262; 1972, 161–62). Wise men were prominent in neighboring nations to Israel, particularly Egypt (Gen 41:8; Exod 7:11). Jeremiah tells us that tribal wisdom resided in Teman, a northeast region of Edom (Jer 49:7; cf. Eliphaz the Temanite in Job 2:11; 4:1), and years later Paul says wisdom was highly sought after by the Greeks (1 Cor 1:22). In the Bible, Wisdom is also something infinitely above and beyond human beings, being the first of God’s creation (Prov 8:22; cf. John 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That wisdom is found in other cultures, to some extent in all cultures, helps us distinguish it from belief or godly faith. Wisdom deals largely with matters of earth, i.e., it is not generally concerned with God or the things of God, which we call theology. And while wisdom can certainly come by divine revelation, it need not be so acquired. More often than not, it comes by living fully and attentively in this world. Wisdom is thus akin to humanism (Rankin 1936, 3; Weinfeld 1961, 242–43). And yet, says Daube (1969a, 28), wisdom in ancient Israel was deeply religious. Psalm 111:10 and Prov 9:10 say: “The fear of the Lord is the beginning of wisdom.” Without the fear of the Lord, wisdom becomes foolishness, as the book of Job teaches.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wisdom has three defining characteristics. It may have more, but it has at least these three: (1) wisdom builds on knowledge; (2) wisdom requires discrimination, or discernment; and (3) wisdom resides in individuals who utilize the knowledge and discernment they possess. Wisdom is something you do (Matt 7:24–27; Lundbom 2010c). Wisdom is not the same as knowledge; it is the larger and more comprehensive of the two terms. Similarly, foolishness takes in more than ignorance, even stupidity (= “slow-wittedness”). A wise person is well informed, having acquired knowledge from: (a) the teaching of others (older folk, parents, teachers); (b) practical experience both positive and negative; and (c) personal observations or reflections upon the natural order and the world in which one lives. Some identify wisdom with common sense. For persons of faith, knowledge can come because God reveals things to them. But not everyone possessing knowledge is wise. Francis Bacon, advisor to Queen Elizabeth I, was called by some “the most learned fool in the world.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The wise person recognizes similarities, but also perceives differences, ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("and is able to discriminate among knowledge he or she possesses. The wise person knows how to “sort things out.” Wisdom often teaches a doctrine of the “two ways,” the way of the righteous and the way of the wicked (Psalm 1; Prov 4:10–19), the way to life and the way to death (Deut 30:15–20; Jer 6:16; 17:5–8; 21:8–9; Matt 7:13–14). The wise person makes judgments about good and bad, right and wrong, truth and falsity, and knows the difference—when there is one—between appearances and reality. The wise person observes actions, discerning whether they contradict words issuing from the mouth. King Solomon was wise because he was able to "), _c('em', [_vm._v("discern")]), _vm._v(" the real mother of the baby placed before him by two women, both of whom claimed it was theirs (1 Kgs 3:16–28).")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("To be wise you must use your knowledge to get on in the world, to avoid shame, or even more importantly, to keep yourself from suffering catastrophic loss. The wise person is a teacher and counselor. In ancient times the wise man was a counselor to the king, advising the best course of action to take in war, also when and how to make peace. Fathers passed on wisdom to their sons—warning them of hidden dangers, how to succeed in life, the virtues of a good wife, and so on (Proverbs). Mothers taught daughters how to succeed in getting a husband (cf. Ruth 3:1–5) and find success in other ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The wisdom element in the book of Deuteronomy is identified by its use of terms for wisdom and being wise, also by themes found in the wisdom literature of the Old Testament, i.e., Proverbs, Ecclesiastes, Job, certain Psalms, and in the Protestant Apocrypha, Wisdom of Solomon and Sirach (Ecclesiasticus), the last-named said by some to be the wisdom book "), _c('em', [_vm._v("par excellence")]), _vm._v(". We also have for comparison wisdom texts and international treaties in extrabiblical literature. The latter would include the Instruction of Amen-em-opet ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 421–25), the Sefire Stela (Fitzmyer 1961; 1967; D. J. McCarthy 1963), the Vassal Treaties of Esarhaddon ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 534–41), and others. The Instruction of Amenem-opet invites comparison to Prov 22:17–24:22 ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 421).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We see early on in Deuteronomy a concern that Israel be a nation imbued with wisdom. Moses says regarding the statutes and ordinances he is teaching the people:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("So you shall be careful and you shall do, for that will be your wisdom and your understanding in the eyes of the peoples, who, when they hear all these statutes, will say, “Surely a wise and understanding people is this great nation!” (Deut 4:6)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The concern here is with appearances, how Israel appears to other nations. This is an appeal to shame, a wisdom theme expounded all throughout Deuteronomy (Daube 1969a, 50).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("In three different passages in the Pentateuch, leaders and magistrates are ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("appointed to aid Moses in governing the people, and in each passage the personal qualities cited are different from the others (Weinfeld 1967, 257; 1972, 244–45). In Exod 18:21, Jethro tells Moses to “choose "), _c('em', [_vm._v("able men")]), _vm._v(" from all the people, "), _c('em', [_vm._v("such as fear God, men who are trustworthy and hate a bribe")]), _vm._v(".” In Num 11:16–30, God endows the elders aiding Moses with a "), _c('em', [_vm._v("divine spirit")]), _vm._v(". But in Deut 1:13–17, Moses is to appoint from the tribes "), _c('em', [_vm._v("wise, understanding, and knowledgeable men")]), _vm._v(" (v. 13).")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("We may compare the Covenant Code (Exodus 21–23) with Deuteronomy at another point to show how, in the view of the Deuteronomic author, the judge is expected to possess wisdom. Exodus 23:8 states: “And you shall take no bribe, for a bribe blinds the officials, and subverts the cause of those who are in the right.” But Deut 16:19 says: “you shall not take a bribe, for a bribe blinds the eyes of the "), _c('em', [_vm._v("wise")]), _vm._v(" and subverts the cause of the righteous.” Weinfeld points out that the intellectual qualities of wisdom, understanding, and knowledge are traits that characterize leaders and magistrates in the wisdom literature. A personified Wisdom declares in Prov 8:15–16: “By me kings reign, and rulers decree what is just; by me princes rule, and nobles, all who govern rightly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy contains laws having clear parallels in the book of Proverbs. The law on not removing the neighbor’s landmark in Deut 19:14, and the curse for the same in 27:17, have parallels in Prov 22:28 and 23:10. The law in Deut 25:13–16 about merchants not using false weights and measures has parallels in Prov 11:1 and 20:10, 23. In Deut 8:5, we are also told that as a man disciplines his son, so Yahweh disciplines his people, which echoes the teaching of Prov 3:11–12. And the law in Deut 23:22–24(23:21–23) about being sure to pay a vow has parallels in Prov 20:25; Eccl 5:3–4[4–5]; Sir 18:22 (Weinfeld 1972, 279).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy also picks up characteristic vocabulary from Proverbs, for example, the term “abomination” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תּוֹעֵבָה")]), _vm._v("), often in the expression, “abomination to Yahweh,” which appears only in Deuteronomy and Proverbs. “Abomination” occurs 21 times in Proverbs (3:32; 6:16; 8:7; 11:1, 20; 12:22; 13:19; 15:8, 9, 26; 16:5, 12; 17:15; 20:10, 23; 21:27; 24:9; 26:25 (plural); 28:9; 29:27 [2x]), and 16 times in Deuteronomy (7:25, 26; 12:31; 13:15[14]; 14:3; 17:1, 4; 18:9, 12; 20:18; 22:5; 23:19[23:18]; 24:4; 25:16; 27:15; 32:16). The term appears also in the Egyptian “Instruction of Amen-em-opet” (Weinfeld 1972, 267–68).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Promient wisdom themes in Deuteronomy are the following:")]), _vm._v(" "), _c('p', {
    staticClass: "VerseSb"
  }, [_vm._v("Humane treatment and benevolence to the poor and needy")]), _vm._v(" "), _c('p', {
    staticClass: "Verse"
  }, [_vm._v("Teaching of children")]), _vm._v(" "), _c('p', {
    staticClass: "Verse"
  }, [_vm._v("Blessing: life, goodness, and longevity in the land")]), _vm._v(" "), _c('p', {
    staticClass: "Verse"
  }, [_vm._v("Avoidance of shame")]), _vm._v(" "), _c('p', {
    staticClass: "Verse"
  }, [_vm._v("Discerning false from true prophets")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-18"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMANE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REATMENT AND")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENEVOLENCE TO THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOR AND")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEDY")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy’s concern that humanitarian treatment be accorded certain individuals in society has long been noted (Driver 1895, xxiii–xxv; E. Day 1911; Weinfeld 1961). Driver (1895, xxv) says of the Deuteronomic writer:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The author speaks out of a warm heart himself; and he strives to kindle a warm response in the heart of everyone whom he addresses. Nowhere else in the OT do we breathe such an atmosphere of generous devotion to God, and of large-hearted benevolence towards man; nowhere else are duties and motives set forth with greater depth and tenderness of feeling, or with more winning and persuasive eloquence; and nowhere else is it shown with the same fulness of detail how high and noble principles may be applied so as to elevate and refine the entire life of the community.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Scholars of an earlier generation attributed this humanitarian outlook to the influence of Hebrew prophecy, but Kaufmann (1960, 157–66) took issue with this view, and Weinfeld (1961, 244–47; 1972, 293–97) countered with a thesis that influence came rather from Israel’s school of wisdom. Daube (1969a) agreed, at least to the extent that Deuteronomy is seen to contain a strong shame-cultural element, which he attributed to wisdom influence. Daube went on to say: “In a system where how you appear to others is of enormous importance, to look on your fellow with benevolence becomes a prominent virtue, to look on him with ill-will a prominent vice, indeed danger” (1969a, 50). He thought it no accident that Deuteronomy alone in the Old Testment uses the expression “his eye is evil, grudging, toward somebody” (15:9; 28:54, 56).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Deuteronomy shows particular concern for the sojourner, orphan, and widow, also the Levite in town, who has no inheritance (= landed property) and in the seventh century is out of a job. Local sanctuaries have been closed down in the reform of Hezekiah (2 Kgs 18:22[= Isa 36:7]), which centralized worship in Jerusalem, and soon after they may well have been ruined by enemy invaders. The local Levite thus gets a share of offerings made at the central sanctuary (14:27; 18:1–5); is entitled to the third-year charity-tithe in the town where he lives (14:28–29; 26:12–13); and is invited to accompany families and their servants in the annual pilgrimages to the central sanctuary, where all are enjoined to eat and be glad (16:10–11, 14). At harvest time, the sojourner, orphan, and widow are accorded gleaning rights (24:19–21). Deuteronomy teaches that justice must not be perverted toward the sojourner, orphan, and widow (24:17; 27:19), for Yahweh loves them and treats them justly (10:17–18). Israel, for its ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("part, would do well to reflect on its own past, remembering that it was once a band of slaves in the land of Egypt (10:19; 16:12; 24:18, 22).")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("We learn from Egyptian, Akkadian, and Ugaritic texts that in other societies, too, special care was taken to protect and treat justly the orphan, widow, and outcast (Fensham 1962a; Galpaz-Feller 2008). From ancient Egypt comes the Instruction for King Meri-ka-Re (twenty-second century), in which a ruler gives this advice to his son and successor: “Do justice while you endure on the earth. Quiet the weeper; do not oppress the widow” ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 415). In The Protest of the Eloquent Peasant (twenty-first century), a peasant beaten and robbed of donkeys on a trip to Egypt seeks redress from the Pharaoh’s chief steward, whom he addresses as “the father of the orphan, the husband of the widow, the brother of the divorcee, and the apron of him who is motherless” ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 408). The Laws of Ur-Nammu (162–68) mandated protection for the orphan, widow, and the poor ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 524). King Hammurabi in the epilogue to his Law Code (lines 30–90) boasts that he “promoted welfare in the land … in order that the strong might not oppress the weak, that justice might be dealt the orphan and the widow in Babylon” ("), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 178). And in the Keret Legend from Ugarit, King Keret is reprimanded by his son Ya"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _vm._v("ib for neglecting the orphans and the widows, and told to step down so Ya"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ṣ")]), _vm._v("ib can reign (KRT Cvi 25–50; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 149). Finally, in the Tale of Aqhat it is the good Daniel who judges the cause of the widow and the orphan (Aqht A v 1–10; Aqht C i 20–30; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 151, 153). In the NT, justice to widows lies at the heart of Jesus’ parable of the Poor Widow (Luke 18:1–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many of the laws of Deuteronomy are humanistic in character. The following, which are peculiar to Deuteronomy, relate to human life and human dignity:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Required construction of a parapet (low wall encircling a flat roof) on a new house to eliminate the danger of someone falling off the roof and being killed (22:8).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude to fair maidens captured in (foreign) wars and wanted by Israelite men for wives—that the maidens be allowed time to mourn and improve their appearance before the marriage is consummated. If the marriage does not work, the women are free to go wherever they want. They must not be sold as slaves, as was commonly done, or treated as slaves by the men who married them, assuming the marriage was largely to satisfy the man’s lustful urges (21:10–14).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The giving of asylum to slaves escaping to Israel, and not returning them to their (foreign) masters. They are to dwell in Israelite towns, and not be oppressed (23:16–17[23:15–16]).")])]), _c('p', {
    staticClass: "Hang"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The attitude on debt remission (= cancellation) to a poor Israelite in the seventh year. The creditor shall not refuse to lend because the seventh ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("year is approaching. The aim is to eliminate poor in the land, but this will obtain only if people obey the commands. There is no danger that the poor will cease (or grow fat) in the land (15:1–11).")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "Hang"
  }, [_vm._v("The warning against a man discriminating against an unfavored wife and her firstborn son in the liquidation of his estate, giving the younger son of the favored wife the (double) portion, and the actual firstborn son what is left. The rights of the firstborn are to be given to the firstborn, even if he is the son of the unfavored wife (21:15–17).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude about not taking hand-mills or upper millstones in pledge, which would deprive the poor (women) of their only means to grind grain and prepare daily bread. This would be tantamount to taking a life in pledge (24:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude toward collecting a pledge as security for a loan, that the creditor not enter the house and fetch it for himself, but wait outside and have it brought to him (24:10–11).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude toward the poor laborer or sojourner, that he receive his wages the same day that he has worked, before the sun goes down (24:14–15).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude about not taking a widow’s garment in pledge under any circumstances (24:17).")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Two laws in Deuteronomy deal with cruelty to animals:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("The prohibition against taking the mother bird with her eggs or her young from a nest happened upon by chance; the mother must be chased away (22:6–7).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The prohibition against muzzling an ox treading grain (25:4).")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Other humanitarian laws in Deuteronomy have parallels or precedents in the Covenant Code:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("The attitude on giving fellow-Israelites interest-free loans, intended as relief for poor and insolvent people who might be victims of war, famine, pestilence, a death in the family (2 Kgs 4:1), or some other adversity over which they had no control (23:20–21[23:19–20]; cf. Exod 22:24[25]).")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("The attitude regarding a poor man from whom a garment has been taken as a pledge, that the creditor not sleep in the pledge, but restore it to the man before sundown (24:12–13; cf. Exod 22:25–26[26–27]).")])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("The law regulating manumission of Hebrew slaves in Deut 15:12–18 is more enlightened than the corresponding law in Exod 21:1–11. In the Deuteronomic ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("law, both male and female slaves are set free when their term is up (Deut 15:12), whereas in the Covenant Code female slaves do not go free (Exod 21:7). The freed slave in the Deuteronomic Code is also given a gift at the time of manumission (15:12–14), which is not specified in Exodus law. According to Weinfeld (1967, 261), Deuteronomy does not consider the Hebrew slave as property (cf. Exod 21:21), rather as a “brother” (15:12). And in Deuteronomic law nothing is said about a wife given to a male slave by his master and children born to that wife, that they not go out with him, which is specified in the law of the Covenant Code (Exod 21:4).")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-19"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EACHING OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILDREN")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Teaching and learning, with a larger aim of promoting doing, are important wisdom themes. The didactic temper, according to Weinfeld (1972, 298), is present in the wisdom literature because its concern is with education. Moses is the great teacher in Deuteronomy (P. D. Miller 1987). He teaches Yahweh’s commands to the people (4:1, 5, 14; 5:31; 6:1; 31:19, 22), who are then supposed to teach the same to their children (4:9–10; 6:7; 11:19). Teaching children is not something you believe in; it is something you do. The verb “teach” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("למד")]), _vm._v(" Piel) occurs ten times in Deuteronomy (4:1, 5, 10, 14; 5:31; 6:1; 11:19; 20:18; 31:19, 22) and the verb “learn” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("למד")]), _vm._v(" Qal), seven times (4:10; 5:1; 14:23; 17:19; 18:9; 31:12, 13). The verb “teach” appears in no other book of the Pentateuch, only in Deuteronomy (Weinfeld 1972, 303).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The related matter of discipline, which is a major theme in Proverbs (Prov 3:11–12; 5:7–14, 23; 6:23; 12:1; 13:24; 15:10; 19:18; 22:15; 23:13; 29:17), and in wisdom literature generally, finds a prominent place in Deuteronomy (Deut 4:36; 8:5; 11:2; 21:18–21; 22:18).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One of the ways in which extraordinary things of the past stay with people is by someone teaching them to the children and grandchildren. Parents are to teach children the mighty acts of God in redeeming Israel from Egyptian slavery. In Deut 6:20–25 we read:")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("When your son asks you in the future: “What mean the testimonies and the statutes and the ordinances that Yahweh our God commanded you?” then you shall say to your son, “Slaves we were to Pharaoh in Egypt, and Yahweh brought us out from Egypt by a strong hand, and Yahweh gave signs and wonders, great and severe against Egypt, against Pharaoh, and against all his house, before our eyes, and us he brought out from there, in order that he bring us in to give to us the land that he swore to our fathers. And Yahweh commanded us to do all these statutes, to fear Yahweh our God, for ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("our own good all the days, that he might let us live, as at this day. And righteousness it will be for us when we are careful to do all this commandment before Yahweh our God, just as he commanded us.”")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "BodySb"
  }, [_vm._v("A liturgical injunction admonishing people to hear, internalize, and teach Yahweh’s commands to their children appears twice in the book (6:4–9; 11:18–20). In 6:4–9 it is preceded by the Shema (“Hear, [O Israel] …”):")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Hear, O Israel, Yahweh our God, Yahweh is one. And you shall love Yahweh your God with all your heart and with all your soul and with all your might. And these words that I am commanding you today shall be upon your heart. And you shall impress them to your children, and you shall speak about them when you sit in your house and when you walk in the way, and when you lie down and when you rise. And you shall bind them as a sign upon your hand, and they shall be as headbands between your eyes. And you shall write them upon the doorposts of your house and within your gates.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Teaching of children is a prominent theme in Proverbs. In Prov 6:20–22 the son is told to keep the teachings of both father and mother. See also Prov 7:1–3 and 8:32–34. Most education in ancient Israel took place in the home (Crenshaw 1985; 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the verses immediately preceding the injunction of 6:4–9, Moses stresses the importance of doing his teachings in the land the people are about to inherit. Keeping the commands by them and their children will lead to fearing Yahweh (6:1–2), which, as was said earlier, is an important wisdom theme in Deuteronomy and all throughout the Bible (Weinfeld 1972, 274–81). Elsewhere in Deuteronomy, people are told to make known to the children and grandchildren the extraordinary events at Horeb and the words Yahweh spoke there (4:9–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Deuteronomy, Moses calls for a public reading of the Law every seven years at the Feast of Booths. Entire families—and even sojourners—are to be present to hear the Law read aloud by the Levitical priests (31:10–13):")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("And Moses commanded them: “After seven years’ time, at the appointed time of the year of remission, at the Feast of Booths, when all Israel comes to appear before Yahweh your God, in the place that he will choose, you shall recite this law in front of all Israel in their hearing. Assemble the people, the men and the women and the little ones, also your sojourner who is within your gates, so that they may hear and so that they may learn to fear Yahweh your God and be careful to do all the words of this law; yes their children who have not known may hear and may learn to fear Yahweh your ")]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("God all the days that you live on the soil that you are crossing over the Jordan to take passession of it.”")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "BodySb"
  }, [_vm._v("When Moses is commanded by Yahweh to teach people a song before he passes from the scene (Deut 32:1–43), which will serve as a witness to future generations of Israel’s rebelliousness in the wilderness, the writer adds parenthetically that this song “will live unforgotten in the mouths of their descendants” (31:21). Teaching of this song will thus be required. After Moses gave the song, he again told the people that they must impart this teaching to their children (32:46).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ANE treaties have a clear didactic concern. In the Sefire Stela:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Thus we spoke (and thus we wr)ote. What I, Mati’el, have written (is) a reminder to my son (and) my grandson who come af(ter) me. Let them do the right thing.… (D. J. McCarthy 1963, 192)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("And from the treaty of Esarhaddon (ca. 672):")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("(You swear that) as you stand in the place of this oath you will not swear with the words of the lips (alone), but with your whole heart, (and) you will teach the treaty to your children who live afterwards. (D. J. McCarthy 1963, 200)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-20"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LESSING")]), _vm._v(": L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")]), _vm._v(", G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OODNESS")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONGEVITY IN THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Horeb covenant, being conditional in nature, stands fortified by blessings and curses. Blessing is what Israel lives for. Deuteronomy recalls Yahweh’s blessing in the past and anticipates more of the same in the future. Opposite of blessing is the curse, and about the covenant curses Deuteronomy has more to say than any other book of the Pentateuch. If Israel obeys Yahweh’s commands, it will be blessed; if it disobeys, a multitude of curses will descend upon the nation. Blessings and curses are therefore announced in Deut 11:26–32, where reference is to a covenant renewal festival on Mount Gerizim and Mount Ebal (cf. 27:12–13), and then are described in copious detail in chapter 28, where the curses outnumber the blessings nearly four to one. For what will happen after Israel has experienced the blessings and the curses, see 30:1–10.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Elsewhere in Deuteronomy, Israel is promised blessing (and multiplication) if it obeys Yahweh’s commands (7:12–16; 8:6–10). Blessing will come when Israelites give the third-year charity-tithe to the Levite, sojourner, orphan, and widow (14:28–29); grant debt remission in the seventh year, most importantly to ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("the fellow-Israelite who is poor (15:1–11); manumit Hebrew slaves—male and female—in the seventh year, providing them also with a departing gift (15:12–18); loan to fellow-Israelites without interest (23:20–21[23:19–20]); restore garments taken in pledge from the poor before sundown (24:12–13); and permit the sojourner, orphan, and widow to glean at harvest time (24:19–22). Deuteronomy says that Yahweh will bring abundant harvests in the good land, and these will be a blessing (2:7; 12:7, 15; 14:24; 15:14; 16:10, 15, 17). And at the presentation of the firstfruits, the worshipper is to request Yahweh’s ongoing blessing on Israel (26:15).")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy describes blessing as material reward: life, goodness, and longevity in the land (Weinfeld 1960b). Weinfeld (1967, 257) says:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Like the wise teacher who stresses the material benefits that accrue from proper behavior, the author of Deuteronomy makes repeated references to the good fortune that will be the lot of those who observe God’s commandments. The principal deuteronomic inducement to observe the Torah is, as in the wisdom literature, material retribution. In no other book of the Pentateuch does the concern for material welfare occupy so great a place as in the book of Deuteronomy. Life, good fortune, longevity, large families, affluence and satiety, the eudemonistic assurances which constitute an essential part of wisdom teaching—these constitute the primary motivation for the observance of God’s laws.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("One meets up often in the book with the stereotypical phrase about “living long in the land” (5:33; 11:9; 22:7; 32:47). Land tenure depends upon Israel keeping the covenant, which is doing the commands. If Israel goes after other gods, it will not live long in the land (4:26; 30:18). Doing the commands gives “life” to the covenant people (4:1; 8:1; 32:47). “Life” also comes to those who practice “justice, and only justice” (16:20; cf. Prov 21:21). Weinfeld (1972, 273) notes that Proverbs speaks often about doing justice and righteousness to preserve one’s life or to keep one from death (Prov 10:2; 11:4, 19; 12:28; 16:31). He thinks this emphasis on “life” has its ultimate source in Egyptian wisdom teaching, e.g., The Instruction of Amen-em-opet.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy pulls all these ideas together in its “two ways” teaching in 30:15–20, which invites comparison with Prov 4:10–19. The “two ways” teaching:")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("See I have set before you today the life and the good, and the death and the bad. [If you listen to the commandment of Yahweh your God] that I am commanding you today, to love Yahweh your God, to walk in his ways, and to keep his commandments and his statutes and his ordinances, then you will live and you will multiply, and Yahweh your God will bless you in the ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("land into which you are entering to possess it. But if your heart turns away and you do not listen, and you are drawn away and you worship other gods and serve them, I declare to you today that you shall surely perish; your days will not be prolonged on the soil that you are crossing over the Jordan to enter to take possession of it. I call to witness against you today the heavens and earth: Life and death I have set before you, blessing and curse, so you can choose life in order that you and your descendants may live, to love Yahweh your God, to obey his voice, and to cling to him, for it is your life and the prolonging of your days to dwell on the soil that Yahweh swore to your fathers, to Abraham, to Isaac, and to Jacob, to give to them.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-21"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VOIDANCE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAME")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("David Daube (1969a; 1969b) argues that Deuteronomy contains a strong shame-cultural element, and as such teaches the avoidance of shame. This shame-cultural bias he attributes to wisdom influence in the book. He says:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The principal explanation of Deuteronomy’s shame-cultural bias seems … to lie in the affiliation with Wisdom.… Deuteronomy does not belong to Wisdom literature but it stands in close relation to it.… In so far as Wisdom governs, authority is more diffused, appeal is made to a larger number of people who are of correspondingly less overwhelming stature [than the single towering figure of a father for the culture in which guilt is more prominent]—the neighbours, peers, well-thinking citizens, and so forth; it is in these conditions that shame culture tends to come to the fore. (Daube 1969a, 27, 51–52)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Because wisdom has its eye on success in society, concern is expressed for the impression created by an act, on applause and disapproval. Yet, as we said earlier, Hebrew wisdom is deeply religious. Daube says this is so because the guilt mechanism is vigorous. Guilt is present or imputed when one has succumbed to wrongdoing—particularly against God or the commands of God. Daube finds a curious blend of guilt culture and shame culture in ancient Israel and says that guilt culture may still predominate. Yet he believes that unless attention is paid to the admixture of shame culture, our picture of Deuteronomy and conclusions drawn from it will be seriously distorted.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A shame element can be seen in a number of Deuteronomic laws:")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("20:8. The officer responsible for recruiting the militia concludes his speech before the assembly by saying that the fearful and weakhearted should depart and not go to battle. This appeals to a man’s sense of shame, says Daube ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("(1969a, 29), particularly when preceded by an earlier admonition from the priest that men not be fearful and weakhearted when Yahweh will give them the victory (vv. 3–4). It is evident that disgrace awaits anyone who slips away due to fear and weakheartedness. Conversely, glory awaits those who, after being offered an opportunity to opt out, do stay to fight. Acceptance, favor, and honor are great rewards in a shame culture. Shame is contrasted to honor in Prov 3:35.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("21:22–23. The body of a criminal executed and hanged must be taken down before sunset, an injunction that appears only in Deuteronomy. The reason for not allowing the body to hang all night is so the land will not be defiled. Daube (1969a, 46–47) says the look of things is important for the writer of Deuteronomy, just as when a corpse lies unburied (21:1) or the camp is left unclean (23:13–15[23:12–14]).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("22:1–4. A cluster of directives warns against “hiding oneself” from awkward situations. None has a parallel outside Deuteronomy. One must not hide oneself from someone’s animal that has wandered off, or when finding something a person has lost, or from someone’s animal that has fallen. The law concerning a stray animal in Exod 23:4 calls simply for a return by the one who finds it; there is no mention of “hiding oneself” from it. Daube (1969a, 29–30) says this means that a person must not give in to the temptation to avoid an awkward sight and in a manner that dispenses with outright refusal. He says the injunction “do not hide yourself” introduces a shame aspect more common in the Orient than in the West. The Deuteronomic writer assumes that one will be embarrassed at an unseemly object and will try to escape without being noticed. A similar “hiding of oneself” is evident in Jesus’ parable of the Good Samaritan (Luke 10:31–32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("22:13–21. This law concerning a bride charged by her husband with coming to him and not being a virgin is promulgated with shame in mind. Daube (1969a, 30) says: “The importance of what people think of you, of your name, your reputation, could not be brought out more clearly.” The entire procedure is carried out in public, before the elders in the city gate. There the bedcloth of the wedding night is displayed for all to see. If the charge proves false, the groom must pay the bride’s father a sum of money and he may not divorce her. Daube emphasizes the reason given: “because he has brought an evil name upon a virgin of Israel” (v. 19). If the charge is true, the bride is stoned at the door of her father’s house, the house where she lived when she misbehaved. Her conduct has brought shame upon all Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("23:2–7(23:1–6). Here certain categories of people are not permitted entrance into the assembly of Yahweh: eunuchs, bastards, Ammonites, and Moabites. Edomites and Egyptians may enter only in the third generation. The creation of classes in which tainted individuals are deprived of full rights, says Daube, is “a mighty weapon in the shame cultural arsenal.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("23:13–15(23:12–14). This legislation about relieving oneself outside the camp and covering up one’s excrement is promulgated so that Yahweh, when touring the camp, will not see “an unseemly thing.” The expression ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("עֶרְוַת דָּבָר")]), _vm._v(") occurs only one other time in the OT, in the Deuteronomic law dealing with divorce (24:1), and Daube says it is a direct reference to the shame aspect.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("23:19(23:18). The wages of a cult prostitute—male or female—are not to be brought into the assembly of Yahweh. They are tainted by the disgraceful way in which they were received.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("24:1–4. The description of the primary divorce in this law reflects a preoccupation with shame. The wife loses favor in the eyes of her husband, which Daube (1969a, 32) says in a shame culture is a terrible misfortune. The great aim in a shame culture is to find favor in the beholder’s eyes. The point is further stressed when it says the husband has found some “unseemly thing” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("עֶרְוַת דָּבָר")]), _vm._v(") in her. Daube compares this with the Roman concept of "), _c('em', [_vm._v("repudium")]), _vm._v(" (1969a, 33; 1969b).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("24:8–9. This law regarding scale disease requires that one follow the instructions of the priests minutely. Remember, the Deuteronomic writer adds, what Yahweh did to Miriam when Israel came out of Egypt. Miriam (and Aaron) had questioned Moses’ authority, and Miriam was smitten with the disease. Moses interceded on her behalf, but Yahweh replied: “If her father had but spit in her face, should she not be shamed seven days?” So Miriam was sent outside the camp for seven days (Num 12:14). Scale disease was seen as a mark of disfavor brought upon by Yahweh, comparable to the disgrace of a child whose father had spit in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("24:10–11. In this law regarding a loan where a pledge is required, the creditor is not permitted to go into the house to seize the pledge but must remain outside and wait there for the pledge to be brought to him. Daube says this is a striking instance of sensitivity to shame. If the creditor were to enter the house and seize whatever he desired for a pledge, it would be a great dishonor to the debtor and his family. Handing over outside preserves appearances.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("25:1–3. Here the wrongdoer sentenced to a whipping must not be given more than forty stripes. If he were given an excessive number, says the Deuteronomic writer, the brother would “be rendered contemptible” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("קלה")]), _vm._v(") in the eyes of others. Daube says a man subjected to a wild, unlimited bastinado will lose his dignity and be degraded forever.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("25:5–10. Here is the only law in the Pentateuch where punishment consists exclusively in public degradation. If a man refuses to carry out the duty of taking his dead brother’s wife in a levirate marriage, the widow shall come up to him in the presence of city elders, pull off his sandal, spit in his face, and recite a degrading word over him (v. 9). His name shall forever be: “The house of him who had his sandal pulled off.” Emphasis is laid here upon preserving “the ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("name” of the dead man, which is of great importance in a shame culture (Daube 1969a, 35).")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("25:11–12. Here is the only law in ancient Israel explicitly mandating maiming. It results from a situation where a woman intervenes in a fight involving her husband and grabs hold of the opponent’s “shameful parts” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מְבשִׁים")]), _vm._v("). She is punished by having her hand cut off, bringing her permanent disfigurement and eternal shame.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("27:16. In Deuteronomy’s Dodecalogue, which deals with clandestine transgressions, a curse is placed on anyone who treats his father or mother “with contempt.” The verb is the same as in 25:3 ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("קלה")]), _vm._v("), which deals with a brother rendered “contemptible” in the sight of others if subjected to an unlimited bastinado. In Exodus and Leviticus the death penalty awaits anyone who “curses” or “strikes” his parents (Exod 21:15, 17; Lev 20:9), which Daube (1969a, 38–39) says is a significant difference. Cursing or striking is more serious and can usually be witnessed by others. Contempt is shown in subtle ways and may be out of public view (Weinfeld 1972, 277–78). Weinfeld says that because dishonoring one’s parents is here a clandestine act, it cannot be penalized. But Proverbs says such behavior is unacceptable and will be punished (Prov 15:20; 23:22; 30:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Deuteronomic Code in other ways shows itself to contain a shamecultural element. One may note, for example, the deterrent function of punishment (Daube 1969a, 40). Four times after mandating capital punishment for an offense, the writer of Deuteronomy adds “and all Israel/all the people/those who remain shall hear and fear” (13:12[11]; 17:13; 19:20; 21:21). Public example is very important in a shame culture. Deuteronomy also speaks eleven times about the duty to “utterly remove ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בער")]), _vm._v(") evil/guilt of innocent blood from your midst/from Israel” (13:6[5]; 17:7, 12; 19:13, 19; 21:9, 21; 22:21, 22, 24; 24:7). Daube (1969a, 41, 48–49) says the concern in all these cases is with the look of things. On a happier note, Deuteronomy expects entire families—also servants and invited guests—to “rejoice” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שׂמח")]), _vm._v(") at the annual pilgrim festivals (12:7, 12, 18; 14:26; 16:11, 14, 15; 26:11). Communal display of happiness on specific occasions suits a culture preoccupied with appearances. The other side of ritual merrymaking is exclusion from the assembly (23:2–9[23:1–8]).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Other vocabulary in Deuteronomy supports the thesis that the book has a shame-cultural bias. There is the expression, “you/he may not do (such and such)” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לאֹ־תוּכַל/יוּכַל")]), _vm._v("), which is not the same as the apodictic “you/he shall not.” This expression occurs seven times in the book (12:17; 16:5; 17:15; 21:16; 22:3, 19; 24:4) and means something like “you/he must not even think of doing (such-and-such).” The appeal is to one’s sense of shame. Daube says the expression is similar to the modern English expression, “this is impossible behavior,” where reference is to an infringement of appearances. There is also the Deuteronomic expression, “when there is found” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי־יִמָּצֵא")]), _vm._v("), which occurs four ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("times in the book. It is used with reference to legislation concerning: (1) a man or woman who does evil and has gone and served other gods (17:2–3); (2) someone found slain in the open field, where it is not known who killed the individual (21:1); (3) a man found lying with another man’s wife (22:22); and (4) someone caught kidnapping a person and enslaving or selling him to another (24:7). This expression, says Daube, which occurs also in the prohibition of 18:10 against passing a son or daughter through the fire, shifts “the emphasis from the fearfulness of the crime to the fearfulness of the resulting appearance in the eyes of the beholder—God above all” (1969a, 43–50; 1971a). It is not so much the transgression that is condemned, but its display. And when shame is felt towards God, we are approaching the realm of guilt. Daube says:")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The beholder is horrified not only by wicked acts in progress, idolatry, adultery, theft of a fellow-Israelite, but also by a corpse lying unappeased. In fact, the latter spoils the appearance of the land almost more than any of the other incidents.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("In these latter passages, the legislation concludes with the phrase: “you shall utterly remove the evil/guilt of innocent blood from your midst/Israel,” which as we said, has to do with the look of things.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Daube concludes his brilliant essay by saying that the most remarkable appeal to shame is the plea that God not wipe out the Israelites, however rebellious, for then their enemies will conclude that he was powerless to lead them to triumph or was ill-intentioned against them from the start (1969a, 51). While this argument occurs elsewhere in the OT (Exod 32:12; Num 14:13–19), it occasions no surprise to find it in the preaching of Deuteronomy (Deut 9:27–29) and also in the Song of Moses (32:26–27).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-22"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISCERNING")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSE FROM")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROPHETS")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The Old Testament records two tests for false prophecy, and both occur in Deuteronomy. The first is found in chapter 13, which includes a law in sermonic dress admonishing people not to follow other gods. Verses 2–6(1–5), which contain the first point of a three-point sermon, focus on the prophet and “dreamer of dreams.” Should one of these individuals give a sign or a wonder—even with a predictive word that comes to pass—people are not to pay heed if the individual leads them in the way of other gods. Prophets and “would-be prophets” who lead people in the way of other gods are ingenuine and must be put to death. Yahweh gives them success only so that he may test people to see whether they love him and are committed to walk in his way. People are to apply ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("the “Yahweh only” test to see which prophets are false and which prophets are true. The true prophet speaks for Yahweh and leads people in the way of Yahweh. The false prophet leads people in the worship of other gods.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("So long as it was between prophets of Yahweh and prophets of other gods the choice was simple. But what does one do when all the prophets are Yahweh prophets and there is disagreement among them? How does one tell the false prophet? Or the true prophet? For this situation a second test of true and false prophecy is given in Deut 18:20–22:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("But the prophet who presumes to speak a word in my name that I did not command him to speak, or who speaks in the name of other gods, yes, that prophet shall die. And if you say in your heart, “How shall we know the word that Yahweh has not spoken?” When the prophet speaks in the name of Yahweh, and the word does not happen, or does not come to pass, that is the word that Yahweh has not spoken. The prophet has spoken it presumptuously; you need not be afraid of him.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("When Yahweh prophets speak contrary words, such as happened in 1 Kings 22, or later in Jeremiah 28, the test for true and false prophecy comes in fulfillment of the prophetic word. Words spoken by false Yahweh prophets will not be fulfilled. And for good measure, the older test of Deut 13:2–6(1–5) is incorporated into this new test by the addition of the words “or who speaks in the name of other gods” in v. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With wisdom being concerned about discerning what is true from what is false, these texts on true and false prophets must be included with other passages in the book showing influence from wisdom traditions.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-12"
    }
  }, [_vm._v("THEOLOGICAL IDEAS IN DEUTERONOMY")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-20",
    attrs: {
      "id": "sec2-23"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME OF")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("The name of Israel’s God is Yahweh, and a glorious and awesome name it is (28:58; 32:3). This name has been put upon Israel (28:10), which implies ownership, as we know from Egyptian texts. In Deuteronomy much is said about the central sanctuary being the place where Yahweh has caused his name to dwell (12:5, 11, 21; 14:23; 16:2, 6, 11; 26:2). Von Rad therefore identified what he called a “name ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שֵׁם")]), _vm._v(") theology” in Deuteronomy, as opposed to a “glory ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כְּבוֹד")]), _vm._v(") theology” in the Priestly document (von Rad 1953, 37–44). Deuteronomy affirms that Yahweh himself is not present in the worship place; he has only put his name there. Yahweh’s residence is in the heavens (4:36; 26:15; 33:26; cf. 1 Kgs 8:27–30). ")]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("In older Yahwistic theology, Yahweh is depicted as residing on earth (Gen 3:8–13), and in other pre-Deuteronomic theology Yahweh is invisibly present on his ark, which serves as his throne (Num 10:35–36; 1 Sam 4:4). Later Priestly theology became even more anthropomorphic, seeing the tabernacle (= tent of meeting) as the place on earth where Yahweh’s “glory” met with the people (Exod 29:43; Num 14:10; 16:19). And yet in older material one does find the statement that Yahweh speaks from heaven (Exod 20:22), and it has been argued recently (Hundley 2009) that Deuteronomy and the Deuteronomic History do not absent Yahweh from earth, but simply leave the exact nature and extent of Yahweh’s presence on earth ambiguous (cf. Deut 4:39).")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Because Yahweh’s name is like no other, Israel is told in the third commandment not to lift up the name of Yahweh in emptiness, or “in vain” (5:11). When people swear oaths, however, they are to swear them in Yahweh’s name (6:13; 10:20). Priests are to serve and bless the people in Yahweh’s name (10:8; 18:5, 7; 21:5), and bona fide prophets speak in the name of Yahweh (18:19). Prophets must not speak in the name of other gods or speak in Yahweh’s name if Yahweh has not commanded them to speak (18:20, 22).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-24"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH THE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE AND")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NLY")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Shema, which has become the preeminent testimony of faith for the Jewish people, affirms the oneness of Yahweh God (6:4), some would say also his uniqueness and exclusivity. The exclusivity of Yahweh, i.e., he is God and there is no other, is clearly attested in 4:35 and 39, also in the Song of Moses (32:39), which anticipate the spirited monotheism of Second Isaiah (Isaiah 40–48). Deuteronomy says Yahweh is God of gods and Lord of lords (Deut 10:17), i.e., he is supreme God and supreme Lord. Yahweh has absolute sovereignty over any other claimants to the title. Moses tells Israel: “Yahweh your God is God” (7:9). Yahweh alone led Israel through the inhospitable wilderness (32:12), and to Yahweh belong the heavens and the earth (10:14).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-25"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH A")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The idea of Yahweh being a holy God, which is celebrated by the prophet Isaiah (Isa 6:3), is not prominent in Deuteronomy, nor in Jeremiah. Moses says only in Deut 32:51 that because he and Aaron broke faith at Meribat-kadesh in not revering Yahweh as holy, they were denied entrance into the promised land. Yahweh’s habitation, however, is holy (26:15). Deuteronomy’s more important teaching is that Israel is a holy people.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-26"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EARD BUT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEN")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy makes it clear that Yahweh is a God who can be heard but not seen. The Ten Commandments were revealed first to the people out of the fire, on the day of assembly (4:10–13; 5:22), when they heard the divine voice but saw no form (cf. Exod 33:18–23). Hearing the divine voice was remarkable enough, and it is a wonder that the people remained alive (Deut 4:33; 5:23–26; cf. Exod 20:18–19). Because Israel saw no form at Horeb, images of Yahweh were disallowed (Deut 4:15–18, 23; 5:8). Images of the divine introduce a visual element into religion, and this was rejected in ancient Israel. The expression “face to face,” when used of Israel’s encounter with Yahweh (5:4), or Moses’ encounter with Yahweh (34:10; cf. Exod 33:11), has no visual dimension whatever; there is only an exchange of words.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-27"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH A")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD OF")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy has more to say about “love” than any other OT book—both Yahweh’s gracious love toward Israel and Israel’s obligation to love Yahweh. In fact, Yahweh’s love for the patriarchs and for Israel is expressed only in Deuteronomy in the Pentateuch. It occurs also in the preaching of Hosea (Hos 2:21[2:19]; 3:1; 11:1, 4; 14:5[14:4]), who speaks about the covenant as a bond of love between husband (Yahweh) and wife (Israel). This metaphor is never made explicit in Deuteronomy. In the Blessing of Moses, an old poem predating Deuteronomy, it says that Yahweh left behind thousands of holy ones in his mountain abodes to throw in his lot with “peoples,” specifically the peoples of Israel. It was done because of his love for them (33:2–3). Deuteronomy elsewhere states that Yahweh became attached to the patriarchs in love (10:15), then became attached in love to Israel (7:7–8, 13). Balaam’s curse was turned into blessing because of Yahweh’s love for Israel (23:6[23:5]). This love was a gracious disposition on the part of Yahweh, a divine mystery admitting no further explanation.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Love in Deuteronomy is closely tied in with election (4:37; 7:7–8; 10:15) and with the covenant (5:10; 7:12). In fact, Moses says in 5:10 that Yahweh shows steadfast love to those who love him and keep his commandments (cf. Exod 34:7). The same holds for the future (7:12–13). Deuteronomy employs two words for love: the common "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אַהֲבָה")]), _vm._v(", which is a term of emotion and embodies the idea of “breathing,” and "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֶסֶד")]), _vm._v(", which is “covenant love.” "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אַהֲבָה")]), _vm._v(" never describes the covenant in Deuteronomy. Yahweh chose Israel for two reasons: (1) because he loved Israel; and (2) because he was keeping an oath sworn to the patriarchs (7:8). Yahweh loves the sojourner too, supplying him with food and clothing ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("(10:18), which shows that divine love is tied in with justice and benevolence and that it is not only for Israel, but for all who reside in the land, even foreigners.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-28"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH A")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AITHFUL TO")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IS")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROMISES")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Song of Moses says that Yahweh is “a God of faithfulness” (32:4), which is affirmed also in 7:9, where it says that Yahweh keeps covenant and steadfast love indefinitely for those who love him and keep his commandments (cf. Exod 34:6–7). The Horeb covenant is conditional; nevertheless, Yahweh will not forget or break this covenant so long as his people remain obedient (4:31; 7:12–13). Deuteronomy affirms Yahweh’s faithfulness mostly in pointing out how Yahweh is keeping the oath to the fathers to drive out the wicked Canaanites and give Israel their land (1:8; 6:10, 18, 23; 9:5; 10:11, and often). This oath is rooted in the covenant with Abraham (Gen 12:7; 13:14–15, 17; 15:18–21, etc.), which included a promise that Abraham would have a myriad of descendants (Gen 12:2; 13:16; 15:5, etc.). Israel’s multiplication in the land, strength to attain wealth in the land, (prolonged) life in the land, blessing in the land, and the promise of enlarged borders are rooted in Yahweh’s promises to Abraham (8:1, 18–19; 11:9, 21; 13:18–19[13:17–18]); 19:8–9; 26:14–15; 28:8–11; 30:19–20). But all depends upon Israel doing the commandments. Yahweh loved and elected Israel as his chosen people because of his oath to the fathers (7:7–8; 29:11–12[29:12–13]). Deuteronomy also knows of other oaths sworn by Yahweh, which he promised to keep and did keep, e.g., that the unfaithful generation would die in the wilderness (1:34–36; 2:14) and that Moses would not enter the promised land (4:21)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-29"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH A")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHTEOUS")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy is much concerned with righteous behavior, but the book proper makes no claims about Yahweh being righteous, which is heard so often in the Psalms (Pss 11:7; 116:5; 119:137; 129:4). Only the Song of Moses states explicitly that Yahweh is righteous (32:4). Yet we assume that Deuteronomy believes Yahweh to be righteous since he hates sin and wrongdoing. Worship of other gods (17:3–4), idols and idolatrous rites (7:25–26; 12:31; 13:15[13:14]; 20:18; 27:15; 32:16), magic and divination (18:12), immoral customs (22:5; 23:19[23:18]; 24:4), blemished sacrifices (17:1), and commercial injustice (25:16) are all “abominations” to him.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-30"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH AN")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPARTIAL")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDGE")])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Yahweh is a God of justice and impartial in carrying out justice. Testimony to Yahweh as a God of justice is prominent in the Song of Moses, which says that all God’s ways are just (32:4). Because Yahweh can be counted on to act justly, vengeance can be left to him, which gets the emphasis at the end of the Song (32:35, 41, 43). Elsewhere in Deuteronomy the emphasis is on the appointing of impartial judges in Israel (1:16–17) and requiring just practices in the marketplace (25:13–15). The reason for needing impartial judges is that the judgment they render is God’s (1:17). Yahweh is impartial in judgment and will not take a bribe (10:17). Yahweh executes justice for the orphan and widow, loving also the sojourner (10:18). And as a good judge, Yahweh tempers his judgments with compassion and mercy (4:31; 13:18[13:17]). In fact, his steadfast love is said to be infinitely greater than his judgment (5:9–10; 7:9–10; cf. Exod 34:6–7).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-31"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SRAEL A")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Israel is a people “holy” to Yahweh (7:6; 14:2, 21; 26:19; 28:9; cf. Exod 19:6), which is to say that in the economy of God Israel has been set apart for a special purpose. To Yahweh belong heaven and earth (Deut 4:39; 10:14); nevertheless, his favor rests upon a single, treasured people: Israel. This idea carries over into the New Testament, where it is given expanded application to the church (1 Pet 2:9–10).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-32"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LECTION OF")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SRAEL")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The concept of election is tied in with the verb "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בחר")]), _vm._v(", “to choose,” which occurs often in Deuteronomy (Driver 1895, lxxx #23). Yahweh’s choice surpassing every other choice was Israel as his own possession out of all the peoples on earth (4:37; 7:6; 10:15; 14:2; 26:18; cf. 32:9). The concept of election derives from Israel being a “holy (= set apart) people” (7:6; 10:15). Israel’s election is given its fullest explanation in the OT in 7:6–8, where election is said to have come not because of numbers, for Israel was the smallest of peoples, even less because of righteousness, for Israel was a people given to rebellion. The divine decision, hidden forever in mystery, was an act of grace stemming from Yahweh’s love for Israel and his determination to keep the oath sworn to the fathers. Yahweh’s covenant with Abraham was unconditional and eternal, and thus could not be broken. Israel’s election was asserted by the prophet Amos, who went on to allow no exception for it having to be punished (Amos 3:2). In his New Testament ")]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("gospel, John says that followers of Jesus were chosen out of the world because of God’s love for them (John 15:12, 19).")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-33"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVENANT AT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OREB")]), _vm._v(" (S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INAI")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("While the term “covenant” seldom occurs in older biblical material, it appears twenty times in Deuteronomy and is common from the seventh century on (Eichrodt 1966, 302). The Horeb (Sinai) covenant is unlike the other covenants made with Noah, Abraham, Phinehas, and David, in that it contains human obligations. It is a conditional covenant, given freely by Yahweh, who promises to keep it but requires obedience on the part of Israel for it to remain intact. If Israel disobeys the terms of the covenant, it is declared broken and must be renewed. In the end this covenant was broken to the point where it could not be renewed, so the nation was destroyed. Jeremiah therefore announced for Israel and Judah a new and eternal covenant (Jer 31:31–34; 32:40), unlike the Horeb covenant in that it contained no conditions and would be for all time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy presents the Horeb covenant more clearly than any other Old Testament book, appropriating as it does the form of international treaties in the ancient Near East, in which the vassal king is under obligation to keep the terms set forth by his suzerain. One sees this clearly in the blessings and curses coming at the end of both the treaties and the covenant of Deuteronomy (27:13–26; 28; cf. 11:26). Deuteronomy promises blessings for covenant obedience (11:27; 27:12; 28:1–14) and a multitude of curses for covenant disobedience (11:28; 27:13–26; 28:15–68). If Israel hearkens to Yahweh’s voice and does his commands, it will live, multiply, and receive blessing in the land (11:27; 30:16). If it does not hearken and do the commands, it will be overcome with incurable diseases (28:58–61), diminish in numbers (28:62–63), become subservient to other nations (28:36–57), and lose the land given to it by Yahweh (11:28; 30:17–18). Israel therefore has a choice between life and death, and the Deuteronomic preacher enjoins Israel to choose life, so it may live long in the land promised to Abraham, Isaac, and Jacob (4:40; 5:16, 32–33; 7:12–14; 30:19–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Deuteronomy affirms both the promise and unconditional covenant given to Abraham and the conditional covenant with the nation given through Moses, how are the two reconciled in the book? The conditional covenant given through Moses deals largely with nationhood and tenure in the land. If Israel breaks this covenant, the nation will be under a curse and will lose the land. Deuteronomy still holds to the covenant with Abraham, since Yahweh—even in his most far-reaching judgments—provides for a remnant that survives (1:34–39; 9:13–14; 28:62–68; 32:26–27).")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-34"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND AS A")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFT AND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENURE IN THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")])])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The land looms exceedingly large in Deuteronomy. Because Yahweh swore an oath to Abraham to give his descendants the land in which he was presently journeying (Gen 12:7; 13:14–15, 17; 15:18–21, etc.), an oath repeated to Isaac and Jacob (Gen 26:3–4; 28:13; 35:12), this land came to be called the promised land. In Deuteronomy, Moses addresses Israel in the plains of Moab as it prepares to cross the Jordan and enter the land for the purpose of taking it. It is usually assumed that the promised land is only Canaan, which lies west of the Jordan. But Moses in his Moab discourse reflects also on a conquest already achieved, which took place in Transjordan as a result of successful battles against the Amorite kings Sihon and Og (2:26–3:11), and the settlement of Reuben, Gad, and the half tribe of Manasseh in their land (3:12–17). In Deuteronomy, then, land in Transjordan becomes part of the promised land. Weinfeld argues that for Deuteronomy the beginning of the conquest and the fulfillment of the promise to the fathers begins with the crossing of the Arnon in Transjordan (2:24). The promised land, however defined, is a divine gift and, like Israel’s election, is an act of grace, decided aeons ago—perhaps soon after the creation of the world—by Yahweh, who keeps it a secret from the people of earth (32:7–9). This land is Israel’s inheritance (4:21; 12:9–10; 15:4), and it will be enlarged if Israel keeps the commandments (19:8–9; cf. 12:20). Deuteronomy emphasizes that the land being given to Israel is a “good land” (1:25, 35; 3:25; 4:21–22; 6:18; 8:7–10, etc.) and Israel is getting this land not because of its own righteousness, but because the wickedness of Canaan’s inhabitants is complete and because Yahweh is confirming the oath made to Abraham, Isaac, and Jacob (9:4–5; cf. 6:10, 18; 8:1; 10:11, and passim; cf. Jer 7:7; 11:5; 16:15; 25:5; 30:3, and passim).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Settlement in the land, what Deuteronomy calls “coming into rest” (3:20; 12:9) or Israel “attaining rest from all its enemies round about” (12:10), has both opportunities and dangers. Israel will begin to harvest crops, and because this land is a good land, it will eat and become sated. What it must do, then, is to bless Yahweh (8:10) and present the firstfruits to Yahweh in gratitude for the land’s abundant yield (26:1–4). Sacrifices will also take place in the land, but these must be only at the single sanctuary of Yahweh’s choosing (12:5–14). The danger of settlement, seen already in the Song of Moses, is that Israel will become sated and forget Yahweh, going after the gods of the land (31:20–21; 32:13–18; cf. Jer 2:5–9). Deuteronomy therefore warns Israel constantly to destroy all vestiges of Canaanite worship once it settles in the land and not chase after other gods or succumb to idolatry (12:1–3, 29–31; 18:9–14). When Israel crosses the Jordan, one of the first things it must do is to write the law clearly on large stones at Mount Ebal, which will be a visual reminder to Israel of the commandments it must keep (27:1–10). Tenure in the land is contingent upon Israel ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("keeping the commandments. Keeping the commandments is what will give Israel long life in the land (4:40; 5:33; 6:2; 11:8–9, etc.). If Israel fails to keep them, the good land will be lost. It fell to Jeremiah to proclaim this message to the last remnant of the once proud Israelite nation (Jer 7:14; 24:10).")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-35"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AR")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Israelite march to enter and possess the promised land came as a result of holy war, so called, a war in which Yahweh took the lead as “Lord of hosts” (= Lord of the army). Yahweh promised Israel the land, and Deuteronomy makes it ever so clear that taking it would be successful only if the conquest was directed and executed by Yahweh, who delivered Israel from Egypt and cared for it in the wilderness (1:30–33; 2:31–36; 3:2–4; 7:1–2; 31:3–8). But success will also be contingent on Israel keeping the commandments (11:22–25). Yahweh will put “dread” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פַחַד")]), _vm._v(") and “fear” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("יִרְאָה")]), _vm._v(") in the opposition, which is language of holy war (2:25; 11:25; cf. 31:6). Other holy war language in Deuteronomy is seen in commands to the soldiers for upcoming battles: “Be strong and be bold” (31:6, 7, 23). All able-bodied men are to be mustered, although Deuteronomy does make an allowance for some to opt out of the fighting (20:1–9). Newly married men get a one-year deferment to stay at home with their wives (24:5). The subject of holy war is discussed by von Rad (1953, 45–59; 1991, 115–27) and de Vaux (1965, 258–67), with both pointing out that holy war traditions have their clearest and most complete expression in Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the rules of holy war, the camp must be ritually pure (23:13–15[23:12–14]). Once the battle has been fought and won, conquered people who survive were not to be taken as prisoners, and sometimes the spoil, too, was not to be taken as booty; all was to be devoted (= dedicated) to Yahweh. People were to be put to death. Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("הַחֲרֵם")]), _vm._v(" (“devote to destruction”) is a defining term in holy war, referring to the ban ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֵרֶם")]), _vm._v(") placed upon captured people and goods to be given over to Yahweh (2:34–35; 3:6; 7:1–2; 13:16–18[13:15–17]; 20:16–17). In the holy wars against Sihon and Og, men, women, and children were put under the ban, but not the animals (2:34–35; 3:6–7). In wars against the Canaanites, nothing was to be kept alive (20:16–18). But when Israel will fight wars in distant cities, only the (adult) males will need to come under the ban; women, children, cattle, and other goods can be taken as booty (20:10–15). And Deuteronomy provides for females captured in distant wars that Israelite soldiers want to marry, allowing that such marriages be permitted to take place (21:10–14).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("As things turned out, every living thing in Jericho—except Rahab, who hid the spies, and her household—was devoted to destruction (Josh 6:21). Silver and gold and vessels of bronze and iron went into the treasury of Yahweh ")]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("(Josh 6:19, 24). In the second attempt to capture Ai, everything was slated to come under the ban except cattle and spoil, which could be taken as booty by the people (Josh 8:2, 27). In some wars, people failed to honor the ban and were judged with severity (Achan in Joshua 7; King Saul in 1 Samuel 15). When Canaanite peoples could not be driven out, they were subdued and put to forced labor (Josh 16:10; 17:13; Judg 1:27–35; 1 Kgs 9:20–21).")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The reason given in Deuteronomy for waging holy war was that if the former inhabitants were allowed to remain in the land, they and their abominable religious practices would become a snare to Israel (7:1–5, 16; 18:12; 20:16–18; cf. Exod 23:31–33; 34:11–16). Also, Yahweh was said to be punishing these nations for their wickedness (Deut 9:4).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Holy war ideology offends modern sensibilities, particularly when one reads in Deuteronomy that holy war with the ban was commanded by Yahweh. The offense came earlier. The command of Deuteronomy was mitigated already by the rabbis in their time, and so far as the Christian church is concerned, it is no stretch to say that this ideology goes ill with New Testament teaching. Even in the church’s doctrine of a just war, nations are only to go to war as a last resort. And, needless to say, the Jewish Holocaust of the twentieth century has been condemned by virtually everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The holy war teaching of Deuteronomy must nevertheless be understood in the context of what obtained generally among peoples of the ancient world. Israel was not the only nation that practiced the holy war ban on other nations. The term "), _c('em', [_c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("rm")]), _vm._v(" appears on the ninth-century Moabite Stone (line 17), where Mesha says he “devoted” seven thousand Israelite men, boys, women, girls, and maidservants to Ashtar-chemosh. Other parallels exist from the ancient world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Israelite practice must also be seen in larger perspective. The "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֵרֶם")]), _vm._v(" law, severe as it was, particularly with Israel emerging the victor and other peoples being exterminated, was carried out also by Israelites against their own people. When Achan defied the ban by taking devoted things for himself, he and everything belonging to him—sons, daughters, oxen, asses, and sheep—were destroyed (Josh 7:24–25). Deuteronomic law stated also that if an entire Israelite city falls victim to idolatry, it must be devoted to destruction (Deut 13:13–19[13:12–18]). And the day came when what remained of the Israelite nation fell under Yahweh’s holy war judgment for breach of covenant—which consisted largely—but not exclusively—of going after other gods and practicing idolatry. First northern Israel and then Judah were destroyed. And here it was the same Yahweh carrying out holy war! Jeremiah uses holy war terminology in announcing Yahweh’s judgment upon the nation (Jer 6:4–5; 22:7). In this holy war even beasts would be destroyed (Jer 7:20; 21:6; 36:29).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("We should note also with Moran (1963a) that Deuteronomy begins by reporting how Israel undertook an “unholy war,” going up to take Canaan after ")]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Yahweh told the people not to go up. The result was that they were roundly defeated (1:41–44).")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-36"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVINE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LESSING")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy puts great emphasis on blessing. Yahweh has blessed Israel in the past (1:11; 2:7; 23:6[23:5]) and promises blessing in the future (1:11; 12:7, 15; 14:24; 15:4, 6; 16:10), although the latter is said to be contingent upon charity to the poor and needy (14:29; 15:10, 14, 18; 16:17; 23:21[23:20]; 24:19) and obedience to the covenant demands (7:12–14; 11:26–32; 28:1–14; 30:1, 16, 19). The needy will bless his fellow Israelite for kindness that is shown (24:13). Yahweh’s blessing is to be sought (26:15), but Israel is expected to bless Yahweh’s name for the land it is to receive (8:10; 10:8; 16:15; 21:5). Israel is to receive Yahweh’s blessing in the covenant renewal ceremony at Shechem (27:12), although no blessings are stated, only curses for sins done in secret (27:9–26). Deuteronomy states climactically that covenant obedience will bring blessing in the land of Canaan; disobedience will bring the opposite, viz., a host of terrible curses (ch. 28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy, taken as a whole, has considerably more to say about blessing than about curses, making its preaching positive in the main. Fohrer (1968, 177) says:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Unlike the prophetic tradition, however, which generally took quite a negative view of Israel’s prospects for the future, Deuteronomic theology seeks to deliver the people as a whole from the threatened judgment of destruction, without in any way detracting from the seriousness of the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Only in the Song of Moses and its attendant prose (chs. 31–32) does the upbeat message of Deuteronomy give way to ominous predictions about Israel’s future. But even then, the book concludes with Moses pronouncing a blessing on the twelve tribes of Israel (ch. 33).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Divine blessing in Deuteronomy develops largely out of Genesis, where it is rooted in traditions about Abraham. It is not carried over from the Covenant Code or indeed from any other material in Exodus, where the one reference to divine blessing occurs in the explanation of the fourth commandment. There, repeating Genesis, it says that Yahweh blessed the Sabbath (Exod 20:11; cf. Gen 2:3). In Priestly material, too, the blessing theme is largely nonexistent, occurring only in the Aaronic benediction (Num 6:22–27) and in blessings spoken by the non-Israelite seer Balaam son of Beor (Numbers 22–24).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Divine blessing originates in Genesis, where it comes at creation and is then imparted to select individuals, first to Noah (Gen 9:1), then to Abraham ")]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("and his descendants. At creation, God’s blessing rests upon sea creatures and birds (Gen 1:22), then on humans, male and female (Gen 1:28; 5:2). To be blessed here is to be fruitful and multiply and with man and woman to subdue the earth. To the patriarchs, Abraham, Isaac, Jacob, and also Joseph, blessing means multiplication, gaining wealth, receiving a promise of land, and being a blessing to all people on earth (Gen 12:1–3; 18:18; 22:17–18; 26:3–5, 24; 28:3–4, 13–14, etc.). Genesis anticipates Deuteronomy in promising blessing to Abraham, the reason being that he obeyed Yahweh’s voice and kept his commands (Gen 22:15–18; 26:5). Blessing in Genesis is otherwise a pure act of divine grace.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In Deuteronomy, divine blessing means that Israel will multiply exceedingly, rule over other nations (15:6), and reap abundant crops in the land Yahweh is giving it. Moses tells Israel that it is already a multitude and can expect more increase in the future (1:10–11). Israel was blessed on the wilderness trek (2:7), and now in Moab stands ready to possess the land promised to the fathers. Because even more wealth will obtain after settlement in the land, all of which will be a mark of Yahweh’s blessing (12:7, 15; 14:24; 15:4, 13–14), the nation will owe to Yahweh a return blessing (8:10; cf. 21:5; Gen 14:18–20), be under obligation to present offerings to Yahweh (Deut 16:10, 16–17), and act graciously toward the less fortunates in society. These, above all, are the sojourner, orphan, widow, and pensioned Levite, who will be invited to share in the yearly feasts at the central sanctuary (16:13–15), who will receive their portion of the third-year tithe in the cities and towns where they live (14:28–29), and who will have the privilege of gleaning fields after the crops have been harvested (24:19). Benevolence must also be extended to others who are poor and needy. Hebrew slaves are to be released after six years (15:18); fellow-Israelites in need of interest-free loans are to be given them (23:21[23:20]), and the same is to be extended to the poor in general, who may have no chance of repayment and will not grow fat in the land (15:10). Yahweh will compensate the generous lender for any loss he might incur. All these benevolent acts prescribed in Deuteronomy are to issue forth because of the blessings Israel has received at the hand of Yahweh.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-37"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVENANT")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BLIGATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Because the Horeb covenant is conditional and requires obedience on Israel’s part, there are obligations Israel must fulfill. Freedman (1964) calls this covenant, which has its closest parallel in international treaties of the ANE, a covenant of “human obligation.”")])]), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Doing the Commandments")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("This is perhaps the most oft-repeated admonition in the book, that Israel be sure to do the commandments, where the commandments consist first and foremost of the Ten Commandments and, following them, the commandments, statutes, and ordinances of the Deuteronomic Code. Heading the list are commandments one and two of the Horeb covenant: No other gods and no idols, which get attention throughout the book but receive particular emphasis in the sermons of chapters 6–11. Interior dispositions—loving, clinging to, and fearing Yahweh—also walking in Yahweh’s way, serving Yahweh, and expressing gratitude to Yahweh show themselves, according to Deuteronomy, in doing the commandments (4:10; 5:32–33; 6:1–2, 4–9; 10:12–13; 11:1, 18–20).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_vm._v("Love to Yahweh and to Others")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Israel is to love Yahweh, which is a fitting and proper response to the love Yahweh has shown Israel (7:9). Included here is “clinging to Yahweh,” which means loving him (10:20; 11:22; 13:5[13:4]; 30:20). The Shema says: “And you shall love Yahweh your God with all your heart and with all your soul and with all your might” (6:5), pointing up one of the most important features of love in Deuteronomy and throughout the Bible, i.e., that this is a love which can be commanded (10:12; 11:1). It has the same force as the love demanded of vassal kings by suzerain kings in the ANE treaties (Moran 1963b). It goes hand in hand with obeying the covenant, the terms of which lie in the commandments (7:9; 11:13, 22; 19:9; 30:16, 20; cf. John 15:10). Yahweh, in fact, tests Israel by allowing prophets and dreamers initial success when their end game is to lead people in the way of other gods, to see if they really love him (13:4[13:3]). When the curses come upon Israel for disobeying the covenant, Deuteronomy says that Yahweh will open the people’s heart so they can once again love him, and live (30:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the teaching to “love your neighbor as yourself,” which looms so large in the NT (Matt 22:39; John 13:34–35; Gal 5:14; Rom 13:8–9, etc.), comes not from Deuteronomy but from Lev 19:18, it is still the case that Deuteronomy teaches love toward other people. Besides its benevolence program toward the poor and needy, which is certainly an expression of love towards them, Israel is told explicitly to love the sojourner. Why? Because Yahweh loves the sojourner, but also because Israel is to remember that it, too, was once a sojourner in the land of Egypt (Deut 10:19).")])]), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Fear of Yahweh")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy contains much teaching on the “fear of Yahweh,” where “fear” does not carry with it the debilitating effects so common in much of ancient religion, but denotes rather the interior dispositions of “awe” and “reverence.” The verb “to fear” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ירא")]), _vm._v(") in the OT does have both positive and negative meaning. It can simply mean “be afraid of,” where, for example, Yahweh or his divine messenger so often tells individuals to “fear not!” (Gen 15:1; 21:17, etc.) or where in Deuteronomy Moses tells Israel not to fear the enemy (1:21, 29; 3:2, 22). The fear Yahweh puts in the opposition when carrying on holy war is also this type of fear (2:25; 11:25). But when people are told to “fear” Yahweh it means they are to “stand in reverent awe of” Yahweh, not to dread arbitrary and capricious divine action, such as people typically do in other religions ancient and modern.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Deuteronomy fearing Yahweh goes hand in hand with loving and serving him, swearing by his name, and walking in his way (6:13; 8:6; 10:12, 20; 13:5[13:4]), all of which translates into not going after other gods (6:13–14) and doing Yahweh’s commandments. Fear of Yahweh can be taught (4:10; 5:29; 6:1–2, 24; 8:6; 10:12–13; 13:5[13:4]; 14:23 [in tithing]; 28:58; 31:12–13), for which reason Deuteronomy teaches that children are to learn to fear Yahweh. They will learn this if they are instructed in the commandments. Fear of Yahweh, says Deuteronomy, should be present always, i.e., throughout life or as long as Israel lives in the land. Eating the yearly tithe at the central sanctuary is one way of Israel learning to fear Yahweh (14:23). Israel’s king is to read the Deuteronomic law all his days, so he may learn to fear Yahweh and do Yahweh’s commands (17:19). Even the sojourner is to hear Yahweh’s law, learn to fear him, and do his commands (31:12). Moses tells the people that if they do not “fear this glorious and awesome name” of Yahweh, they will suffer great sickness and suffering (28:58–59). But in the eternal covenant announced later by Jeremiah after the curses have fallen, Yahweh promises that he will put the fear of himself in the hearts of people, so they will not turn from him (Jer 32:38–40).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_vm._v("Walking in Yahweh’s Way")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("“Walking in Yahweh’s way” has broad application in Deuteronomy, just as it does elsewhere in the OT, referring to the whole of life for individuals and for the Israelite nation. It includes the interior dispositions of love and fear, also one’s conduct, which in Deuteronomy is measured in terms of doing the commandments (8:6; 10:12; 11:22; 13:5[13:4]; 19:9; 26:17; 28:9; 30:16). One walks in Yahweh’s way so that one may live, that it may go well with one, and that one’s days may be prolonged in the land. No turning aside to the right or to left (5:32–33), ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("which means not walking after other gods Israel has not known (11:28; 13:6[13:5]). Going after other gods and the idols of neighboring peoples is to “walk in the stubbornness of one’s heart” (29:15–18[29:16–19]). Moses admonishes people to keep the commandments ever before them, speaking about them when they sit in the house and when they walk in the way (6:7; 11:19).")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-5"
    }
  }, [_vm._v("Serving Yahweh")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Israel is also under obligation to “serve Yahweh,” where “serve” too has broad meaning but often means simply “worship” (so Targums). As commandments one and two make clear, people are not to serve/worship other gods—also the heavenly bodies—or bow down before idols (4:19; 5:8–9; 6:13–14; 8:19; 11:16; 17:3–5; 30:17; 31:20); if they do these things, they will perish. Worship of heavenly bodies has been allotted to other peoples (4:19), but not to Israel (29:25[29:26]. Some individuals will go after other gods and want to lead fellow Israelites to do the same (13:3, 7, 14[13:2, 6, 13]; 17:3–5; 29:17, 25[29:18, 26]), but these are to be wholly resisted. Such individuals must be put to death. If people do make gods of wood and stone, Yahweh says he will scatter them among nations where they can serve these lifeless wonders (4:28; 28:36, 64). People are expected to serve Yahweh with gladness and goodness of heart; if they do not, they will end up having to serve their enemies in great privation (28:47–48). Yahweh’s holy war ban is carried out so that Israel will not turn to serving the Canaanite gods (7:16). Canaanite worship places are to be destroyed for the same reason (12:2). Even after these sanctuaries are destroyed, Israel is warned not to revert to serving gods that were once worshipped there (12:30). Marriages with the Canaanites are to be disallowed, for then the Israelite son or daughter may end up turning from Yahweh to serve other gods (7:3–4). Serving Yahweh, like all the other interior dispositions and covenant obligations, means keeping the commandments (10:12–13, 20; 11:13; 13:5[13:4]).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-6"
    }
  }, [_vm._v("Gratitude to Yahweh")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Moses calls upon Israel to show gratitude for Yahweh’s liberation of the nation from Egyptian slavery, for the victory over Pharaoh’s army at the Red Sea, for Yahweh’s care in the wilderness (11:2–5), and for blessings received and to be received in the settlement—first in Transjordan, later in Canaan. Deuteronomy is repeatedly saying “Remember,” and “Do not forget.” Gratitude is an obligation, just like the other covenant obligations. The Song of Moses shows how ungrateful Israel was following the Transjordan settlement. Yahweh fed the people so they ")]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("became sated, and they thanked him by turning to other gods (32:13–18). Moses expects they will do the same in the future (31:20). Curses for disobeying the covenant anticipate the same, saying that this will result in Israel having to serve its enemies amidst great want (28:47–48). Ingratitude for the wonders of Egypt was shown when Israel first refused to go up and take the land (1:26–27, 30–33).")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Israel is to serve Yahweh in joy and gladness of heart for everything received at Yahweh’s hand, sharing its abundance with orphans, widows, sojourners, and pensioned Levites (12:7, 12, 18; 14:27; 16:11, 14–15; 26:11; 27:7). The firstfruits to be presented at the sanctuary are to be an expression of gratitude for Yahweh’s gift of the land and the abundant yield it has brought forth (26:9–10). At the three yearly feasts no male is to appear empty-handed before Yahweh (16:16–17), for that would be a sign of ingratitude. Benevolence to all who are poor and needy should proceed from the same glad and grateful heart. The person who gives grudgingly to the needy, says Deuteronomy, has evil in his heart (15:10).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-13"
    }
  }, [_vm._v("THE BOOK OF DEUTERONOMY")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The book of Deuteronomy is a collection of addresses by Moses to Israel in the plains of Moab, just before his death and before Israel is to cross the Jordan under Joshua and begin its conquest of Canaan. The speaker in Deuteronomy is Moses (1:1, 5; 5:1), not Yahweh, as in the Covenant Code (Exod 20:1). The first identifiable book of Deuteronomy is chapters 1–28, called here the First Edition. It specifies itself as the words of the covenant Moses brokered between Yahweh and Israel in the plains of Moab, to be distinguished from the covenant Moses brokered at Mount Horeb/Sinai (28:69[29:1]).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The First Edition was expanded at some point with two supplements: (1) chapters 29–30, which further exhorts Israel to keep the commandments and says Israel can do it; and (2) chapters 31–34, which adds two old poems, the Song of Moses (ch. 32) and the Blessing of Moses (ch. 33), and closes with a report of Moses’ death and burial.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-38"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DITION")]), _vm._v(" ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHS")]), _vm._v(". 1–28)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The First Edition of Deuteronomy is held together by an inclusio made from its concluding verse and the opening superscription:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1:1–5")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-jus"
  }, [_c('em', [_vm._v("These are the words")]), _vm._v(" that "), _c('em', [_vm._v("Moses")]), _vm._v(" spoke to "), _c('em', [_vm._v("all Israel")]), _vm._v(" beyond the Jordan … beyond the Jordan "), _c('em', [_vm._v("in the land of Moab")]), _vm._v(", Moses undertook to make plain "), _c('em', [_vm._v("this law")]), _vm._v(".…")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("28:69[29:1]")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-jus"
  }, [_c('em', [_vm._v("These are the words of the covenant")]), _vm._v(" that Yahweh commanded "), _c('em', [_vm._v("Moses")]), _vm._v(" to cut with "), _c('em', [_vm._v("the children of Israel in the land of Moab")]), _vm._v(", besides the covenant that he cut with them in Horeb.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("We do not know when this first book of Deuteronomy was written or when it was made public. It contains material that appears to have a northern Israel provenance. If it were written in the north, it would then, at the very latest, have been brought south after northern Israel’s fall to the Assyrians in 722. But it seems more probable that this First Edition was written in Judah. Again, one can only speculate as to when this might have been. It could be preaching of traveling princes and priests who, in a judicial reform during the reign of Jehoshaphat (873–849), went out to teach people the law (2 Chr 17:7–9). Or it could be a document associated with the reform of Hezekiah (712–701). Von Rad thought it was a post-701 document written by Levitical priests from the countryside who were put out of a job by the centralization of worship in Jerusalem. While many commentators continue to call Deuteronomy a seventh-century document, it was surely written long before the temple lawbook was found in 622 (see pp. 6–7, “The Josianic Reform”).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-7"
    }
  }, [_vm._v("Prologue (1–4)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Prologue to Deuteronomy (chs. 1–4) begins with a superscription in 1:1–5, after which Israel’s journey from Mount Horeb to Kadesh-barnea is recounted. The narrative does not begin with the Exodus or even with the encampment at Horeb, where the covenant was brokered and the Decalogue given. It begins with Israel’s departure from Horeb (1:6–7). Recollections of the revelation at Mount Horeb do come, however, in chapter 4. From Kadesh-barnea Israel launched its first attempt to enter Canaan, which was unsuccessful (ch. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The forty long years of wandering in the wilderness is not reported. The Deuteronomic writer only refers back to the wilderness experience in later sermons of chapters 8–10. After the failed attempt to enter Canaan, the narrative moves on to Israel’s march northward, and the people are told not to confront Edom, Moab, and Ammon, but rather to do battle with Sihon and Og, Amorite kings residing north of the Arnon. The battles are successful, and Moses settles Reuben, Gad, and the half-tribe of Manasseh in the newly won land (chs. 2–3). Israel is now encamped at Beth-peor in Moab (3:29). In the historical survey are also a few antiquarian notes (2:20–23; 3:9, 11, 13b–14).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("A sermonic discourse fills most of chapter 4, which begins with a variation of Deuteronomy’s signature introduction: “And now, O Israel” (4:1). Moses, speaking now in the valley opposite Beth-peor, begins by shifting from past to ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("present. He tells people that the law is life, also a mark of Israel’s wisdom (4:1–8). The core teaching (4:9–31) goes on to impress upon Israel that it must do the commandments and refrain from idolatry, which anticipates commandments one and two of the Decalogue. It also warns what will happen if his admonition is not heeded: destruction, scattering, repentance, and eventual return. Moses, returning now to the past, reminds the people how Yahweh spoke the Decalogue to them directly out of the fire, even before the written tablets were brought down from the mountain. Moses says in conclusion that the greatness of the statutes and ordinances is proved by Yahweh alone being God, that there is no other (4:32–40).")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Following this discourse, the Deuteronomic writer reports Moses’ allocation of three refuge cities in the Transjordan (4:41–43). The Prologue then concludes with a subscription in 4:44–49.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-8"
    }
  }, [_vm._v("The Covenant at Horeb (5–11)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moses in Deuteronomy is presenting a new law code, but before doing so he must repeat the Decalogue to those present in the assembly (5:1–21). This defining law, which lies at the heart of the Horeb covenant, was not just for the generation who heard the “ten words” out of the midst of the fire, but for the generation now assembled in Moab (5:2–5). Deuteronomy makes it clear that after the Decalogue was given to the people Yahweh added nothing more (5:22). To Moses alone Yahweh gave other commandments, statutes, and ordinances that will now be taught to the people (5:30–31). These make up the Deuteronomic Code that Moses is delivering in the plains of Moab.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The discourse in chapters 5–11 contains three sermons: (1) 5:1–6:3; (2) 6:4–8:20; and (3) 9:1–11:32. Each begins with “Hear, O Israel” (5:1; 6:4; 9:1). The sermons are not unified compositions, rather compilations of shorter discourses, and in chapters 9–11 they include, like the discourse in chapters 2–3, antiquarian notes. The first sermon presents the Decalogue and stresses its ongoing importance to the Moab assembly.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("The discourse following in chapters 6–11 stresses obedience to commandments one and two of the Decalogue: (1) no other gods besides Yahweh and (2) no idols. The second sermon (6:4–8:20) is introduced with the words of the Shema: “Hear, O Israel, Yahweh our God, Yahweh is one. And you shall love Yahweh your God with all your heart and with all your soul and with all your might” (6:4–5). A liturgical injunction follows, admonishing people to keep the commandments ever before them (6:6–9). Canaan is filled with cities Israel did not build and orchards it did not plant; therefore when Israel arrives in the land it must not forget Yahweh and go after other gods. It muat also not test Yahweh, ")]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("as it did at Massah in the wilderness (6:10–19). Yahweh was gracious to Israel in the exodus and now again shows himself to be a God of grace in his gift of the land. When children later inquire about the meaning of the commandments, parents are to relate this to them (6:20–25).")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In this second sermon, after Moses says that Yahweh will clear away the seven nations in Canaan and Israel wipes out all vestiges of their religion (7:1–5), an important teaching is given about Israel’s election as Yahweh’s holy people. The love Israel owes to Yahweh is to be a response to Yahweh’s love, for Yahweh’s choice of Israel as a holy people was not because Israel was larger than other peoples, because she was not. It was because Yahweh loved Israel and because Yahweh was fulfilling a promise to the fathers (7:6–8). Yahweh promises to keep his covenant and continue in this love, although much will hinge on Israel keeping the commandments (7:9–16). Once again, Yahweh promises to clear away these nations before Israel, little by little. Once the kings are subdued and their land is taken, the idols of their gods must be burned with fire (7:17–26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This sermon continues into chapter 8, with Moses telling the people that Yahweh humbled them in the wilderness in order to test them. They must therefore keep the commandments (8:1–6). Now Yahweh is bringing Israel into a good land, so good that it will eat and become sated. For this goodness Israel must bless Yahweh (8:7–10), not forget him by disobeying the commandments. Forgetting and remembering get the emphasis, as they do elsewhere in the book. Yahweh’s care in the wilderness—including the manna provided—is to be remembered (8:11–16). The bottom line is that Israel must not go after other gods and serve them; if it does, it will perish like the nations now being destroyed so Israel can possess their land (8:17–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The third sermon (9:1–11:32) contains another important teaching, this one about Yahweh’s gift of the land. Israel is not getting the land because of its own righteousness, rather because the nations now living there are wicked. Yahweh is also fulfilling an oath made to the fathers (9:1–5). Moses then proceeds to document how rebellious Israel has been—from the day it came out of Egypt, at Horeb, and in the wilderness (9:6–24). Were it not for Moses’ mediation at Horeb, Israel would have been destroyed (9:25–29). But the covenant was renewed and the Decalogue written on new tablets (10:1–5). The journey to the promised land could therefore continue (10:10–11). What now does Yahweh ask of Israel? Answer: that Israel fear him, walk in his ways, love him, and serve him heart and soul. All this translates into doing the commands (10:12–13). To Yahweh belong heaven and earth, and let Israel not forget that, for Yahweh has done great things (10:14–22).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("Other sermonic discourse follows, much of it on keeping the commandments. This is what loving Yahweh is about. Israel is to consider Yahweh’s discipline and greatness, in Egypt, at the Red Sea, and especially in the wilderness ")]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("(11:1–9). The promised land, unlike Egypt, will have abundant rainfall, but rain will hinge on keeping the commandments (11:10–17). The liturgical injunction on keeping the commandments then repeats (11:18–21). This third sermon closes with three brief exhortations on obedience and disobedience (11:22–32), the middle one telling of a blessing and curse ceremony to take place on Mount Gerizim and Mount Ebal (11:26–28). Israel has two choices: it can obey the covenant and be blessed or it can disobey and be cursed.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-9"
    }
  }, [_vm._v("The Deuteronomic Code (12–26)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Deuteronomic Code begins in chapter 12 and continues through to chapter 26. Chapter 12 is an introduction mandating worship at a single sanctuary, and chapter 26 contains rituals on the firstfruits and the third-year tithe. Together, chapters 12 and 26 frame the legal material in chapters 13–25. The narrative on covenant renewal at Shechem, with its curses on crimes carried out in secret (ch. 27), combines with the listing of blessings and curses relating to the Deuteronomic Code (ch. 28), which concludes the First Edition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 12, besides mandating a single sanctuary and stating what need or need not be offered there, introduces the forthcoming laws on tithes and offerings (vv. 5–14) and ritually clean and unclean eating (vv. 15–28). The laws themselves come in chapters 14–15, but in reverse order: (1) laws on clean and unclean foods (14:1–21) and (2) laws on tithes and offerings (14:22–15:23). Chapter 12 begins and ends with a solemn word about rooting out Canaan’s multiple worship sites and multiple gods (vv. 2–4, 29–31), a subject covered fully in chapter 13. So while chapter 12 quite intentionally begins the Deuteronomic Code, it introduces only the legal material in chapters 13–15.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Deuteronomic Code builds on the Decalogue and presents its laws so they will correlate sequentially—in some cases by extension or by association—with commandments of the Decalogue:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Decalogue")])])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Deuteronomic Code")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("I.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No other gods before Yahweh (5:7)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Go not after other gods (13:2–19[1–18])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("II.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No images of Yahweh (5:8–10)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("III.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No empty oaths in Yahweh’s name (5:11)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("IV.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Keep the Sabbath Day holy (5:12–15)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Clean and unclean foods for a holy people (14:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Tithes and offerings (14:22–15:23)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Keeping the annual feasts (16:1–17)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("V.")])])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Honor your father and your mother (5:16)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Judges, judgment, and miscellaneous prohibitions (16:18–17:13)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Concerning the king (17:14–20)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Concerning the Levitical priests (18:1–8)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Concerning the prophet (18:9–22)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("VI.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("You shall not murder (5:17)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Homicide and refuge cities (19:1–13)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Regarding false witnesses (19:15–21)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Rules of warfare (20:1–20)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Unsolved murder (21:1–9)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Regarding women war captives (21:10–14)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Regarding estate liquidation (21:15–17)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Death for rebellious sons (21:18–21)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Corpses hung for public display (21:22–23)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Restoration of lost property (22:1–3)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Help for fallen animals (22:4)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("No transvestism (22:5)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Taking eggs or young birds as food (22:6–7)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Roofs require parapets (22:8)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Regarding mixtures (22:9–12)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("VII.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("You shall not commit adultery (5:18)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Unchaste brides (22:13–21)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Sex with married woman (22:22)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Sex with betrothed woman (22:23–27)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Sex with unbetrothed woman (22:28–29)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Sex with a father’s wife (23:1[22:30])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("On purity and cleanliness (23:2–15[1–14])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Hospitality to runaway slaves (23:16–17[15–16])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("No cult prostitutes (23:18–19[17–18])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("VIII.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("You shall not steal (5:19)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No lending at interest (23:20–21[19–20])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Prompt payment of vows (23:22–24[21–23])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("No stealing of crops (23:25–26[24–25])")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("No return to first husband (24:1–4)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Pledge prohibitions (24:6)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("No stealing of persons (24:7)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("On fetching pledges (24:10–13)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Paying hired servants (24:14–15)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Pledges from the needy (24:17–18)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Gleanings for the needy (24:19–22)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("IX.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No false witness against neighbor (5:20)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Court decisions and punishment (25:1–3)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("X.")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("No coveting of neighbor’s property (5:21)")])]), _vm._v(" "), _c('td', {
    staticClass: "w45"
  }, [_c('p', {
    staticClass: "t-hangs1"
  }, [_vm._v("Levirate marriage (25:5–10)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Wives intervening in a fight (25:11–12)")]), _vm._v(" "), _c('p', {
    staticClass: "t-hangs"
  }, [_vm._v("Just weights and measures (25:13–16)")])])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("The opening legislation of the Deuteronoic Code forbidding Israel to go after other gods is more like a three-point sermon (13:2–19[13:1–18]. Yahweh gives ")]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("certain prophets and would-be prophets a brief day in the sun only to test people whether they really love Yahweh heart and soul (13:4[13:3]). The sermon does contain casuistic law, however, as it provides a sentence of death for individuals and even entire cities if they violate commandment one of the Decalogue.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Clean and unclean foods are listed in 14:1–21, the point here being that Israel is a people holy to Yahweh its God. Certain animals, waterfowl, and winged creatures may not be eaten. Various obligations are then enumerated in 14:22–15:23, those coming up each year, every three years, and every seven years. Included here are laws regarding tithes and offerings of agricultural produce and firstborns from one’s flocks and herds. Israelites are to be granted debt remission and slave remission every seven years, with particular emphasis put on care for the poor and needy and benevolences to the orphan, widow, sojourner, and Levite living in one’s town.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Israel’s three annual feasts, Passover (Unleavened Bread), Weeks (Pentecost), and Booths, are covered in 16:1–17, where it is said that every adult male is to journey to the central sanctuary. Other family members may come also, and no one is to appear empty-handed before Yahweh. Offerings are to be brought to the feasts. Orphans, widows, sojoiurners, and resident Levites are invited to join the pilgrimages to the central sanctuary and share in the gladness of the feast.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 16:18–18:22 are listed the four major officeholders who will govern national life once Israel is settled in the land: judges (16:18–20; 17:2–13), kings (17:14–20), priests (18:1–8), and prophets (18:9–22). Listed with the judges are subordinate officials, also priests who will assist judges in difficult cases. Preceding the legislation on the prophets is a catalog of Canaanite religious functionaries who are not to mediate between Yahweh and his covenant people (18:9–14). Three miscellaneous laws against abominable worship practices are interspersed in 16:21–17:1, which have no apparent relation to the discourse on the major officeholders.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Substantive laws and judicial matters, over which judges, city elders, and priests are to have jurisdiction, come in chapters 19–25, in which there is also less sermonizing than in chapters 13–18. Laws in chapters 19–22, with one exception, have no parallel in the Covenant Code. The exception is the first law dealing with accidental homicide (19:1–13), which is dealt with briefly in Exod 21:12–14. If someone unwittingly kills his fellow, he can escape to one of three refuge cities that will be set up in Canaan. Three cities of refuge were set up earlier in Transjordan (Deut 4:41–43). Individuals found to be actual murderers, however, will not be permitted to remain in these cities, but will be handed over to the avenger of blood, who will put them to death. Combined with this law is another stating that in all litigation—not just criminal cases—two or three witnesses are required for conviction. False witnesses are also dealt with. Punishment for them is to be carried out according to the talion principle (19:15–21). ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Interspersed between these two laws is another about not moving back the boundary marker of one’s fellow (19:14).")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In 20:1–21:14 are laws dealing with the institution of holy war. Deuteronomy is the only book in the Pentateuch to contain laws of this nature. The first law deals with mustering an army (20:1–9); conduct of war against enemies far and near (20:10–18); and respect for fruit trees when a city is being besieged (20:19–20). The second law deals with women war captives desired as wives (21:10–14). In between is a law on expiation for an unsolved murder (21:1–9). Priests and officials in charge of recruitment and deferrals are to give spirited speeches in mustering an army for battle. Deferrals in certain cases are permitted. When Israel is fighting a distant city it is first to offer peace, which, if accepted, will require the inhabitants of the city to submit to forced labor. If they refuse, war is to be fought. When Yahweh gives the victory, all surviving adult males of the enemy are to come under the holy war ban. Women, children, beasts, and goods can be taken as spoil. But in holy war against the Canaanites, everything is to come under the ban. The stated reason is that otherwise these people would teach Israel their abominable worship practices.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some captive women in distant wars will be desired as wives, and the law in 21:10–14 deals with this. Taking foreign women as wives is permitted, but there are subtle indications in the law that such marriages may be ill-advised. The young and presumably beautiful woman is to be brought to the man’s house, where she is to shave her head, pare her nails, discard her captive clothing, and mourn her mother and father for a month. She presumably has not been married, therefore she has no husband to mourn. At the end of a month, the Israelite man may cohabit with her. If it should happen that his war bride no longer delights him, he may send her away and she can then go wherever she wants. He may not sell her as a slave or oppress her in any other way, for he has dishonored her by marrying her and then casting her off.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In between these holy war laws is a law dealing with expiation for an unsolved murder (21:1–9). If a slain person turns up in a field outside of town and the slayer is not known, the city nearest the site must assume responsibility for the crime. A young heifer, which has not yet been worked, is to be slain near a water-filled wadi in an expiation rite presided over by the priest. Its shed blood will rid the city—and all Israel—from the bloodguilt brought about by the crime.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The law in 21:15–17 regulates liquidation of an estate when a man has two wives, one loved and one unloved, and both have borne him sons. The man may not give the double portion due the firstborn to the son of the loved wife if the son of the unloved wife is his actual firstborn. The firstborn is the firstfruits of his generative power, and the rights of the firstborn belong to him. This son gets a double portion of everything the man has.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("In 21:18–21 is law dealing with a stubborn and rebellious son. If a son continually ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("refuses to obey his mother and father and will not accept discipline, the parents are to bring him (forcibly) out to the city gate and state before the elders that he is a glutton and a drunkard. The men of the city will then stone the fellow to death, since he is a liability not only to his family but to the whole city. With his death evil will be removed from the city, and all Israel shall duly hear and fear.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("When criminals are put to death, their bodies are to be hung on a tree for public display (21:22–23). But this law states that the bodies must be taken down by evening and buried. Such persons are cursed of God, and the land must not be defiled by the extended display of a corpse.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Five brief laws end the collection expanding upon the sixth commandment, “You shall not murder” (22:1–8). They aim to preserve human and animal life, promote security and well-being in the community, and prohibit role switching between the sexes. The law in 22:1–3 deals with the restoration of lost property. One must not ignore the stray ox or ass of a fellow Israelite but make every effort to see that it is returned. It matters not if the owner lives far away or is unknown to the finder. The finder is to bring the animal home for safekeeping until the owner comes looking for it. The same applies to lost asses, garments, or any item one happens to find. The law in 22:4 deals with fallen animals. One must also give help to a fellow Israelite if his ox or ass has fallen along the way, helping the owner to raise the animal to its feet.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Transvestism will not be sanctioned in the land (22:5). No article worn or carried by a man is to be found on a woman, nor is a man to wear women’s clothes. Male-female role switching, found among other peoples, is an abomination in the eyes of Yahweh. People must also exercise control in taking birds as food (22:6–7). If one happens upon a mother bird with her nestlings or eggs, the nestlings and eggs may be taken, but not the mother bird; it is to be chased away. Finally, newly built houses must have parapets, i.e., low walls on all sides of the flat roof (22:8). This will prevent people from falling off, causing accidental death and bringing bloodguilt upon the house.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Miscellaneous laws on mixtures follow in 22:9–12. When a new vineyard is planted from seed, grapes may not be eaten for three years. In the fourth year they are to be consecrated to Yahweh. In the fifth year the owner can eat his grapes. He may therefore want to plant a second crop in the vineyard while waiting for the grapes to be deconsecrated, but this law prohibits him from doing so (22:9). If he did plant a second crop of wheat, barley, or other nonfruit, it would be consecrated along with the grapes, so he could not eat it until the fifth year. So two crops in a vineyard are disallowed. In vineyards five or more years old, this law will not apply.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("An ox and an ass may not be yoked together for plowing (22:10). This would be harmful for both animals, the stronger ox and the weaker ass. There must also be no mixed blends of wool and linen in one’s garments, which will preserve the ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("distinction in dress between priests and the laity (22:11). Only priests are permitted to wear clothes of linen and wool. The one exception is with the tassels on one’s garments, which may contain mixed threads of wool and linen (22:12).")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In 22:13–23:1(22:30) are six laws dealing with improper commerce between the sexes, expanding upon the seventh commandment, “You shall not commit adultery.” Their aim is to preserve chastity and marriage in Israel. With one exception, these laws do not appear in the Covenant Code. The exception is the law on sex with an unbetrothed girl, which appears in Exod 22:15–16(22:16–17). The law prohibiting sex with a father’s wife is repeated in Lev 18:8, where it appears with other laws against incest.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The law on unchaste brides (22:13–21) deals with a woman accused by her newlywed husband of not being a virgin on the night of their marriage. He will have gone public with his charge and is thus giving the woman a bad name. The mother and father of the bride are then to bring the bloodstained sleeping garment to the elders at the city gate, repeat the husband’s charge, and display the garment. Upon this evidence, the husband will be given a whipping, fined a hefty one hundred shekels of silver, and not allowed to divorce his wife in the future. If the garment cannot be produced, the woman will be presumed guilty and executed at the entrance to her father’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The law on sex with another married woman (22:22) is straightforward casuistic law on the seventh commandment forbidding adultery. If a man—married or single—has sex with a woman married to another man and they are found out, both are executed by stoning.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If a man—married or single—has sex with a betrothed girl in the city (22:23–24), the case is treated the same as an adultery case. A betrothed girl is one for whom the bride-price has been paid, so she is legally married, even though the ceremony has not occurred and her husband has not yet taken her. The act is presumed to be consensual, since it occurred in the city. If it had been rape, she would have cried out and someone would have heard her. Both man and woman are executed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If a man—married or single—has sex with a betrothed girl in the country (22:25–27), the girl is given the benefit of the doubt, because had she cried for help, no one would have heard her. The act here is presumed to be rape, even though it may not have been. Only the man is put to death. The girl is not punished.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If a single man has sex with an unbetrothed girl (22:28–29), i.e., premarital sex, the man must pay a fine of fifty shekels to the girl’s father and the two of them will be married. Here, again, the man will not be able to divorce his wife any time in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The final law in the group forbids a man from having sex with his father’s wife (23:1[22:30]). This would be a woman who is not the man’s mother and the father presumed to be dead.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("In 23:2–19(23:1–18) is a group of laws on purity and cleanliness. Purity must be preserved within Yahweh’s assembly, with certain persons, all presumably foreigners, excluded forever or for just two generations (23:2–9[23:1–8]). Blemished men, i.e., those with bruised or crushed testicles or those who have been castrated (eunuchs), are excluded. Individuals born of illicit unions are also forbidden entrance to Yahweh’s assembly, even to the tenth generation, i.e., forever (23:2–3[23:1–2]). Ammonites and Moabites are excluded forever (23:4–7[23:3–6]), the Ammonites because they refused hospitality to Israel in the wilderness and the Moabites because they hired Balaam to curse Israel. Edomites and Egyptians are excluded only for two generations (23:8–9[23:7–8]). Neither is considered an abomination, the Edomites because they are brothers to Israel and the Egyptians because Israel sojourned in Egypt in the time of Joseph. The third generation of these people may enter the assembly of Yahweh.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Purity and cleanliness must be preserved in the camp when holy war is being carried on (23:10–15[23:9–14]). If a man has a night accident, he is to go outside the camp until evening, at which time he can wash and return. There must also be a place outside the camp for relieving oneself. When going outside, each person is to carry a spike for digging a hole, and when he is finished he must not forget to cover up his excrement. Because Yahweh walks about in the camp, it must be kept holy. If Yahweh sees anything unseemly, he will turn away.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Connected by catchwords to the latter purity law are two other laws: one requiring hospitality to runaway slaves (23:16–17[23:15–16]) and another forbidding holy prostitutes in Israel (23:18–19[23:17–18]). Slaves escaping to Israel from foreign countries are to be given asylum; they are not to be surrendered to their masters. These individuals may live anywhere they choose and are to be treated like any other resident alien, not being oppressed. No female or male sacred prostitute, which was part of the Canaanite religious scene, is to be allowed in Israel. What is more, the hire of a whore or price of a dog is not to be brought into Yahweh’s sanctuary in payment of a vow. Dirty money is an abomination to Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three laws develop from the eighth commandment, “You shall not steal” (23:20–26[23:19–25]). Loans to fellow Israelites must be given interest-free (23:20–21[23:19–20]). These can be loans of silver, food, or anything at all, which will provide temporary relief for a brother who has fallen on hard times. Interest-free loans must be made even to a brother who is solvent. To a foreigner who will be in the land as a merchant or trader, one may loan at interest. Providing interest-free loans will bring a blessing from Yahweh on all of one’s undertakings.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("A law on the payment of vows follows in 23:22–24(23:21–23). When vows are made to Yahweh, they are not like loans which take time to repay, but must be paid promptly. A vow is a promise to Yahweh that one will carry out a certain act if Yahweh grants the petitioner’s request, which could be for the birth of a child, deliverance from sickness, enemies, or death, or some other life crisis. ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("Not paying a vow will be reckoned as sin. But since vows are voluntary, it is no sin to refrain from vowing. One simply has to pay a vow one has made and pay it promptly.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("When Israel becomes settled in the land and has vineyards and crop-bearing fields, it will be permissible when passing by another’s vineyard to pick grapes for eating or to pluck standing ears of grain from another’s field for eating. But one must not carry away grapes in a basket nor put a sickle to the standing grain of one’s fellow. That would be crop stealing (23:25–26[23:24–25]).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 24:1–25:4 is a collection of laws, which, for the most part, deal with humane treatment to individuals being punished or who have a precarious position in Israelite society due to poverty or some other misfortune. One law deals with humane treatment to a threshing ox (25:4). The law in 24:1–4 states that a divorced woman may not return to her first husband if she has contracted a second marriage. The first husband has found something indecent in her—not adultery, but indecent behavior of some sort—and he divorces her. She marries another man, but he also divorces her or he dies, at which point the woman may not return to her first husband. She has been rendered unclean to her first husband, and to remarry him would be an abomination to Yahweh. It would also bring guilt upon the land. This law seeks to preserve the second marriage. Because the woman has had two husbands, there is also the possibility of intrigue, and if the woman received an inheritance at the death of her second husband, the first husband could gain financially by taking her back. This would be unjust financial gain and may explain why the law follows other laws dealing with theft.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A law providing war deferment for a newlywed man is connected by catchwords to the law on divorce and remarriage (24:5). It states that for one year a newlywed man may be free from war and war-related obligations so he can attend to his wife and enjoy her. One year together will allow the marriage to be established and will also be enough time for a child to be born.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("Four laws following regulate the exacting of pledges, in between which is a warning about the danger of scale disease. In taking pledges for a loan, one may not take a hand-mill or an upper millstone, for that would amount to taking a life in pledge (24:6). There must also be no stealing of persons as pledges, with the creditor then lording it over the debtor or selling him or her to another as a slave (24:7). Anyone doing this will be put to death. Then comes the warning about scale disease (not leprosy), which has no apparent relation to the laws on pledges (24:8–9). Here one must do all that the Levitical priests say. Miriam’s punishment in the wilderness is called to remembrance. The third law on pledges states that a creditor coming to collect his pledge must not enter the debtor’s house to fetch it, but wait outside for the debtor to bring it to him (24:10–11). The fourth law states that under no circumstances is a creditor to sleep in a poor man’s pledge (24:12–13). He must return it to the debtor at sundown ")]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("so he can sleep on his garment. The poor man will then bless him, and it will be righteousness to the creditor before Yahweh.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Four more laws of a humane nature focus on justice, compassion, and benevolence to the poor and needy. The first law deals with hired laborers (24:14–15). They are to be paid their wages each day at sundown. They wait for them, and their needs are immediate. Employers failing to do this will cause the laborer to cry out to Yahweh, and it will be reckoned to the employer as sin. The second law (24:16) redefines the principle of retribution, stating that fathers shall not be put to death on account of their children and children shall not be put to death on account of their fathers. Each for his own sin shall die. The third law states that there must be no perversion of judgment to the needy, many of whom are without an advocate (24:17–18). Under no circumstances is a creditor to take the cloak of a widow in pledge. People are to remember that they were once slaves in Egypt and Yahweh ransomed them. The fourth law gives gleaning rights to sojourners, orphans, and widows (24:19–22). They are permitted to gather forgotten sheafs in the field, olives on the boughs or on the ground in the orchards, and grapes uncut in the vineyards. Yahweh will bless the owners, who again are told to remember that Israel was once a slave in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two more humane laws follow, one regarding a fellow who is to receive a beating, the other on an animal treading grain. If in a dispute brought to court, one man is acquitted as innocent and the other condemned as guilty and it is determined that the guilty deserves a beating commensurate with the offense committed, the man is to lie down and take his stripes in the presence of the judge. He may be given forty stripes, but no more, lest he be dishonored in the eyes of the people (25:1–3). An ox threshing grain is not to be muzzled (25:4). Working animals deserve to nibble from food that is continually before their eyes. This law appears only in Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The legal portion of the Deuteronomic Code concludes with three miscellaneous laws and a closing admonition to wipe out the remembrance of Amalek. The first law deals with the custom of the levirate marriage (25:5–10). If two brothers are living together on the family estate and the one dies without leaving a son, the wife of the deceased is not to marry outside the family. Her brother-in-law is to take her as a wife and have intercourse with her in the hope of raising up a son. The first son born to the woman will keep alive the name of the deceased and will gain the deceased’s share of the inheritance. The widow will also be provided for. Otherwise the surviving brother would get the entire inheritance. The levirate obligation, however, can be rejected. City elders will try to persuade the man to take his brother’s wife, but if he refuses, the wife will publicly shame him, taking off his sandal and spitting in his face. The man’s name will thus live on, but in infamy.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("The second law deals with a woman who interferes in a fight between her husband and another man, attempting to rescue him by grabbing hold of the other man’s testicles. Punishment for her is having her hand cut off, since the offense was committed with the hand (25:11–12). This is the only law in the OT explicitly calling for punishment by maiming.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The third law has to do with just weights and measures (25:13–16). Traders and merchants must not carry two weights in their bag, one great and one small. And when measuring grain, they must not have two ephahs, one great and one small. All stones must be full; all ephahs must be full. People must act honestly with one another if they want to live long in the land. Those who deal deceitfully are an abomination to Yahweh, for Yahweh loves justice and the practice of fair trade.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The legal portion of the code closes with an admonition to wipe out any remembrance of Amalek when people are settled in the land (25:17–19). On the way out of Egypt, the Amalekites showed no fear of God by cutting off stragglers at Israel’s rear—people unable to defend themselves. For this treachery, Amalek’s remembrance is to be wiped out.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Concluding the Deuteronomic Code are two rituals to be performed by each Israelite at the central sanctuary: (1) a ritual of the firstfruits (26:1–11) and (2) a ritual regarding the third-year charity tithe (26:12–15). Moses then closes with an admonition that Israel be sure to obey the statutes and ordinances Yahweh has commanded the people in the plains of Moab (26:16–19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the Feast of Weeks (Pentecost), when Israel is settled in the land, the worshipper is to bring his firstfruits in a basket, present them to the priest in office, and affirm with joy and thanksgiving that he is now settled in the land and has realized the land’s bounty. The priest will take the basket and set it next to the altar. The worshipper will then say his “A wandering Aramean was my father” confession. The basket is to be left with the priest, after which the worshipper is to host a feast for his family, servants, the Levite, and the sojourner, probably also the orphan and widow who are along.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the Feast of Booths the worshipper must attest to having distributed the third-year tithe designated for the Levite, sojourner, orphan, and widow residing in his town. The worshipper is to say before Yahweh that he has completely removed the sacred tithe from his house and given it to the recipients of charity. The worshipper then asks for a blessing from Yahweh’s heavenly sanctuary.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-3",
    attrs: {
      "id": "sec3-10"
    }
  }, [_vm._v("Blessings and Curses (27–28)")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("The First Edition of Deuteronomy (1–28) ends with blessings and curses. Chapter 27 is an interpolation into the First Edition, breaking continuity with the ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("conclusion to the Deuteronomic Code (ch. 26) and the blessings and curses relating to the Code (ch. 28). It is a fragmented report of a covenant renewal ceremony slated to be carried out at Shechem.")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Once the people have crossed the Jordan they are to set up large stones, coat them with lime, and write on them the Deuteronomic law (27:1–8). The writing is to be legible. These stones will give Israel entitlement to the land. They are to be erected at Mount Ebal, which looks down upon the city of Shechem. People are also to build an altar there for burnt offerings and peace offerings.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moses tells the people that on this day they have become Yahweh’s people (27:9–10). He told them this before, but it bears repeating. They must therefore do the commandments Moses has taught them. This sermonizing is similar to what appears in 26:16–19 and may be an earlier tie-in between the conclusion of the Deuteronomic Code and the blessings and curses of chapter 28.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The tribes are then instructed to ascend the mountains above Shechem, Mount Gerizim on the south and Mount Ebal on the north (27:11–13). Six will bless Israel from Mount Gerizim (Simeon, Levi, Judah, Issachar, Joseph, and Benjamin), and six will speak curses from Mount Ebal (Reuben, Gad, Asher, Zebulun, Dan, and Naphtali). Nothing more is said about the ceremony, and it is unclear whether the curses following were a part of this ceremony or some other ceremony at the same location. No blessings are given, which means that the narrative as it stands is incomplete.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What remains is a litany of twelve curses, each of which is to be recited in full voice by the Levites, to which the people are to respond with a loud “Amen” (27:14–26). The curses are on people engaged in clandestine acts prohibited by Israelite law. The first sin is against Yahweh, falling on people who set up idols in secret (v. 15). This violates the second commandment. Next come four curses on people committing social sins: (1) dishonoring father or mother (v. 16); (2) moving back a fellow’s boundary marker (v. 17); (3) misleading a blind person on the road (v. 18); and (4) perverting justice to the sojourner, orphan, and widow (v. 19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Four curses follow on men secretly engaging in illicit sexual commerce: (1) a man who has sex with the wife of his father, even if she is not his mother (v. 20); (2) a man who has sex with a beast (v. 21); (3) a man who has sex with his sister or half-sister (v. 22); and (4) a man who has sex with his mother-in-law (v. 23).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Two curses return to social crimes, both of which are criminal in nature: (1) on the person who strikes down—to severely wound or kill—another person in secret (v. 24); and (2) on the person who takes a bribe to strike down (= kill) another person, which predictably will occur in secret (v. 25). A final curse is on anyone who does not perform the words of this law by doing them ")]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("(v. 26), which is a crime against Yahweh. To all of these curses the people are to give their loud “Amen.”")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 28 contains blessings and curses on those obeying or disobeying the Deuteronomic covenant. The collection is a compilation, containing a core of balanced and tightly knit blessings and curses, to which have been added a Blessing Supplement and five Curse Supplements. The core collection may survive from the Shechem renewal ceremony described in chapter 27, which, as we said, is incomplete as it stands (27:11–13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Six blessings will come to people who obey the Deuteronomic covenant (28:1–6). They are general in nature, encompassing the whole of life. The six curses on those disobeying this covenant use the same words, except for the substitution of “cursed” in place of “blessed” (28:15–19). The center curses reverse the sequence of the center blessings, employing the same sort of variation found in the liturgical injunctions of 6:6–9 and 11:18–20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Blessing Supplement (28:7–14) expands upon the core blessings by promising Israel victory in battle, prosperity, dominance over enemies, and world respect. All will come to Israel if it keeps Yahweh’s commandments and walks in his ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Curse Supplement I (28:20–26) expands upon the core curses by promising Israel disease, famine, crop failure, battle panic, defeat by enemies, and ultimate ruin. All will come to Israel for its evil doings and because it has forsaken Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Curse Supplement II (28:27–37) announces incurable diseases; madness; oppression by enemies, with none to help; robbery of wives, sons and daughters, houses, vineyards, animals, and everything one owns; and for survivors, banishment to a distant place where they can serve gods of wood and stone. Yahweh will be the one leading his people away.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Curse Supplement III (28:38–46) speaks about crop failure, impoverishment, and dependent status; even the sojourner will rise above the lowliest Israelite. He will be the head; the Israelite will be the tail. The end will be Israel’s destruction because it did not heed the voice of Yahweh and keep the Deuteronomic covenant. Israel’s descendants will forever suffer because of this.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Curse Supplement IV (28:47–57) announces the terrible curses of the siege, where the conditional language of the previous curses gives way to language now that is absolute. Israel’s disobedience of the Deuteronomic covenant is an established fact, and what we are hearing is preaching like that emanating from the prophets. Israel will serve its enemies in hunger and thirst, in nakedness and in want of everything, and the enemy will put an iron yoke upon its neck. The siege will force the most delicate of men and women to do the most indelicate of things, eating their own children and not sharing this unholy food with dear wives, dear husbands, or the last living child.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Curse Supplement V (28:58–68) speaks again about disease, only now it is the diseases of Egypt, which Moses said would never again be visited upon Israel (7:15). Moses also said that Yahweh promised never again to return Israel to Egypt (17:16), but now this may happen (the language here is conditional: the curses depend on disobedience to the Deuteronomic law and not fearing Yahweh’s glorious and awesome name). Israelite men and women will offer themselves for sale as slaves, but no one will buy them. Dread and uncertainty will be unimaginable, with life hanging each day by a single thread. This supplement refers twice to Deuteronomy as a written book (28:58, 61), which must mean that the supplement is added later to the First Edition. The First Edition concludes with the subscription in 28:69(29:1).")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-39"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPPLEMENT")]), _vm._v(" ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHS")]), _vm._v(". 29–30)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("This supplement to the First Edition of Deuteronomy consists of two addresses—May be more than two—in which Moses calls for faithfulness to the covenant demands. It is said by some to be in the nature of a peroration. Moses begins by making the point that the covenant is something you do (29:1–8[29:2–9]). Israel has been witness to Yahweh’s mighty acts of the past, but they have not understood them until now. Israel must therefore be careful to do the words of the covenant, and in so doing it will prosper.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("People are then bid to enter into a sworn covenant with Yahweh, one that will be binding on them and future generations (29:9–28[29:10–29]). Warnings are given about the danger of idol worship, which Israel observed ever since it left Egypt, and the curses awaiting Israel if it succumbs to this poisonous and bitter fruit. But Moses ends this discourse on a positive note. While the secret things belong to Yahweh, the revealed things belong forever to Israel and its children, so they may do all the words of this law.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The discourse in chapter 30 follows up on the covenant renewal ceremony and its warnings about blessings and curses with a word about what will happen after the curses come to pass (30:1–10). This will not be the end. Restoration is promised after exile, at which time Israel will return to Yahweh and obey his commands. There will be numerical growth and prosperity. This discourse also concludes on a positive note. The word of Yahweh is not in heaven or across the sea; it is very near people, which means obeying Yahweh’s commands is something they can do (30:11–14). The nation can choose one of two ways: obedience to the sworn covenant, which is the road to life and good fortune, or disobedience to the sworn covenant, which is the road to misfortune and death (30:15–20). People are told to choose life, so they and their descendants may live.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-40"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPPLEMENT")]), _vm._v(" ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHS")]), _vm._v(". 31–34)")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("In a second and final supplement, the book of Deuteronomy is brought to completion. This supplement prepares for Moses’ death and adds two old poems, the Song of Moses (32:1–43) and the Blessing of Moses (33:1–29). The Song of Moses is the core of the supplement, in my view the temple lawbook found during Josiah’s reform in 622. The prose in this supplement reports (1) a directive to Moses to write down the Deuteronomic law and entrust it to the Levites and elders; (2) a warning to Israel about future disobedience and covenant infidelity; (3) the commissioning of Joshua as Moses’ successor; and (4) Moses’ death and burial.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The supplement begins by Yahweh telling Moses once again that he cannot cross the Jordan and that Joshua will succeed him as the people’s leader (31:1–6). Moses is advanced in age and no longer able to conduct holy war. He has reached the full number of his days. Yahweh will be with Israel in the conquest of Canaan, doing the same to the kings there as he did to the Amorite kings, Sihon and Og, in Transjordan. The conquest will succeed. People are told to be strong and bold and not to fear the enemy. Yahweh will go with them and will not abandon them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moses then summons Joshua to charge him before the people, telling him to be strong and bold as he leads Israel into the promised land (31:7–13). Then Moses is said to have written down the Deuteronomic law and entrusted it to the Levites and the elders. He instructed them that the law be read publicly every seven years at the Feast of Booths, at which time all Israel—men, women, small children, and even sojourners—were to be present.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the next segment of prose Yahweh speaks first to Moses, then to Joshua (31:14–23). Moses is first told to summon Joshua so Yahweh may com mssion him at the tent of meeting. The two of them go there, and Yahweh appears in a pillar of cloud at the door (31:14–15). But before the actual commissioning takes place, Yahweh instructs Moses to write a song that will witness against Israel’s disobedience and unfaithfulness after he dies (31:16–22). Then the commissioning of Joshua takes place, and a word is given him about being strong and bold in his mission (31:23).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The next segment tells how Moses, after he had written the Song, told the Levites to put it beside the ark of the covenant, over which they had jurisdiction (31:24–30). In the ark were the tablets of the Decalogue. The Levites were then told what Yahweh had said to Moses about Israel being rebellious in future days. Moses then calls for an assembly of tribal elders and officials, to which the same is announced. Evil will come upon Israel when it falls into idolatry. Then Moses recited the Song in its entirety to the assembly (v. 30).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("What follows is the Song itself, a masterful poetic composition that ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("served as a model for all subsequent prophetic preaching (32:1–43). The poem consists of eight well-structured stanzas in four pairs, metrically balanced, with an introduction and a conclusion. It is rich in rhetorical features: climactic and ballast lines, repeated words and particles in strategic collocations, chiasms, partial chiams, inclusios, rhetorical questions, and shifts in direct address. It is poetry of a very high order.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The Introduction (vv. 1–3) begins like a wisdom poem, calling on the heavens and the earth to hear the poet proclaim the name of Yahweh and the greatness of Israel’s God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 1 (vv. 4–9) acclaims Yahweh’s greatness, perfect in all his created works, just in all his ways, faithful to the covenant, and in whom no wrong can be found. Israel, by contrast, is a corrupt and perverse adversary, foolish to repay Yahweh in the way it has. In hoary antiquity, Yahweh Most High gave to the nations their inheritance, and Israel was singled out as his special portion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 2 (vv. 10–14) recalls Yahweh’s gift of salvation to Israel, finding her as he did in a desert wasteland, caring for her there, and leading her to a bountiful land having every good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 3 (vv. 15–18) goes on to say how Israel repaid the favor by becoming “fat and sassy.” She forsook Yahweh and stirred him to jealousy by chasing after “no gods,” gods that neither she nor her fathers had known.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 4 (vv. 19–22) says that Yahweh therefore passed sentence on Israel, stirring it to jealousy with a “no people.” A divine fire burned not to be quenched.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 5 (vv. 23–27) focuses on the extent of Israel’s punishment. It was great; nevertheless, Yahweh stopped short of destroying Israel completely, lest her enemies—and Yahweh’s too—think that the nation’s ruin was their doing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 6 (vv. 28–33) looks further at Israel’s punishment in retrospect. Yahweh is the one who sold Israel into the hands of its enemy. Israel’s Rock has nothing in common with their “rock.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 7 (vv. 34–38) shifts to punishment for the enemy and salvation for Israel. Vengeance belongs to Yahweh. The enemy’s foot will slip, and calamity will come. Israel will be vindicated when it sees that its support is gone. The poem therefore begins and ends with salvation; judgment comes in the middle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Stanza 8 (vv. 39–42) acclaims the infinite and incomparable power of Yahweh. Yahweh kills and Yahweh makes alive, Yahweh wounds and Yahweh heals. Yahweh will take vengeance on his adversaries, repaying all those who hate him.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("The Conclusion (v. 43) calls for the heavens (or the nations) to give ringing praise to Yahweh, for he avenges the blood of his servants and makes atonement for his people and his land. The LXX expands a four-colon MT verse to eight colons, with 4QDeut"), _c('sup', [_vm._v("q")]), _vm._v(" expanding it to six colons. The longer LXX version ")]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("makes the Conclusion comparable in length to the Introduction, which is eight colons.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The prose following the Song reports that Moses recited the poem to the people, Joshua being with him (32:44–47). He then exhorted the people to take these words to heart and to teach them to their children, so they might learn them and do Yahweh’s “law.” These were not empty words, but words of life, which would prolong Israel’s days in the land it would soon possess.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the next prose segment Moses is told to ascend Mount Nebo, view the land of Canaan, and die there (32:48–52). This addition appears to derive from the Priestly writer. Yahweh repeats that Moses and Aaron were unfaithful to him at the waters of Meribath-kadesh, not honoring him as holy in the midst of the people. Moses will therefore be permitted a look at the land across the Jordan, but he will not be able to enter there.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What follows is the Blessing of Moses (33:1–29), another poem of separate origin that aids in bringing closure to the book of Deuteronomy. It is particularly welcome after the Song of Moses, which contains a riveting indictment and judgment of Israel for breaking covenant with Yahweh. The Blessing brings a needed word of healing for the Israelite tribes as they prepare to cross the Jordan and enter Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Introduction to the Blessing (vv. 2–5) tells how Yahweh came from holy mountains in the southland, where he was surrounded with brilliant radiance and myriads of holy ones, leaving all this behind because of his love for people, specifically the tribes of Israel. Yahweh became King in Israel. Blessings are then given to each of Israel’s twelve tribes (vv. 6–25). Simeon is omitted, but its loss is compensated for by blessings on the two sons of Joseph: Ephraim and Manasseh. The conclusion (vv. 26–29) returns to address Israel as a whole. There is no God like the one Israel has known. He rides triumphantly through the heavens, yet comes to Israel’s aid in her time of need. This God is Israel’s refuge; underneath her are the everlasting arms. Israel is therefore to be happy. It is a nation like no other, knowing Yahweh’s salvation and gift of a bountiful land. Yahweh will be Israel’s sword and shield as she marches triumphantly against her enemies.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The supplement closes with a report of Moses’ final days in Moab, how he was given a look at the promised land from the top of Mount Nebo, and then died (34:1–12). Burial was in an unmarked grave in the valley opposite Bethpeor. No one knows just where. The narrator concludes by saying that no prophet has arisen like Moses, with whom Yahweh could speak “face to face.” No prophet could perform the signs and wonders Moses performed in Egypt, and no prophet could demonstrate the power Moses demonstrated before all Israel.")])]), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("DEUTERONOMY AND THE NEW TESTAMENT")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("Deuteronomy is one of four Old Testament books that writers of the New Testament cite most frequently; the others are Genesis, Isaiah, and the Psalms (see ")]), _c('span', {
    attrs: {
      "href": "#/021_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")]), _vm._v("). Citations and allusions occur in all four Gospels, Acts, the Pauline and Deutero-Pauline letters, Hebrews, James, the Johannine Epistles, and Revelation. Of all the OT books known to Matthew, the most influential seems to have been Deuteronomy—thirteen explicit quotations in his Gospel (Brodie 1992, 699). To the citations, near-citations, and allusions must be added other teachings in the NT that show a clear indebtedness to Deuteronomy, making the influence of this OT book upon writers of the NT considerably greater than a list of citations would indicate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Song of Moses is quoted in Acts (2:40); in Romans (10:19; 11:11; 12:19; 15:10) and other Pauline letters (1 Cor 10:20, 22; Phil 2:15); in Hebrews (10:30); and in Revelation (9:20; 15:3; 16:5; 18:20; 19:2). The expanded LXX text of 32:43 is quoted in Hebrews (1:6) and in Revelation (6:10; 18:20; 19:2).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-41"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YNOPTIC")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSPELS")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Synoptics report Jesus as upholding without exception all the Ten Commandments. Commandments one and two get support by quotations of the Shema, that God is one and is to be loved heart and soul (Mark 12:29–33; Matt 22:37; Luke 10:27). Jesus reflects Deuteronomy in warning about false prophets who show signs and wonders, but who lead people astray (Mark 13:22; Matt 24:24). Commandment three about no empty swearing is affirmed in the Sermon on the Mount (Matt 5:33–37). Commandment four on keeping the Sabbath is not cited directly, but is affirmed nevertheless in Jesus’ celebrated dictum: “The Sabbath was made for man, not man for the Sabbath” (Mark 2:27). Jesus’ disciples are said to have rested on the Sabbath (Luke 23:56; cf. Mark 16:1). Commandments five through nine are affirmed explicitly (Mark 7:10; 10:18–19; Matt 15:4; 19:18; Luke 18:20). Commandment ten about not coveting is affirmed indirectly by Jesus’ expansion of the adultery prohibition in his Sermon on the Mount (Matt 5:27–30).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus has Deuteronomy in mind during his forty days in the wilderness, where all three of his answers to the devil are quotes from Deuteronomy: (1) “man shall not live by bread alone, but by every word that proceeds from the mouth of God” (Matt 4:4; Luke 4:4); (2) “you shall not tempt/test the Lord your God” (Matt 4:7; Luke 4:12); and (3) “you shall worship the Lord your God, and him only shall you serve” (Matt 4:10; Luke 4:8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Matthew has Jesus quoting or alluding to Deuteronomy in his Sermon on "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("the Mount. In the sermon Jesus says that one must be “blameless before the Lord” (Matt 5:48). The "), _c('em', [_vm._v("lex talionis")]), _vm._v(", taught in Deuteronomy, is to be set aside in cases of insult (5:38). The law on divorce is also cited in the Sermon on the Mount (5:31), as well as elsewhere in the Gospels (Mark 10:4; Matt 19:7). Jesus and his opponents discuss the Deuteronomic law on the levirate marriage (Mark 12:19; Matt 22:24–25; Luke 20:28), and the Deuteronomic teaching about God gathering exiles from the “uttermost parts of heaven” is applied to the judgment at the end of time (Mark 13:27; Matt 24:31). Jesus’ teachings about benevolence to the poor, needy, and widowed (Mark 10:21; 12:40; Matt 19:21; 25:35–46; 26:11; Luke 20:47) are rooted in Deuteronomy’s laws of benevolence. Luke has a special concern for the poor (Luke 14:13, 21; 18:22; 19:8). Matthew’s teaching about settling disputes in church makes use of the Deuteronomic principle of having two or three witnesses (Matt 18:16).")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-42"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSPEL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN AND THE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHANNINE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PISTLES")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("While John in his Gospel and in the Epistles does not cite Deuteronomy directly, he fully understands Deuteronomy’s teaching about love: God’s love, the believer’s love for God, and love one for another. John knows that love is a command, that love among people should issue forth when God’s love has been shown to them (John 13:34; 15:12, 17; 1 John 4:11, 19, 21), and he grasps more fully than any other NT writer, except perhaps James, the tie-in between love and doing the commandments (John 15:10; 1 John 2:3–5; 5:2–3; 2 John 6). 1 John 2:6 contains the expression “walking in [God’s] way,” which is Deuteronomic. John knows the teaching of Deuteronomy that the commandments are not burdensome (1 John 5:3), and he gives explicit directives concerning benevolence to the poor and needy and to strangers (John 12:8; 1 John 3:17; 3 John 5).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-43"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CTS OF THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("POSTLES")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("In the Acts of the Apostles, Luke includes numerous references to Deuteronomy in the speeches of Peter, Stephen, and Paul. Peter, in a Jerusalem speech after Pentecost, cites the “prophet like Moses” promise as having been fulfilled in the Christ and points out that people must heed the prophetic word or be destroyed (3:22–23). In another speech before the Jewish high priest and the council, Peter says that God raised Jesus whom they killed by hanging on a tree (5:30). In speaking later to Cornelius, the Gentile, Peter cites the death of Jesus on a tree once again (10:39) and says he now realizes that God shows no partiality (10:34), which he gets from Deuteronomy. Stephen in his impassioned ")]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("speech uses language from Deuteronomy in recalling Abraham’s sojourn in a land that he would not himself inherit (7:5). He also cites Deuteronomy in saying that Israel went down to Egypt a mere seventy-five persons (7:14) and that God would raise up a “prophet like Moses” (7:37).")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul, in a speech delivered in Antioch, cites God’s care of Israel in the wilderness and his clearing away the Canaanites to give Israel an inheritance (13:18–19). Preaching at Lystra, he cites God’s giving of rain to past generations to show that God did not leave himself without witness, making use of another promise out of Deuteronomy (14:17). Luke himself shows concern for neglected widows (6:1), the same sort of compassion for the poor that characterizes his gospel.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-44"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AULINE AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUTERO")]), _vm._v("-P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AULINE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Paul is well versed in Deuteronomy. In Ephesians he quotes the fifth commandment about honoring parents, including the benefit of well-being and long life added by the Deuteronomic writer (Eph 6:2–3). Commandments six to eight are cited in Rom 13:9, where also commandment ten about not coveting is cited. The latter appears also in Rom 7:7, where Paul says that knowing the law has made him conscious of sin. Paul applies Deuteronomic teaching in telling the Corinthian church, where immorality has been reported to him, to remove the evil from its midst (1 Cor 5:13). In his Second Letter to the Corinthians, Paul reminds the fractious church that all charges must be supported by two or three witnesses (2 Cor 13:1). Paul knows the Song of Moses’ teaching about God being blameless amidst a crooked generation (Deut 32:4–5), telling people they should also be blameless amidst a generation no different (Phil 2:15). He knows the Deuteronomic verse about God showing no partiality (Gal 2:6; Rom 2:11). Paul cites Deuteronomc teaching that laborers deserve their wages in arguing that preachers of the gospel deserve their living by the gospel (1 Cor 9:3–14); he cites the law about not muzzling an ox when it is treading the grain (v. 9; cf. 1 Tim 5:18).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Deuteronomy serves Paul in his doctrinal teaching. In explaining his view that Christ has redeemed people from the curse of the law by becoming himself a curse, he cites the teaching of Deuteronomy that everyone not doing the law stands cursed by the law and then adds: “Cursed be every one who hangs on a tree” (Gal 3:10–13). Israel’s election as God’s chosen people is cited in Titus 2:14, but in Romans, Paul explains the hardening of the Jews by quoting the Deuteronomic verse about Israel not having the mind to understand, or eyes to see, or ears to hear the wonders of Egypt (Rom 11:7–8). Paul knows the Deuteronomic teaching about “the word of God being very near you” (Rom ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("10:6–8). In discussing communion, Paul says one cannot drink the cup of the Lord and at the same time drink the cup of demons (pagan sacrifices), citing the Song of Moses, where it says people sacrificed to demons and provoked Yahweh in doing so (1 Cor 10:14–22). Paul also has the Song of Moses in mind when he cites the passage about God making his people jealous with a “no people,” applying it to those who have not heeded the gospel (Rom 10:19; 11:11). Paul is concerned for the hungry and thirsty, even if they are one’s enemies (Rom 12:20). He takes up a collection for the poor (Rom 15:26) and is concerned about generosity generally (2 Corinthians 9). In 1 Timothy special concern is shown for widows who are real widows (1 Tim 5:3–16).")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-45"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PISTLE OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("James, in supporting his argument that the entire law must be followed, cites commandments six and seven as examples (Jas 2:11) and, to buttress his doctrine that faith and works are essentially one, cites the Shema that God is one (Jas 2:19). Here he finds strong support from Deuteronomy’s teaching that the interior dispositions of love and fear must go hand-in-hand with doing the commandments. James has concern for orphans, widows, the hungry, and illclad (1:27; 2:2–6, 15–16), censuring the rich for laying up treasures for themselves while they keep back wages of the poor that should be given them daily (5:4). He therefore tells people to be patient for the coming of the Lord, as the farmer waits patiently for the rain (5:7–8).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-46"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PISTLE TO THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBREWS")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The writer of Hebrews cites Deuteronomy when reflecting on sin and judgment, particularly on those who deliberately sin after receiving the truth (Heb 10:26–31). Such persons will die without supporting testimony from two or three witnesses. God has said: “Vengeance is mine, I will repay,” and the writer follows with words made famous by the fiery sermon of Jonathan Edwards: “It is a fearful thing to fall into the hands of the living God.” In his sermon on discipline, the writer warns about the “root bearing poison,” which jeopardizes peaceful relations among people (12:15). Believers stand before God like those present at Horeb on the day of assembly, who witnessed a blazing fire and heard a voice making them draw back in fright; even Moses trembled at the sight (12:18–21). Let the wise beware: “Our God is a consuming fire” (12:29). But the writer of Hebrews finds comfort in Deuteronomy’s teaching that God “will not forsake or abandon,” applying it to those who show hospitality to strangers and live honorably (13:1–5).")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-47"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVELATION OF")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AINT")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")])])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The writer of Revelation cites the Song of Moses, which begins by affirming that “all the ways [of God] are justice” (Rev 15:3; 16:5; 19:2). From the Song the writer also derives support in censuring all those who have worshipped “demons” (9:20). He gives ringing praise to a God who avenges the blood of his servants (6:10; 18:20; 19:2) and applies the Deuteronomic expression, “Lord of lords,” to the Lamb, i.e., Jesus (17:14; 19:16). Finally, Deuteronomy is recalled when it comes to laying down curses: a curse of sores for those worshipping an image of the beast (16:2) and a curse on anyone adding to or taking away from the book the author has written (22:18–19).")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Introduction#f1",
      "id": "f-1"
    }
  }, [_vm._v("*")]), _vm._v("A "), _c('em', [_vm._v("mezuzah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מְזוּזָה")]), _vm._v(") is a scroll affixed to doorposts ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מְזוּזֹת")]), _vm._v(") in a Jewish home (cf. 6:9; 11:20).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#f2",
      "id": "f-2"
    }
  }, [_vm._v("†")]), _vm._v("Phylacteries (Heb "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תְפִלּין")]), _vm._v(") are two black leather boxes containing Scripture passages that are bound by leather strips to the left hand and the head (cf. 6:8; 11:18).")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467439084',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(148)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(150);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 150 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.f395449d1be1bc3d2932.js